
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("aXtv3", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $f6fa4f4ced7abfee$export$2e2bcd8739ae039);
$parcel$export(module.exports, "RapidBoardWithSLA", () => $f6fa4f4ced7abfee$export$c4c56a250bf4e3c5);

var $eUqFw = parcelRequire("eUqFw");

var $eUGPU = parcelRequire("eUGPU");

var $9EHc8 = parcelRequire("9EHc8");

var $5GxEP = parcelRequire("5GxEP");

var $1ybV0 = parcelRequire("1ybV0");

var $10fdS = parcelRequire("10fdS");

var $51ACp = parcelRequire("51ACp");

var $gd0Sp = parcelRequire("gd0Sp");

var $jK1pm = parcelRequire("jK1pm");

var $lB25E = parcelRequire("lB25E");

var $igrdx = parcelRequire("igrdx");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f6fa4f4ced7abfee$export$2e2bcd8739ae039 = ()=>// @ts-expect-error - TS2739 - Type '{ children: (history: any) => Element; }' is missing the following properties from type 'RouteContext': location, query, route, match, action
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $51ACp.HistoryAdapter), null, (history)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f6fa4f4ced7abfee$export$c4c56a250bf4e3c5, {
            history: history
        }));
const $f6fa4f4ced7abfee$export$c4c56a250bf4e3c5 = ({ history: history })=>{
    const { appEditions: appEditions } = (0, $gd0Sp.useTenantContext)();
    const { name: name } = (0, $10fdS.useCurrentRoute)();
    const [rapidView = ''] = (0, $lB25E.useQueryParam)('rapidView');
    const [projectKey = ''] = (0, $lB25E.useQueryParam)('projectKey');
    const [chart = ''] = (0, $lB25E.useQueryParam)('chart');
    const experienceId = (0, $eUGPU.getExperienceId)(rapidView, projectKey, name, chart);
    const synthetic = (0, $1ybV0.ff)('jsw.pollinator.tenants');
    const additionalAttributes = (0, $eUqFw.useMemo)(()=>({
            synthetic: synthetic,
            isClassic: true,
            isSPA: true
        }), [
        synthetic
    ]);
    const experienceAttributes = (0, $eUqFw.useMemo)(()=>(0, $eUGPU.getExperienceAttributes)(name, appEditions.software, chart), [
        appEditions.software,
        chart,
        name
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "rapid-board-with-sla"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9EHc8.ViewExperienceTrackingProvider), {
        experienceId: experienceId,
        ...experienceAttributes,
        additionalAttributes: additionalAttributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
        id: "rapid-board",
        packageName: "jiraClassicBoardAndBacklog"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $igrdx.default), {
        history: history
    }))));
};

});
parcelRegister("eUGPU", function(module, exports) {

$parcel$export(module.exports, "isUserNetworkError", () => $7367fc58bb26b823$export$34bc86f6bf17f1e0);
$parcel$export(module.exports, "getExperienceId", () => $7367fc58bb26b823$export$ef9f7d5361bca87b);
$parcel$export(module.exports, "getStatusCode", () => $7367fc58bb26b823$export$68868794c9b58e55);
$parcel$export(module.exports, "getDataAttributes", () => $7367fc58bb26b823$export$e5ac556b1404ae1e);
$parcel$export(module.exports, "getFailedReason", () => $7367fc58bb26b823$export$18e1541d9ebd5731);
$parcel$export(module.exports, "getExperienceAttributes", () => $7367fc58bb26b823$export$590fb51cb481d9ae);
$parcel$export(module.exports, "isBoardSettings", () => $7367fc58bb26b823$export$14c18b73936afcc2);
$parcel$export(module.exports, "getErrorMessage", () => $7367fc58bb26b823$export$82f46aa4e6535a45);
$parcel$export(module.exports, "getDebugAttributes", () => $7367fc58bb26b823$export$af1f115af1bea29a);

var $exb0h = parcelRequire("exb0h");

var $eIp1n = parcelRequire("eIp1n");

var $crSCO = parcelRequire("crSCO");
const $7367fc58bb26b823$var$getReportExperienceName = (reportName)=>{
    if (reportName === undefined) return 'viewUnknownChart';
    return `view${reportName[0].toUpperCase() + reportName.substring(1)}`;
};
const $7367fc58bb26b823$export$34bc86f6bf17f1e0 = (errorName)=>errorName === 'TypeError' || errorName === 'AbortError' || errorName === 'ChunkLoadError';
const $7367fc58bb26b823$export$ef9f7d5361bca87b = (rapidView, projectKey, name, chart)=>{
    const key = `RapidBoardSPA_${projectKey || ''}_${rapidView}_`;
    if (name === (0, $exb0h.ROUTE_NAMES_RAPIDBOARD_BACKLOG) || name === (0, $exb0h.ROUTE_NAMES_RAPIDBOARD_USER_BACKLOG)) return `${key}_backlog`;
    if (name === (0, $exb0h.ROUTE_NAMES_RAPIDBOARD_BOARD) || name === (0, $exb0h.ROUTE_NAMES_RAPIDBOARD_USER_BOARD)) return `${key}_board`;
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly burndownChart: "sprintBurndown"; readonly burnupChart: "burnup"; readonly sprintRetrospective: "sprintReport"; readonly cumulativeFlowDiagram: "cumulativeFlowDiagram"; readonly velocityChart: "velocity"; readonly unknown: "unknown"; }'.
    return `${key}_${$7367fc58bb26b823$var$getReportExperienceName((0, $crSCO.REPORT_NAMES)[chart])}`;
};
const $7367fc58bb26b823$export$68868794c9b58e55 = (error)=>{
    if (error !== null && error !== undefined) {
        // @ts-expect-error - TS2339 - Property 'statusCode' does not exist on type 'SLAError'.
        const { statusCode: statusCode } = error || {};
        return statusCode === null || statusCode === undefined ? null : statusCode;
    }
    return null;
};
const $7367fc58bb26b823$export$e5ac556b1404ae1e = ()=>{
    const { GH: GH } = window;
    if (GH && GH.RapidViewConfig && GH.RapidBoard) {
        const rapidViewConfig = GH.RapidViewConfig.currentData.data;
        return {
            taskId: rapidViewConfig ? rapidViewConfig.id : -1,
            boardType: GH.RapidBoard.State.getBoardTypeForAnalytics()
        };
    }
    return null;
};
const $7367fc58bb26b823$export$18e1541d9ebd5731 = (error)=>{
    // Ideally error will never be null or undefined but need to check due to flow type of RouteResourceError
    if (error !== null && error !== undefined) {
        const statusCode = $7367fc58bb26b823$export$68868794c9b58e55(error); // Will return null or actual value
        return statusCode === null ? (0, $crSCO.REASON_BOARD_CRITICAL_DATA_FAILED) : (0, $crSCO.REASON_BOARD_CRITICAL_DATA_FAILED_WITH_STATUS_CODE);
    }
    return 0, $crSCO.REASON_BOARD_CRITICAL_DATA_FAILED;
};
const $7367fc58bb26b823$export$590fb51cb481d9ae = (name, edition, chart)=>{
    if (name === (0, $exb0h.ROUTE_NAMES_RAPIDBOARD_BACKLOG)) return {
        experience: 'viewBacklog',
        analyticsSource: 'backlog',
        edition: edition,
        application: (0, $eIp1n.JIRA_SOFTWARE)
    };
    if (name === (0, $exb0h.ROUTE_NAMES_RAPIDBOARD_BOARD)) return {
        experience: 'viewBoard',
        analyticsSource: 'board',
        edition: edition,
        application: (0, $eIp1n.JIRA_SOFTWARE)
    };
    return {
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly burndownChart: "sprintBurndown"; readonly burnupChart: "burnup"; readonly sprintRetrospective: "sprintReport"; readonly cumulativeFlowDiagram: "cumulativeFlowDiagram"; readonly velocityChart: "velocity"; readonly unknown: "unknown"; }'.
        experience: $7367fc58bb26b823$var$getReportExperienceName((0, $crSCO.REPORT_NAMES)[chart]),
        analyticsSource: 'board',
        edition: edition,
        application: (0, $eIp1n.JIRA_SOFTWARE)
    };
};
const $7367fc58bb26b823$export$14c18b73936afcc2 = (config)=>{
    if (config !== null && config !== undefined) return true;
    return false;
};
const $7367fc58bb26b823$export$82f46aa4e6535a45 = (failedReason, status)=>status === null ? `${failedReason}-unknown` : `${failedReason}-${status}`;
const $7367fc58bb26b823$export$af1f115af1bea29a = (mode, statusCode, error)=>({
        origin: mode,
        statusCode: statusCode === null ? 'unknown' : statusCode || 'unknown',
        userAgent: navigator ? navigator.userAgent : 'unknown',
        isSPA: true,
        windowErrors: error,
        href: window.location.href,
        referrer: document.referrer
    });
const $7367fc58bb26b823$export$c4f28f26fa94e5c2 = (error)=>{
    if (error !== null && error !== undefined) {
        const statusCode = $7367fc58bb26b823$export$68868794c9b58e55(error); // Will return null or actual value
        if (statusCode === null) return true;
        if (statusCode >= 400 && statusCode < 500) return false; // Should fire success sla
        if (statusCode >= 500) return true;
        return false;
    }
    return false;
};

});
parcelRegister("crSCO", function(module, exports) {

$parcel$export(module.exports, "REPORT_NAMES", () => $0cef6eca1a689c69$export$4a5d90f20a52884d);
$parcel$export(module.exports, "REASON_BOARD_CRITICAL_DATA_FAILED", () => $0cef6eca1a689c69$export$ca7951b3c8688166);
$parcel$export(module.exports, "REASON_BOARD_CRITICAL_DATA_FAILED_WITH_STATUS_CODE", () => $0cef6eca1a689c69$export$1a0ab76190c8276);
$parcel$export(module.exports, "UNKNOWN_STATUSCODE", () => $0cef6eca1a689c69$export$58851cb488bddad0);
// Code is duplicated here because at this point that legacy code has not been loaded in the first place
const $0cef6eca1a689c69$export$4a5d90f20a52884d = {
    burndownChart: 'sprintBurndown',
    burnupChart: 'burnup',
    sprintRetrospective: 'sprintReport',
    cumulativeFlowDiagram: 'cumulativeFlowDiagram',
    velocityChart: 'velocity',
    unknown: 'unknown'
};
const $0cef6eca1a689c69$export$ca7951b3c8688166 = 'board-critical-data-failed-unknown-reason';
const $0cef6eca1a689c69$export$1a0ab76190c8276 = 'board-critical-data-failed-with-status-code';
const $0cef6eca1a689c69$export$58851cb488bddad0 = '[unknown]';

});


parcelRegister("51ACp", function(module, exports) {

$parcel$export(module.exports, "HistoryAdapter", () => $7c9b058abf515682$export$d852f51b8427aefc);

var $eUqFw = parcelRequire("eUqFw");

var $lB25E = parcelRequire("lB25E");

var $dsNuc = parcelRequire("dsNuc");
// eslint-disable-next-line jira/react/no-class-components
class $7c9b058abf515682$var$HistoryAdapterComponent extends (0, $eUqFw.Component) {
    constructor(props){
        super(props);
        this.compatibleHistory = (0, $dsNuc.createReactRouterCompatibleHistory)(props.history);
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.children !== this.props.children;
    }
    componentWillUnmount() {
        this.compatibleHistory.destroy && this.compatibleHistory.destroy();
    }
    render() {
        const { children: children } = this.props;
        return children(this.compatibleHistory);
    }
}
const $7c9b058abf515682$export$d852f51b8427aefc = (0, $lB25E.withRouter)($7c9b058abf515682$var$HistoryAdapterComponent);

});
parcelRegister("dsNuc", function(module, exports) {

$parcel$export(module.exports, "createReactRouterCompatibleHistory", () => $03e13d3d865e0b52$export$2df73cd79c2401bf);

var $6l6Xk = parcelRequire("6l6Xk");
const $03e13d3d865e0b52$export$2df73cd79c2401bf = (history)=>{
    let cleaned = false;
    let listeners = [];
    // @ts-expect-error - TS2304 - Cannot find name 'HistoryAction'.
    const listen = (callback)=>{
        if (cleaned) // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ()=>{};
        const unsubscribe = (0, (/*@__PURE__*/$parcel$interopDefault($6l6Xk)))(history.listen(callback));
        const listener = {
            unsubscribe: unsubscribe
        };
        listeners.push(listener);
        return (0, (/*@__PURE__*/$parcel$interopDefault($6l6Xk)))(()=>{
            listener.unsubscribe();
        });
    };
    const cleanup = ()=>{
        listeners.forEach(({ unsubscribe: unsubscribe })=>{
            unsubscribe();
        });
        cleaned = true;
        listeners = [];
    };
    return {
        get length () {
            return history.length;
        },
        get location () {
            return history.location;
        },
        get action () {
            return history.action;
        },
        get index () {
            return history.index;
        },
        get entries () {
            return history.entries;
        },
        // @ts-expect-error - TS7006 - Parameter 'state' implicitly has an 'any' type.
        push: (path, state)=>history.push(path, state),
        // @ts-expect-error - TS7006 - Parameter 'state' implicitly has an 'any' type.
        replace: (path, state)=>history.replace(path, state),
        // @ts-expect-error - TS7006 - Parameter 'n' implicitly has an 'any' type.
        go: (n)=>history.go(n),
        goBack: ()=>history.goBack(),
        goForward: ()=>history.goForward(),
        // @ts-expect-error - TS7019 - Rest parameter 'args' implicitly has an 'any[]' type.
        createHref: (...args)=>history.createHref(...args),
        // Memory only
        // @ts-expect-error - TS7006 - Parameter 'n' implicitly has an 'any' type.
        canGo: (n)=>{
            if (history.canGo) return history.canGo(n);
            return true;
        },
        listen: listen,
        // @ts-expect-error - TS7006 - Parameter 'blocker' implicitly has an 'any' type.
        block: (blocker)=>history.block(blocker),
        destroy: cleanup
    };
};

});


parcelRegister("igrdx", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5a7433e2ee6f5ba$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
parcelRequire("kQSGw");

var $53ciZ = parcelRequire("53ciZ");

var $cYPRW = parcelRequire("cYPRW");

var $l8fTB = parcelRequire("l8fTB");

var $7rg47 = parcelRequire("7rg47");

var $3rlFA = parcelRequire("3rlFA");

var $9m00l = parcelRequire("9m00l");

var $fhupA = parcelRequire("fhupA");

var $d55eu = parcelRequire("d55eu");

var $6di80 = parcelRequire("6di80");

var $04x3f = parcelRequire("04x3f");

var $1FK6i = parcelRequire("1FK6i");

var $2xaXW = parcelRequire("2xaXW");

var $9xMnT = parcelRequire("9xMnT");

var $1CHhy = parcelRequire("1CHhy");

var $iK63v = parcelRequire("iK63v");

var $jT7aq = parcelRequire("jT7aq");

var $exb0h = parcelRequire("exb0h");

var $gVPP8 = parcelRequire("gVPP8");

var $8UjU2 = parcelRequire("8UjU2");

var $5GxEP = parcelRequire("5GxEP");

var $1ybV0 = parcelRequire("1ybV0");

var $10fdS = parcelRequire("10fdS");

var $3rugj = parcelRequire("3rugj");

var $cfJys = parcelRequire("cfJys");

var $fO5rB = parcelRequire("fO5rB");

var $lB25E = parcelRequire("lB25E");

var $bhy8H = parcelRequire("bhy8H");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a5a7433e2ee6f5ba$export$2e2bcd8739ae039 = ({ history: history })=>{
    const { isRapidBoardsReady: isRapidBoardsReady, mode: mode, isBentoEnabled: isBentoEnabled, shouldUserSeeBoard: shouldUserSeeBoard } = (0, $7rg47.useRapidBoard)(history);
    const contentLoadedStatus = (0, $cYPRW.useRapidBoardContentListener)();
    if ((0, $1ybV0.ff)('jsw.classic.board.api-calls.modern-frontend')) (0, $l8fTB.useRapidBoardDataLoader)();
    const isClassicReportsPage = (0, $bhy8H.useIsReportsPage)();
    const isRendered = contentLoadedStatus.ttr[mode] && isRapidBoardsReady;
    const isInteractive = contentLoadedStatus.tti[mode] && isRapidBoardsReady;
    const [modal] = (0, $lB25E.useQueryParam)('modal');
    const [selectedIssue] = (0, $lB25E.useQueryParam)('selectedIssue');
    const [view] = (0, $lB25E.useQueryParam)('view');
    const [config] = (0, $lB25E.useQueryParam)('config');
    const isConfigPage = typeof config === 'string' && config.length > 0;
    const [routerState, routerActions] = (0, $lB25E.useRouter)();
    const { name: name } = (0, $10fdS.useCurrentRoute)();
    (0, $eUqFw.useEffect)(()=>{
        if (!false) {
            const queryParams = (0, $53ciZ.parse)(routerState.location.search);
            const quickFilters = queryParams.quickFilter;
            const activeQuickFilters = (0, $3rugj.getActiveQuickFilters)(name);
            if (!quickFilters?.length && activeQuickFilters?.length) {
                queryParams.quickFilter = activeQuickFilters;
                routerActions.replace(`${routerState.location.pathname}?${(0, $53ciZ.stringify)(queryParams)}`);
            }
        }
    }, [
        routerState,
        routerActions,
        name
    ]);
    (0, $cfJys.useRapidBoardLongTasks)(name);
    if (isClassicReportsPage) (0, $8UjU2.asyncRunInitBridge)();
    const shouldIssueViewLoad = (0, $jT7aq.shouldIssueViewAppBeRendered)({
        modal: modal,
        selectedIssue: selectedIssue,
        view: view
    }) || isInteractive;
    const subProductAnalytic = name === (0, $exb0h.ROUTE_NAMES_SERVICEDESK_BOARDS) ? 'serviceDesk' : 'software';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, isRapidBoardsReady && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9m00l.DocumentTitle), null), !shouldUserSeeBoard && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
        to: "/jira/boards?showFlag=jsw.board-not-found"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fO5rB.SubProductUpdater), {
        subProduct: subProductAnalytic
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d55eu.PerformanceMarks), {
        isRendered: isRendered,
        isInteractive: isInteractive
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fhupA.NextGenRedirect), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1CHhy.RoadmapSettingRedirect), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6di80.PrettyUrlRedirect), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3rlFA.ArchivedProjectRedirect), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9xMnT.RapidboardContent), {
        isBentoEnabled: isBentoEnabled,
        isRapidBoardsReady: isRapidBoardsReady,
        mode: mode
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iK63v.SLATracker), null), shouldIssueViewLoad ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1FK6i.default), {
        shouldLoad: shouldIssueViewLoad
    }) : null, isInteractive ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $04x3f.RapidBoardApps), {
        shouldLoad: isInteractive
    }) : null, isConfigPage ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2xaXW.RapidBoardConfig), {
        shouldLoad: isConfigPage
    }) : null, isInteractive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
        packageName: "jiraDevelopmentDetailsLoader",
        id: "devDetailsDialogLoader",
        extraEventData: {
            teamName: 'fusion-isotopes'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gVPP8.DevDetailsDialogLoaderAsync), {
        scopeId: "software-board.board"
    })));
};

});
parcelRegister("cYPRW", function(module, exports) {

$parcel$export(module.exports, "useRapidBoardContentListener", () => $bdd4c45a50781c28$export$fa8a94d1c9579b89);
$parcel$export(module.exports, "useRapidBoardContentLoadListener", () => $bdd4c45a50781c28$export$6d02a4e7b983d16d);

var $eUqFw = parcelRequire("eUqFw");

var $lcJyp = parcelRequire("lcJyp");

var $3T07y = parcelRequire("3T07y");

var $g3DZb = parcelRequire("g3DZb");

var $anJ3c = parcelRequire("anJ3c");
const $bdd4c45a50781c28$export$fa8a94d1c9579b89 = ()=>{
    const [isFirstLoad, setIsFirstLoad] = (0, $eUqFw.useState)(true);
    const [contentLoadStatus, setHasContentLoaded] = (0, $eUqFw.useState)((0, $anJ3c.initialState));
    const [, { setAppReady: setAppReady }] = (0, $lcJyp.useSpaStateActions)();
    const { mode: mode, boardId: boardId, chartView: chartView } = (0, $g3DZb.useUrlState)();
    (0, $eUqFw.useEffect)(()=>{
        let ttrListener;
        if (isFirstLoad) {
            ttrListener = (0, $anJ3c.generateContentLoadingListener)(setHasContentLoaded);
            // @ts-expect-erro - TS2769 - No overload matches this call.
            window.addEventListener((0, $3T07y.GH_SPA_CONTENT_LOADING), ttrListener);
            setIsFirstLoad(false);
        }
        const ttiListener = (0, $anJ3c.generateContentDoneListener)(setHasContentLoaded, setAppReady);
        window.addEventListener((0, $3T07y.GH_SPA_CONTENT_READY), ttiListener);
        return ()=>{
            ttrListener && window.removeEventListener((0, $3T07y.GH_SPA_CONTENT_LOADING), ttrListener);
            window.removeEventListener((0, $3T07y.GH_SPA_CONTENT_READY), ttiListener);
        };
    }, [
        setAppReady,
        boardId,
        mode,
        chartView,
        isFirstLoad
    ]);
    return contentLoadStatus;
};
const $bdd4c45a50781c28$export$6d02a4e7b983d16d = ()=>{
    const [isAppContentLoaded, setIsAppContentLoaded] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useEffect)(()=>{
        const appLoadedListener = ()=>{
            !isAppContentLoaded && setIsAppContentLoaded(true);
        };
        window.addEventListener((0, $3T07y.GH_SPA_CONTENT_READY), appLoadedListener);
        return ()=>{
            window.removeEventListener((0, $3T07y.GH_SPA_CONTENT_READY), appLoadedListener);
        };
    }, [
        isAppContentLoaded
    ]);
    return [
        isAppContentLoaded,
        setIsAppContentLoaded
    ];
};

});
parcelRegister("3T07y", function(module, exports) {

$parcel$export(module.exports, "WORK", () => $e2b75d99eb6e548e$export$77d6f70978850641);
$parcel$export(module.exports, "PLAN", () => $e2b75d99eb6e548e$export$c303e491e026ebc6);
$parcel$export(module.exports, "INITIAL_DATA", () => $e2b75d99eb6e548e$export$b89e93f49fd2d1eb);
$parcel$export(module.exports, "CONFIG_DATA", () => $e2b75d99eb6e548e$export$5711a66d592b156a);
$parcel$export(module.exports, "REPORT", () => $e2b75d99eb6e548e$export$e3d31417f21c1ce7);
$parcel$export(module.exports, "SUCCESS", () => $e2b75d99eb6e548e$export$638cc6e36b2a737a);
$parcel$export(module.exports, "FAILURE", () => $e2b75d99eb6e548e$export$5b1e245d5eac107);
$parcel$export(module.exports, "ALL_DATA_PROMISE", () => $e2b75d99eb6e548e$export$79529b1d8f537dc7);
$parcel$export(module.exports, "GH_SPA_RESOURCES_READY", () => $e2b75d99eb6e548e$export$7d798b3d2b3dfe6e);
$parcel$export(module.exports, "GH_SPA_RB_READY", () => $e2b75d99eb6e548e$export$af91ef97c134b44c);
$parcel$export(module.exports, "GH_SPA_CONTENT_READY", () => $e2b75d99eb6e548e$export$f7f9968a603665fb);
$parcel$export(module.exports, "GH_SPA_CONTENT_LOADING", () => $e2b75d99eb6e548e$export$dbfa398ce856dd34);
$parcel$export(module.exports, "BENTO_ROOT", () => $e2b75d99eb6e548e$export$cd8e3f3a08b0ddda);
const $e2b75d99eb6e548e$export$77d6f70978850641 = 'work';
const $e2b75d99eb6e548e$export$c303e491e026ebc6 = 'plan';
const $e2b75d99eb6e548e$export$b89e93f49fd2d1eb = 'initial-data';
const $e2b75d99eb6e548e$export$5711a66d592b156a = 'config-data';
const $e2b75d99eb6e548e$export$e3d31417f21c1ce7 = 'report';
const $e2b75d99eb6e548e$export$638cc6e36b2a737a = 'success';
const $e2b75d99eb6e548e$export$5b1e245d5eac107 = 'failure';
const $e2b75d99eb6e548e$export$79529b1d8f537dc7 = 'all-data-promise';
const $e2b75d99eb6e548e$export$7d798b3d2b3dfe6e = 'GH_SPA_RESOURCES_READY';
const $e2b75d99eb6e548e$export$af91ef97c134b44c = 'GH_SPA_RB_READY';
const $e2b75d99eb6e548e$export$f7f9968a603665fb = 'GH_SPA_SPINNER_HIDE';
const $e2b75d99eb6e548e$export$dbfa398ce856dd34 = 'GH_SPA_SPINNER_SHOW';
const $e2b75d99eb6e548e$export$cd8e3f3a08b0ddda = 'ghx-issue-fragment';
const $e2b75d99eb6e548e$export$7ed3b6fb15486a80 = [
    // superbatch resources
    // SKATE HAS TO COME FIRST OR ELSE THE OTHER MODULES WILL FAIL
    'wrc!jira.webresources:skate',
    'wrc!jira.webresources:util-lite',
    'wrc!jira.webresources:util',
    'wrc!jira.webresources:feature-flags',
    'wrc!jira.webresources:dialogs',
    'wrc!jira.webresources:jira-global',
    'wrc!com.atlassian.auiplugin:aui-spinner',
    // analytics
    'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client',
    // dependencies from HeaderFooterRendering
    'wrc!jira.webresources:key-commands',
    'wrc!jira.webresources:header',
    // overrides for AUI, styles and bridge apis
    'wrc!com.atlassian.jira.jira-atlaskit-plugin:sidebar',
    'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-general',
    'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-dialogs',
    'wrc!com.atlassian.jira.jira-atlaskit-plugin:breadcrumbs',
    'wrc!com.atlassian.jira.jira-atlaskit-plugin:profilecard',
    'wrc!com.atlassian.jira.jira-atlaskit-plugin:ipblocklisting',
    'wrc!com.atlassian.jira.jira-atlaskit-plugin:async-modals',
    'wrc!jira.webresources:global-static',
    // browser metrics
    'wrc!com.atlassian.jira.plugins.jira-browser-metrics:contrib',
    'wrc!com.atlassian.plugins.browser.metrics.browser-metrics-plugin:impl',
    'wrc!com.atlassian.plugins.browser.metrics.browser-metrics-plugin:api',
    // old analytics library
    'wrc!com.atlassian.analytics.analytics-client:js-events'
];

});

parcelRegister("g3DZb", function(module, exports) {

$parcel$export(module.exports, "useUrlState", () => $f2d667e0135e1e51$export$6a582373474709af);

var $lB25E = parcelRequire("lB25E");

var $jDTMC = parcelRequire("jDTMC");
const $f2d667e0135e1e51$export$6a582373474709af = ()=>{
    const [{ query: query, route: route, match: match }] = (0, $lB25E.useRouter)();
    const { rapidView: rapidView, chart: chart, view: view, config: config, projectKey: queryProjectKey, locationless: locationless } = query;
    const { accountId: accountId } = match.params;
    const isBoardLocationless = !!locationless;
    const shouldUsePrettyUrlState = !isBoardLocationless;
    const mode = shouldUsePrettyUrlState ? (0, $jDTMC.getModeV2)(route) : (0, $jDTMC.getMode)(view);
    const boardId = shouldUsePrettyUrlState ? match.params.boardId : rapidView;
    const projectKey = shouldUsePrettyUrlState ? match.params.projectKey : queryProjectKey;
    const chartView = shouldUsePrettyUrlState ? (0, $jDTMC.toCamelCaseChartView)(match.params.chartView) : chart;
    return {
        accountId: accountId,
        mode: mode,
        boardId: boardId,
        chartView: chartView,
        projectKey: projectKey,
        routeName: route.name,
        config: config,
        isBoardLocationless: isBoardLocationless
    };
};

});
parcelRegister("jDTMC", function(module, exports) {

$parcel$export(module.exports, "toCamelCaseChartView", () => $18ce17f9861ad61a$export$f1cb745981250009);
$parcel$export(module.exports, "getMode", () => $18ce17f9861ad61a$export$1fc0f6205829e19c);
$parcel$export(module.exports, "getModeV2", () => $18ce17f9861ad61a$export$cc65f5a30b63da10);

var $jh2R9 = parcelRequire("jh2R9");

var $exb0h = parcelRequire("exb0h");

var $3T07y = parcelRequire("3T07y");
const $18ce17f9861ad61a$export$f1cb745981250009 = (chartView)=>(0, (/*@__PURE__*/$parcel$interopDefault($jh2R9)))(chartView);
const $18ce17f9861ad61a$export$1fc0f6205829e19c = (view)=>{
    switch(view){
        case 'planning':
        case 'planning.nodetail':
            return 0, $3T07y.PLAN;
        case 'reporting':
            return 0, $3T07y.REPORT;
        default:
            return 0, $3T07y.WORK;
    }
};
const $18ce17f9861ad61a$export$cc65f5a30b63da10 = (route)=>{
    if (!route) return 0, $3T07y.WORK;
    switch(route.name){
        case 0, $exb0h.ROUTE_NAMES_RAPIDBOARD_BACKLOG:
        case 0, $exb0h.ROUTE_NAMES_RAPIDBOARD_USER_BACKLOG:
            return 0, $3T07y.PLAN;
        case 0, $exb0h.ROUTE_NAMES_RAPIDBOARD_REPORT:
        case 0, $exb0h.ROUTE_NAMES_RAPIDBOARD_USER_REPORT:
            return 0, $3T07y.REPORT;
        default:
            return 0, $3T07y.WORK;
    }
};

});


parcelRegister("anJ3c", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $40f0a9f985f0e938$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "generateContentLoadingListener", () => $40f0a9f985f0e938$export$cc4e514b345931fd);
$parcel$export(module.exports, "generateContentDoneListener", () => $40f0a9f985f0e938$export$187951dcf58edfbe);

var $14fFu = parcelRequire("14fFu");

var $cprue = parcelRequire("cprue");

var $3T07y = parcelRequire("3T07y");
const $40f0a9f985f0e938$var$defaultState = {
    [(0, $3T07y.WORK)]: false,
    [(0, $3T07y.PLAN)]: false,
    [(0, $3T07y.REPORT)]: false
};
const $40f0a9f985f0e938$export$d4c72bab9d6cc13a = {
    ttr: {
        ...$40f0a9f985f0e938$var$defaultState
    },
    tti: {
        ...$40f0a9f985f0e938$var$defaultState
    }
};
const $40f0a9f985f0e938$export$cc4e514b345931fd = (setHasContentLoaded)=>function ttrListener(ev) {
        setHasContentLoaded({
            ttr: {
                ...$40f0a9f985f0e938$var$defaultState,
                // @ts-expect-error - A computed property name must be of type 'string', 'number', 'symbol', or 'any'.
                [ev.mode]: true
            },
            tti: {
                ...$40f0a9f985f0e938$var$defaultState
            }
        });
        window.removeEventListener((0, $3T07y.GH_SPA_CONTENT_LOADING), ttrListener);
    };
const $40f0a9f985f0e938$export$187951dcf58edfbe = (setHasContentLoaded, setAppReady)=>function ttiListener(ev) {
        setHasContentLoaded({
            ttr: {
                ...$40f0a9f985f0e938$var$defaultState
            },
            tti: {
                ...$40f0a9f985f0e938$var$defaultState,
                // @ts-expect-error - A computed property name must be of type 'string', 'number', 'symbol', or 'any'.
                [ev.mode]: true
            }
        });
        setAppReady();
        window.dispatchEvent((0, $14fFu.default)((0, $cprue.CLEAR_SEARCH_SESSION)));
        window.removeEventListener((0, $3T07y.GH_SPA_CONTENT_READY), ttiListener);
    };

});
parcelRegister("14fFu", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9be0b0302f41db4$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import/no-anonymous-default-export
var $c9be0b0302f41db4$export$2e2bcd8739ae039 = (eventType, eventConstructor = 'Event', bubbles = true, cancelable = true)=>{
    const event = document.createEvent(eventConstructor);
    event.initEvent(eventType, bubbles, cancelable);
    return event;
};

});



parcelRegister("l8fTB", function(module, exports) {

$parcel$export(module.exports, "useRapidBoardDataLoader", () => $9ab67b8bca31da3b$export$69547ed814592891);

var $eUqFw = parcelRequire("eUqFw");

var $6iz4v = parcelRequire("6iz4v");

var $1cNJ6 = parcelRequire("1cNJ6");

var $a5edq = parcelRequire("a5edq");

var $jT7aq = parcelRequire("jT7aq");

var $kQ5lq = parcelRequire("kQ5lq");

var $g3DZb = parcelRequire("g3DZb");

var $j5t61 = parcelRequire("j5t61");
const $9ab67b8bca31da3b$export$69547ed814592891 = ()=>{
    const { mode: mode } = (0, $g3DZb.useUrlState)();
    const { promise: promise, loading: loading, refresh: refresh, update: update } = (0, $kQ5lq.useRapidBoardResource)({
        resource: (0, $a5edq.getRapidBoardDataResource)(),
        retryPredicate: (0, $jT7aq.isAllDataErrorValid)
    });
    const [deferredPromise, setDeferredPromise] = (0, $eUqFw.useState)(null);
    const [initiateRefresh, setInitiateRefresh] = (0, $eUqFw.useState)(false);
    const onLoadData = (0, $eUqFw.useCallback)(({ isRefresh: isRefresh, mode: callerMode, deferred: deferred })=>{
        if (!deferred) return;
        setInitiateRefresh(mode === callerMode && isRefresh);
        setDeferredPromise({
            deferred: deferred,
            callerMode: callerMode
        });
        (0, $6iz4v.setMark)((0, $1cNJ6.getPrefixedMarkName)(`rapidboard_${mode}_data_requested`));
    }, [
        mode
    ]);
    const onUpdateData = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7006 - Parameter 'data' implicitly has an 'any' type.
    (data)=>{
        update((oldData)=>({
                // @ts-expect-error - TS2698 - Spread types may only be created from object types.
                ...oldData,
                data: new Promise(// eslint-disable-next-line @typescript-eslint/no-explicit-any
                (resolve)=>resolve(data))
            }));
    }, [
        update
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (initiateRefresh && !loading) refresh();
        if (initiateRefresh) setInitiateRefresh(false);
    }, [
        initiateRefresh,
        loading,
        refresh
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (deferredPromise === null || initiateRefresh && !loading) return;
        const { deferred: deferred, callerMode: callerMode } = deferredPromise;
        if (mode === callerMode) {
            // @ts-expect-error - TS2345 - Argument of type 'Promise<unknown> | null' is not assignable to parameter of type 'Promise<{ data: Promise<Record<any, any>>; } | null> | null'.
            (0, $j5t61.resolveDeferredWithPromise)(promise, deferred);
            setDeferredPromise(null);
            (0, $6iz4v.setMark)((0, $1cNJ6.getPrefixedMarkName)(`rapidboard_${mode}_data_resolved`));
        }
    }, [
        promise,
        deferredPromise,
        mode,
        initiateRefresh,
        loading
    ]);
    (0, $eUqFw.useEffect)(()=>{
        (0, $j5t61.setupRapidBoardDataLoader)(onLoadData, onUpdateData);
    }, [
        onLoadData,
        onUpdateData
    ]);
};

});
parcelRegister("jT7aq", function(module, exports) {

$parcel$export(module.exports, "isPlanningMode", () => $8542beb5d9f97e1e$export$2f3aae63e9b6fcd4);
$parcel$export(module.exports, "isWorkMode", () => $8542beb5d9f97e1e$export$a048503e6027751b);
$parcel$export(module.exports, "isAllDataErrorValid", () => $8542beb5d9f97e1e$export$f0e61c8225ce57eb);
$parcel$export(module.exports, "shouldIssueViewAppBeRendered", () => $8542beb5d9f97e1e$export$eff701308e2e1aa6);

var $6rW04 = parcelRequire("6rW04");

var $3T07y = parcelRequire("3T07y");
const $8542beb5d9f97e1e$export$2f3aae63e9b6fcd4 = (mode)=>mode === (0, $3T07y.PLAN);
const $8542beb5d9f97e1e$export$a048503e6027751b = (mode)=>mode === (0, $3T07y.WORK);
const $8542beb5d9f97e1e$export$f0e61c8225ce57eb = (error)=>// @ts-expect-error - TS2339 - Property 'statusCode' does not exist on type 'RouteResourceError'. | TS2339 - Property 'statusCode' does not exist on type 'RouteResourceError'. | TS2339 - Property 'statusCode' does not exist on type 'RouteResourceError'.
    !!(error && error.statusCode !== 400 && error.statusCode !== 404 && error.statusCode !== 500);
const $8542beb5d9f97e1e$export$eff701308e2e1aa6 = ({ modal: modal, selectedIssue: selectedIssue, view: view })=>{
    if (!false) {
        const isUserBentoEnabled = (0, $6rW04.default)('ghx-user-bento-enabled') === 'true';
        const isIssueViewOpen = (modal === 'detail' || view === 'detail' || view === 'planning') && selectedIssue;
        return isUserBentoEnabled && !!isIssueViewOpen;
    }
    return false;
};

});

parcelRegister("kQ5lq", function(module, exports) {

$parcel$export(module.exports, "useRapidBoardResource", () => $e25326556728e35b$export$8235e1f44255471f);

var $eUqFw = parcelRequire("eUqFw");

var $k8Qyf = parcelRequire("k8Qyf");

var $lB25E = parcelRequire("lB25E");

var $l3xWF = parcelRequire("l3xWF");
const $e25326556728e35b$var$ERROR_RETRY_LIMIT = 3;
const $e25326556728e35b$export$8235e1f44255471f = ({ resource: resource, shouldShowFlag: shouldShowFlag = true, retryPredicate: // eslint-disable-next-line @typescript-eslint/no-explicit-any
retryPredicate = (error)=>error && error.statusCode !== 404 })=>{
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const [retryNumber, setRetryNumber] = (0, $eUqFw.useState)(0);
    const { promise: promise, data: data, loading: loading, error: error, refresh: refresh, update: update, clear: clear, clearAll: clearAll } = (0, $lB25E.useResource)(resource);
    const flagId = (0, $eUqFw.useRef)(null);
    const shouldAttemptRefetch = !!(!loading && error && retryPredicate(error) && retryNumber < $e25326556728e35b$var$ERROR_RETRY_LIMIT);
    (0, $eUqFw.useEffect)(()=>{
        if (shouldAttemptRefetch) {
            refresh();
            setRetryNumber(retryNumber + 1);
        }
    }, [
        refresh,
        retryNumber,
        shouldAttemptRefetch
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (shouldShowFlag && !loading && retryNumber >= $e25326556728e35b$var$ERROR_RETRY_LIMIT && flagId.current === null) flagId.current = showFlag((0, $l3xWF.ErrorFlag)());
    }, [
        loading,
        retryNumber,
        shouldShowFlag,
        showFlag
    ]);
    return {
        promise: promise,
        data: data,
        loading: loading,
        error: error,
        hasFinishedRetrying: !shouldAttemptRefetch,
        update: // @ts-expect-error - TS2328 - Types of parameters 'getNewData' and 'getNewData' are incompatible.
        update,
        refresh: refresh,
        clear: clear,
        clearAll: clearAll
    };
};

});
parcelRegister("l3xWF", function(module, exports) {

$parcel$export(module.exports, "ErrorFlag", () => $ba2ebeca0a34c17f$export$518ba8e0e60f145f);

var $1MNES = parcelRequire("1MNES");
const $ba2ebeca0a34c17f$export$518ba8e0e60f145f = ()=>({
        type: 'error',
        title: (0, $1MNES.default).title,
        description: (0, $1MNES.default).description,
        isAutoDismiss: false
    });

});
parcelRegister("1MNES", function(module, exports) {

$parcel$export(module.exports, "default", () => $be420c64badaa7b2$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $be420c64badaa7b2$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    title: {
        "id": "classic-software.common.error-flag.title",
        "defaultMessage": "Oops! Something went wrong"
    },
    description: {
        "id": "classic-software.common.error-flag.description",
        "defaultMessage": "We cannot access this page at the moment. Please try again later."
    }
});

});



parcelRegister("j5t61", function(module, exports) {

$parcel$export(module.exports, "resolveDeferredWithPromise", () => $668a51eabb67dfdb$export$4fbe07c44244a10);
$parcel$export(module.exports, "setupRapidBoardDataLoader", () => $668a51eabb67dfdb$export$b04990c14596734);

var $3T07y = parcelRequire("3T07y");
const $668a51eabb67dfdb$export$4fbe07c44244a10 = async (promise, deferred)=>{
    if (!promise) {
        deferred.rejectWith(null);
        return;
    }
    try {
        const response = await promise;
        if (!response?.data) {
            deferred.rejectWith(null);
            return;
        }
        const data = await response.data;
        deferred.resolveWith(null, [
            data
        ]);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        const { GH: GH } = window;
        deferred.rejectWith(null, [
            GH.Ajax._convertFrameworkErrors(error),
            {
                status: error.statusCode
            }
        ]);
    }
};
const $668a51eabb67dfdb$export$b3bddb6595120042 = ()=>{
    const { AJS: AJS } = window;
    return AJS.$.Deferred();
};
const $668a51eabb67dfdb$var$generateRapidBoardReadyListener = (onLoadData, onUpdateData)=>()=>{
        const { GH: GH } = window;
        GH.RapidBoard.loadData = onLoadData;
        GH.RapidBoard.updateData = onUpdateData;
    };
const $668a51eabb67dfdb$export$b04990c14596734 = (onLoadData, // eslint-disable-next-line @typescript-eslint/no-explicit-any
onUpdateData)=>{
    const { GH: GH } = window;
    const setupRapidBoard = $668a51eabb67dfdb$var$generateRapidBoardReadyListener(onLoadData, onUpdateData);
    if (GH?.RapidBoard) setupRapidBoard();
    else {
        const listener = ()=>{
            window.removeEventListener((0, $3T07y.GH_SPA_RB_READY), listener);
            setupRapidBoard();
        };
        window.addEventListener((0, $3T07y.GH_SPA_RB_READY), listener);
    }
};
const $668a51eabb67dfdb$export$79f5fef719ded8cd = ()=>{
    const { GH: GH } = window;
    if (GH?.RapidBoard) {
        delete GH.RapidBoard.loadData;
        delete GH.RapidBoard.updateData;
    }
};

});


parcelRegister("7rg47", function(module, exports) {

$parcel$export(module.exports, "useRapidBoard", () => $f7019b0138f437e1$export$264220cfe099885c);

var $g3DZb = parcelRequire("g3DZb");

var $1cIj5 = parcelRequire("1cIj5");
const $f7019b0138f437e1$export$264220cfe099885c = false ? (_history)=>{
    const { mode: mode } = (0, $g3DZb.useUrlState)();
    return {
        isRapidBoardsReady: false,
        isBentoEnabled: false,
        mode: mode,
        shouldUserSeeBoard: true
    };
} : (0, $1cIj5.useRapidBoard);

});
parcelRegister("1cIj5", function(module, exports) {

$parcel$export(module.exports, "useRapidBoard", () => $ade266f10da6c14d$export$264220cfe099885c);

var $eUqFw = parcelRequire("eUqFw");

var $2BvS3 = parcelRequire("2BvS3");

var $exb0h = parcelRequire("exb0h");

var $1ybV0 = parcelRequire("1ybV0");

var $65uQX = parcelRequire("65uQX");

var $48mPv = parcelRequire("48mPv");

var $d7Wfe = parcelRequire("d7Wfe");

var $SEaoU = parcelRequire("SEaoU");

var $j5J5y = parcelRequire("j5J5y");

var $a5edq = parcelRequire("a5edq");

var $10v3r = parcelRequire("10v3r");

var $3T07y = parcelRequire("3T07y");

var $jT7aq = parcelRequire("jT7aq");

var $cYPRW = parcelRequire("cYPRW");

var $kQ5lq = parcelRequire("kQ5lq");

var $g3DZb = parcelRequire("g3DZb");

var $3syrf = parcelRequire("3syrf");

var $l4zPY = parcelRequire("l4zPY");

var $gbkeC = parcelRequire("gbkeC");

var $6U8he = parcelRequire("6U8he");

var $1HT5A = parcelRequire("1HT5A");
let $ade266f10da6c14d$var$resolveInstallAppsPromise;
const $ade266f10da6c14d$var$installAppsPromise = new Promise((resolve)=>{
    $ade266f10da6c14d$var$resolveInstallAppsPromise = resolve;
});

/**
 * We import from /entry because we cannot move the app install logic while rapidboard lives inside and outside the SPA
 */ (()=>{
    (parcelRequire("jAeda")).then((rapidBoardApps)=>{
        $ade266f10da6c14d$var$resolveInstallAppsPromise(rapidBoardApps);
    });
})();
const $ade266f10da6c14d$var$startApps = ()=>{
    $ade266f10da6c14d$var$installAppsPromise.then((rapidBoardApps)=>rapidBoardApps.startApps());
};
const $ade266f10da6c14d$var$useConfigResource = (boardId)=>{
    const { promise: promise, refresh: refresh, loading: loading, update: update, data: data } = (0, $kQ5lq.useRapidBoardResource)({
        resource: (0, $j5J5y.boardConfigApiResource),
        shouldShowFlag: false
    });
    const key = `rapidViewConfig-${boardId}`;
    return (0, $eUqFw.useMemo)(()=>({
            key: key,
            data: data,
            promise: promise,
            refresh: refresh,
            update: update,
            loading: loading
        }), [
        key,
        data,
        promise,
        refresh,
        update,
        loading
    ]);
};
// @ts-expect-error - TS7023 - 'scopeObject' implicitly has return type 'any' because it does not have a return type annotation and is referenced directly or indirectly in one of its return expressions.
function $ade266f10da6c14d$var$scopeObject(val) {
    if (typeof val !== 'object') return val;
    return $ade266f10da6c14d$var$scopeObject(Object.values(val)[0]);
}
function $ade266f10da6c14d$var$extractIssueData(key, // @ts-expect-error - TS7005 - Variable 'value' implicitly has an 'any' type.
value, issueVal) {
    const res = {
        ...issueVal
    };
    if (typeof value === 'string' || typeof value === 'number') {
        // @ts-expect-error - TS2339 - Property 'key' does not exist on type 'object'.
        res[key] = value;
        if (key === 'id' && typeof value === 'string') // @ts-expect-error - TS2339 - Property 'key' does not exist on type 'object'.
        res[key] = parseInt(value, 10);
        return res;
    }
    if (Array.isArray(value)) value.forEach((field)=>{
        const storeKey = field.id;
        const storeVal = $ade266f10da6c14d$var$scopeObject(field.fieldValue);
        // @ts-expect-error - TS2339 - Property 'storeKey' does not exist on type 'object'.
        res[storeKey] = storeVal;
        // @ts-expect-error - TS2339 - Property 'key' does not exist on type 'object'.
        if (storeKey === 'issuekey') res.key = storeVal;
    });
    return res;
}
function $ade266f10da6c14d$var$decorateResponse(matchAPIIssueResponse) {
    const issueResponse = {};
    Object.entries(matchAPIIssueResponse).forEach(([key, value])=>{
        const issueId = key;
        const issueData = value.issue;
        let issueVal = {};
        Object.entries(issueData).forEach(([issueDataKey, issueDataValue])=>{
            issueVal = $ade266f10da6c14d$var$extractIssueData(issueDataKey, issueDataValue, issueVal);
        });
        // @ts-expect-error - TS2339 - Property 'issueId' does not exist on type 'object'.
        issueResponse[issueId] = issueVal;
    });
    return issueResponse;
}
// TODO : Change this logic after JVIS fallback is introduced
function $ade266f10da6c14d$var$overwriteMatchData(searchData, matchData) {
    const result = searchData;
    Object.keys(result).forEach((key)=>{
        // @ts-expect-error - TS2339 - Property 'key' does not exist on type 'object'.
        if (typeof result[key] === 'object') // @ts-expect-error - TS2339 - Property 'key' does not exist on type 'object'.
        result[key] = $ade266f10da6c14d$var$overwriteMatchData(searchData[key], matchData);
        else if (Object.prototype.hasOwnProperty.call(matchData, key)) result[key] = matchData[key];
    });
    return result;
}
const $ade266f10da6c14d$export$179c0f1288f7b075 = ()=>{
    const [hasLayoutLoaded, setHasLayoutLoaded] = (0, $eUqFw.useState)(false);
    const { data: rapidboardData, loading: rapidboardResourceLoading } = (0, $kQ5lq.useRapidBoardResource)({
        resource: (0, $10v3r.rapidboardResource)
    });
    const [{ data: projectData }] = (0, $SEaoU.useContainerContext)();
    // @ts-expect-error - TS2571 - Object is of type 'unknown'.
    const isBentoOn = !!rapidboardData?.isNewIssueViewEnabled;
    const hasProjectDataLoaded = !!projectData;
    // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'. | TS2339 - Property 'project' does not exist on type 'ContainerContext'.
    const projectKey = projectData && projectData.project && projectData.project.key;
    // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'. | TS2339 - Property 'project' does not exist on type 'ContainerContext'.
    const projectId = projectData && projectData.project && projectData.project.id;
    (0, $eUqFw.useLayoutEffect)(()=>()=>{
            (0, $gbkeC.cleanupGH)(window, document)();
        }, []);
    (0, $eUqFw.useLayoutEffect)(()=>{
        let metaTags = [];
        let initalClassList = [
            'adg3'
        ];
        if (!rapidboardResourceLoading && hasProjectDataLoaded) {
            initalClassList = Array.from(document.body ? document.body.classList : []);
            metaTags = (0, $1HT5A.initDOM)(isBentoOn, projectKey, String(projectId));
            setHasLayoutLoaded(true);
        }
        return ()=>{
            setHasLayoutLoaded(false);
            (0, $1ybV0.ff)('jsw.classic.board.api-calls.modern-frontend') && (0, $gbkeC.cleanupResources)([
                (0, $3T07y.CONFIG_DATA)
            ]);
            (0, $gbkeC.cleanupDOM)(document)(initalClassList, metaTags, isBentoOn);
        };
    }, [
        rapidboardResourceLoading,
        hasProjectDataLoaded,
        isBentoOn,
        projectId,
        projectKey
    ]);
    (0, $eUqFw.useEffect)(()=>()=>{
            !rapidboardResourceLoading && (0, $gbkeC.hideGhControllers)();
        }, [
        rapidboardResourceLoading
    ]);
    return [
        hasLayoutLoaded,
        isBentoOn
    ];
};
const $ade266f10da6c14d$var$handleBackToBackNavigation = (mode)=>{
    const { GH: GH } = window;
    if ((0, $1ybV0.ff)('jsw.classic.board.api-calls.modern-frontend') && GH.RapidBoard.State?.isFirstLoad() === false) GH.RapidBoard.State.setMode(mode);
};
const $ade266f10da6c14d$export$264220cfe099885c = (history)=>{
    const [pastRapidView, setPastRapidView] = (0, $eUqFw.useState)(null);
    const [pastChartView, setPastChartView] = (0, $eUqFw.useState)(undefined);
    const [areAppsInstalled, setAreAppsInstalled] = (0, $eUqFw.useState)(null);
    const [isRapidBoardsReady, setIsRapidBoardsReady] = (0, $eUqFw.useState)(false);
    const [shouldDeferToMonolith, setShouldDeferToMonolith] = (0, $eUqFw.useState)(false);
    const { accountId: accountId, mode: mode, boardId: boardId, chartView: chartView, projectKey: projectKey, routeName: routeName, isBoardLocationless: isBoardLocationless } = (0, $g3DZb.useUrlState)();
    const [hasLayoutLoaded, isBentoEnabled] = $ade266f10da6c14d$export$179c0f1288f7b075();
    const [isAppContentLoaded, setIsAppContentLoaded] = (0, $cYPRW.useRapidBoardContentLoadListener)();
    (0, $l4zPY.useCalendarSideEffects)();
    const { hasGHContextLoaded: hasGHContextLoaded } = (0, $3syrf.useWrmBundleLoader)();
    const { promise: allDataPromise, data: data, loading: allDataLoading, error: allDataError, hasFinishedRetrying: allDataAttemptFinished } = (0, $kQ5lq.useRapidBoardResource)({
        resource: (0, $a5edq.getRapidBoardDataResource)(),
        retryPredicate: (0, $jT7aq.isAllDataErrorValid)
    });
    // @ts-expect-error - TS2339 - Property 'data' does not exist on type 'unknown'. | TS2339 - Property 'route' does not exist on type 'unknown'.
    const { data: allData, route: initialRoute } = data ?? {};
    const shouldUserSeeBoard = !(allDataError && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    allDataError.statusCode != null && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    allDataError.statusCode === 404 || allData && allData.errors && allData.errors.rapidViewId);
    let haveResourcesLoaded = !!(hasGHContextLoaded && hasLayoutLoaded && (allDataPromise || !allDataLoading));
    const isReadyForMatching = !!(hasGHContextLoaded && (allDataPromise || !allDataLoading));
    let configResource;
    if ((0, $1ybV0.ff)('jsw.classic.board.api-calls.modern-frontend')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        configResource = $ade266f10da6c14d$var$useConfigResource(boardId == null ? '' : boardId);
        haveResourcesLoaded = !!(hasGHContextLoaded && hasLayoutLoaded && (allDataPromise || !allDataLoading) && (configResource.promise || !configResource.loading));
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const parseIssueData = (issueData)=>{
        if (!issueData) return [];
        return issueData.issues;
    };
    function reconcilingData() {
        if (!allDataPromise || !boardId) return;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        allDataPromise.then(async (dataPromise)=>{
            const { reconciledIssues: reconciledIssues, matchAPIResponse: matchAPIResponse } = await (0, $65uQX.default).searchAndReconcile(`/rest/greenhopper/1.0/xboard/issue/matches/board?rapidViewId=${boardId}`, boardId, // @ts-expect-error - TS2339 - Property 'data' does not exist on type 'object'.
            dataPromise.data, parseIssueData, 'CLASSIC_BACKLOG');
            let lastIssue = {
                id: 0,
                key: '',
                hidden: false,
                typeName: '',
                typeId: '',
                typeHierarchyLevel: 0,
                summary: '',
                typeUrl: '',
                priorityUrl: '',
                priorityName: '',
                done: false,
                hasCustomUserAvatar: false,
                flagged: false,
                estimateStatisticRequired: false,
                estimateStatistic: {
                    statFieldId: '',
                    statFieldValue: {
                        text: ''
                    }
                },
                statusId: '',
                statusName: '',
                statusUrl: '',
                status: {
                    id: '',
                    name: '',
                    description: '',
                    iconUrl: '',
                    statusCategory: {
                        id: '',
                        key: '',
                        colorName: ''
                    }
                },
                fixVersions: [],
                projectId: 0,
                linkedPagesCount: 0
            };
            // @ts-expect-error - TS7005 - Variable 'rapidboardData' implicitly has an 'any' type.
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
            dataPromise.data.then((rapidboardData)=>{
                const matchedData = $ade266f10da6c14d$var$decorateResponse(matchAPIResponse.issue.issuesResponse);
                const remainingIssue = new Set();
                reconciledIssues.forEach((issueObj, idx)=>{
                    // @ts-expect-error - TS2339 - Property 'id' does not exist on type 'object'.
                    if (issueObj.id in matchedData) {
                        // @ts-expect-error - TS2339 - Property 'id' does not exist on type 'object'.
                        remainingIssue.add(issueObj.id);
                        const merged = {
                            ...lastIssue,
                            ...reconciledIssues[idx]
                        };
                        reconciledIssues[idx] = $ade266f10da6c14d$var$overwriteMatchData(merged, // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{}'.
                        matchedData[issueObj.id]);
                    }
                });
                Object.entries(matchedData).forEach(([key, value])=>{
                    if (!remainingIssue.has(parseInt(key, 10))) {
                        lastIssue = {
                            ...lastIssue
                        };
                        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                        const overwriteData = $ade266f10da6c14d$var$overwriteMatchData(lastIssue, value);
                        if (data) reconciledIssues.push(overwriteData);
                        remainingIssue.add(parseInt(key, 10));
                    }
                });
                const newRapidBoardData = rapidboardData;
                const { GH: GH } = window;
                if (routeName === (0, $exb0h.ROUTE_NAMES_RAPIDBOARD_BOARD) && reconciledIssues.length > 0) {
                    newRapidBoardData.issuesData.issues = reconciledIssues;
                    GH.WorkController.setPoolData(newRapidBoardData);
                }
                if (routeName === (0, $exb0h.ROUTE_NAMES_RAPIDBOARD_BACKLOG) && reconciledIssues.length > 0) {
                    newRapidBoardData.issues = reconciledIssues;
                    GH.BacklogController.processData(false, newRapidBoardData);
                }
            });
        });
    }
    (0, $eUqFw.useEffect)(()=>{
        const { GH: GH } = window;
        const hasUserSwitchedRouteDuringLoad = hasGHContextLoaded && initialRoute && initialRoute !== routeName && GH?.RapidBoard?.State?.isFirstLoad();
        if (hasUserSwitchedRouteDuringLoad && isRapidBoardsReady) {
            GH?.RapidBoard?.State?.changeFirstLoadState?.();
            GH?.RapidBoard?.loadNewBoard?.(boardId);
        }
    }, [
        routeName,
        isRapidBoardsReady,
        boardId,
        initialRoute,
        hasGHContextLoaded
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const { GH: GH } = window;
        // @ts-expect-error - TS2339 - Property 'statusCode' does not exist on type 'Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error)'.
        if (hasGHContextLoaded && allDataAttemptFinished && allDataError?.statusCode === 500) {
            // Fallback to let monolith handle error as it may be a board config issue
            GH.RapidBoard.State.changeFirstLoadState();
            setShouldDeferToMonolith(true);
        }
    }, [
        allDataAttemptFinished,
        allDataError,
        hasGHContextLoaded
    ]);
    (0, $6U8he.addEventListenersEcClient)(isRapidBoardsReady, hasGHContextLoaded, routeName);
    (0, $eUqFw.useEffect)(()=>{
        if ((0, $1ybV0.ff)('jsw.odin.ec.client.enable.reconciliation.iic') && allDataPromise !== null && isReadyForMatching) reconcilingData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        routeName,
        boardId,
        allDataPromise,
        isReadyForMatching
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (shouldDeferToMonolith || haveResourcesLoaded && (allData || mode === (0, $3T07y.REPORT) || pastRapidView)) {
            const { GH: GH, AJS: AJS } = window;
            const dataPromise = new Promise((r)=>r(allData));
            if (mode !== (0, $3T07y.REPORT) && allData) (0, $1HT5A.setUpWrmData)(dataPromise);
            if ((0, $1ybV0.ff)('jsw.classic.board.api-calls.modern-frontend')) {
                const { key: configKey, promise: configPromise, update: configUpdate } = configResource;
                (0, $1HT5A.setupConfigResources)(configPromise, configKey, configUpdate);
            }
            (0, $1HT5A.setUpHistory)(history, {
                accountId: accountId,
                mode: mode,
                boardId: boardId,
                rapidView: boardId,
                chartView: chartView,
                projectKey: projectKey,
                isBoardLocationless: isBoardLocationless
            });
            if (pastRapidView === boardId && pastChartView === chartView && GH?.RapidBoard?.State?.getMode?.() === mode) return;
            if (pastRapidView == null && window.GH?.RapidBoard && String(window.GH.RapidBoard?.State?.data?.rapidViewId) === boardId) {
                // Render initial content for rapidboards to mount onto
                (0, $1HT5A.renderRapidboardDom)(mode === (0, $3T07y.WORK));
                GH.RapidBoard.ViewController.setMode(mode, true);
                (0, $1HT5A.afterRenderSetup)();
                setIsRapidBoardsReady(true);
                setPastRapidView(boardId);
                return;
            }
            if (pastRapidView === boardId) {
                if (isAppContentLoaded && isRapidBoardsReady && GH.RapidBoard.State.getDataValue('mode') && mode !== GH.RapidBoard.State.getMode()) GH.RapidBoard.ViewController.setMode(mode);
                if (pastChartView !== chartView) {
                    setIsAppContentLoaded(false);
                    GH.RapidBoard.init();
                    setPastChartView(chartView);
                }
            } else {
                (0, $1HT5A.resetWorkControllerFilters)();
                setIsRapidBoardsReady(false);
                setIsAppContentLoaded(false);
                $ade266f10da6c14d$var$handleBackToBackNavigation(mode);
                GH.RapidBoard.init().then(()=>{
                    setIsRapidBoardsReady(true);
                    !areAppsInstalled && $ade266f10da6c14d$var$startApps();
                    setAreAppsInstalled(true);
                    setShouldDeferToMonolith(false);
                    if (mode === (0, $3T07y.REPORT) && AJS) AJS.$(window).trigger('resize.rapidboardSpa');
                    (0, $1HT5A.afterRenderSetup)();
                });
                setPastRapidView(boardId);
                setPastChartView(chartView);
            }
        }
    }, [
        haveResourcesLoaded,
        allData,
        mode,
        history,
        areAppsInstalled,
        pastRapidView,
        boardId,
        pastChartView,
        chartView,
        isRapidBoardsReady,
        projectKey,
        isAppContentLoaded,
        setIsAppContentLoaded,
        shouldDeferToMonolith,
        accountId,
        // @ts-expect-error - Variable 'configResource' is used before being assigned
        configResource,
        isBoardLocationless
    ]);
    // @ts-expect-error - TS7005 - Variable 'event' implicitly has an 'any' type.
    function IICFire(event, issue) {
        if ((0, $1ybV0.ff)('jsw.odin.ec.client.enable.reconciliation.iic')) return (0, $65uQX.default).saveIssueMutationToCache(// @ts-expect-error - TS2339 - Property 'issueId' does not exist on type 'object'.
        new (0, $48mPv.default)(issue.issueId, (0, $d7Wfe.MutationSource).CREATE, '1', [], Date.now())).then((result)=>{
            if (!result) window.AJS.trigger('analyticsEvent', {
                name: 'jira-frontend.classic-software.controllers.rapidboard-state.inline-issue-create-listener.unable.to.save.error',
                data: {
                    errorMsg: 'Failed at IIC save event'
                }
            });
            // TODO : It is causing flickering UI bug ODIN-90
            reconcilingData();
        });
    }
    (0, $eUqFw.useEffect)(()=>{
        // eslint-disable-next-line jira/wrm/no-load-bridge
        (0, $2BvS3.loadBridge)({
            name: 'jira/util/events',
            wrmKeys: 'wrc!jira.webresources:jira-events'
        }).then((Events)=>Events.bind('inlineIssueCreatedOnBacklog', IICFire));
        return ()=>{
            // eslint-disable-next-line jira/wrm/no-load-bridge
            (0, $2BvS3.loadBridge)({
                name: 'jira/util/events',
                wrmKeys: 'wrc!jira.webresources:jira-events'
            }).then((Events)=>Events.unbind('inlineIssueCreatedOnBacklog', IICFire));
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return {
        isRapidBoardsReady: isRapidBoardsReady,
        mode: mode,
        isBentoEnabled: !!isBentoEnabled,
        shouldUserSeeBoard: shouldUserSeeBoard
    };
};

});
parcelRegister("65uQX", function(module, exports) {

$parcel$export(module.exports, "EcClient", () => $9d182d4720e39d79$export$a736992aaac2307a);
$parcel$export(module.exports, "getEcClient", () => $9d182d4720e39d79$export$c9342bd32f51406b);
$parcel$export(module.exports, "default", () => $9d182d4720e39d79$export$2e2bcd8739ae039);

var $gUUjF = parcelRequire("gUUjF");

var $1ybV0 = parcelRequire("1ybV0");

var $2OdyW = parcelRequire("2OdyW");

var $jMP2a = parcelRequire("jMP2a");

var $3FyZ4 = parcelRequire("3FyZ4");

var $fqqil = parcelRequire("fqqil");

var $7S3WE = parcelRequire("7S3WE");

var $d7Wfe = parcelRequire("d7Wfe");

var $4qvSX = parcelRequire("4qvSX");
class $9d182d4720e39d79$export$a736992aaac2307a {
    #issueCache;
    #config;
    constructor(){
        this.#issueCache = new (0, $7S3WE.default)('issue-cache-v1');
        this.#config = {};
    }
    /**
	 * A method to set tenant level details.
	 * These details include activation id, cloud id and user id
	 */ static setTenantDetails(activationID, cloudID, atlassianAccountId) {
        (0, $7S3WE.default).setTenantDetails(activationID, cloudID, atlassianAccountId);
    }
    /**
	 * A method to fire analytics events for both success and failure
	 */ static fireAnalyticsEvents(issueMutations, key = {
        analyticsMetadata: {
            scenario: 'unknown'
        }
    }, isSaved, analyticsFailureEventObj = {}) {
        try {
            // let mutationAnalyticsObj: any = [];
            let trackingId = '-1';
            if (Array.isArray(issueMutations)) //   mutationAnalyticsObj = issueMutations.map((item: IssueMutation) => item.issueId);
            trackingId = String(new Date(issueMutations[0]?.lastModified).valueOf()) + (0, $7S3WE.default).userID;
            else trackingId = String(new Date(issueMutations.lastModified).valueOf()) + (0, $7S3WE.default).userID;
            const payload = {
                action: 'mutated',
                actionSubject: 'issue',
                source: key?.analyticsMetadata?.scenario || 'unknown',
                attributes: {
                    ...key.analyticsMetadata,
                    trackingId: // issueMutationDetails: mutationAnalyticsObj,
                    trackingId
                }
            };
            // Error condition
            if (!isSaved) {
                if (!analyticsFailureEventObj) // eslint-disable-next-line no-param-reassign
                analyticsFailureEventObj = {
                    error: true,
                    errorMsg: payload.source
                };
                payload.attributes = {
                    ...payload.attributes,
                    ...analyticsFailureEventObj
                };
            }
            if (Object.prototype.hasOwnProperty.call(key, 'analyticsEventObj')) (0, $jMP2a.fireTrackAnalytics)(// @ts-expect-error - Argument of type 'Object' is not assignable to parameter of type 'UIAnalyticsEvent'.
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            key.analyticsEventObj, `${payload.actionSubject} ${payload.action}`, payload.attributes);
            else // if there is no UI component that triggers the event then we manually fire the event
            (0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>{
                client.getInstance().sendTrackEvent(payload);
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            (0, $gUUjF.default).safeErrorWithoutCustomerData('jsis-ec-client', e);
        }
    }
    /**
	 * A method to save a single issue mutations in cache
	 */ async saveIssueMutationToCache(issueMutation, key = {
        analyticsMetadata: {
            scenario: 'unknown'
        }
    }, analyticsFailureEventObj = {}) {
        if ((0, $1ybV0.ff)('odin.enable.backend.cache.ec.client')) {
            const isSaved = (0, $7S3WE.default).setBackendCache(issueMutation);
            $9d182d4720e39d79$export$a736992aaac2307a.fireAnalyticsEvents(issueMutation, key, isSaved, analyticsFailureEventObj);
            return isSaved;
        }
        return this.#issueCache.isPresent(issueMutation.issueId).then(async (result)=>{
            let isSaved = false;
            if (issueMutation.mutationType === (0, $d7Wfe.MutationSource).DELETE) isSaved = await this.#issueCache.delete(issueMutation.issueId);
            else if (result || issueMutation.mutationType === (0, $d7Wfe.MutationSource).UPDATE) isSaved = await this.#issueCache.update(issueMutation.issueId);
            else isSaved = await this.#issueCache.create(issueMutation.issueId);
            $9d182d4720e39d79$export$a736992aaac2307a.fireAnalyticsEvents(issueMutation, key, isSaved, analyticsFailureEventObj);
            return new Promise((resolve)=>resolve(isSaved));
        });
    }
    /**
	 * A method to save multiple issue mutations in cache
	 */ async saveIssueMutationsToCache(issueMutations, key = {
        analyticsMetadata: {
            scenario: 'unknown'
        }
    }, analyticsFailureEventObj = {}) {
        const data = [];
        if ((0, $1ybV0.ff)('odin.enable.backend.cache.ec.client')) {
            const isSaved = (0, $7S3WE.default).setBackendCache(issueMutations);
            $9d182d4720e39d79$export$a736992aaac2307a.fireAnalyticsEvents(issueMutations, key, isSaved, analyticsFailureEventObj);
            return [
                isSaved
            ];
        }
        issueMutations.forEach(async (issueMutation)=>{
            this.#issueCache.isPresent(issueMutation.issueId).then(async (result)=>{
                let isSaved = false;
                if (issueMutation.mutationType === (0, $d7Wfe.MutationSource).DELETE) isSaved = await this.#issueCache.delete(issueMutation.issueId);
                else if (result || issueMutation.mutationType === (0, $d7Wfe.MutationSource).UPDATE) isSaved = await this.#issueCache.update(issueMutation.issueId);
                else isSaved = await this.#issueCache.create(issueMutation.issueId);
                data.push(isSaved);
                $9d182d4720e39d79$export$a736992aaac2307a.fireAnalyticsEvents(issueMutations, key, isSaved, analyticsFailureEventObj);
            });
        });
        return new Promise((resolve)=>resolve(data));
    }
    /**
	 * A method to get issue mutations in saved in cache
	 */ getIssueMutationFromCache(key) {
        return this.#issueCache.get(key);
    }
    /**
	 * A method to remove the deleted issues from the search API
	 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    async filterData(data) {
        const localStorageData = await this.getIssueMutationFromCache(null);
        const deletedData = new Set();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Object.values(localStorageData).forEach((element)=>{
            if (element.mutationType === (0, $d7Wfe.MutationSource).DELETE) deletedData.add(element.issueId);
        });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const filteredData = [];
        let success = true;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Object.values(data).forEach((element)=>{
            if (!element.id || typeof element.id !== 'number') success = false;
            else if (!deletedData.has(element.id.toString())) filteredData.push(element);
        });
        return new Promise((// eslint-disable-next-line @typescript-eslint/no-explicit-any
        resolve, // eslint-disable-next-line @typescript-eslint/no-explicit-any
        reject)=>{
            if (success) resolve(filteredData);
            else reject(new Error());
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    async constructMatchRequest() {
        const issueData = {
            issues: [],
            hydrationMode: 0
        };
        const data = await this.getIssueMutationFromCache(null);
        Object.values(data).forEach((issueMutation)=>{
            const element = {
                issueId: issueMutation.issueId,
                version: issueMutation.version
            };
            issueData.issues.push(element);
        });
        const options = {
            method: 'POST',
            headers: {
                content_type: 'application/json',
                // @ts-expect-error - TS2339 - Property 'capability' does not exist on type 'object'.
                'x-atlassian-capability': (0, $fqqil.getEnhancedCapabilityHeader)(this.#config.capability)
            },
            body: JSON.stringify(issueData)
        };
        return new Promise((resolve)=>resolve(options));
    }
    /**
	 * A method to get the relevant search data from the parsing function that the user has provided
	 */ static getIssueDataFromSearch(data, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    parseIssueData) {
        const result = parseIssueData(data);
        if (result == null) return [];
        return result;
    }
    /**
	 * A method to get the search data and reconcile it with the data present in cache
	 */ async searchAndReconcile(matchApiUrl, jqlMatchingKey, search, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    parseIssueData, capability) {
        // @ts-expect-error - TS2339 - Property 'capability' does not exist on type 'object'.
        this.#config.capability = capability;
        const matchRequest = await this.constructMatchRequest();
        if (matchRequest && matchRequest.body && matchRequest.body.issues && matchRequest.body.issues.length === 0) return search.then((data)=>new Promise((resolve)=>resolve({
                    reconciledIssues: $9d182d4720e39d79$export$a736992aaac2307a.getIssueDataFromSearch(data, parseIssueData),
                    matchAPIResponse: {
                        response: {
                            resultsByIssueId: {}
                        },
                        issue: {
                            issuesResponse: {}
                        }
                    }
                })));
        const matchPromise = (0, $2OdyW.default)(matchApiUrl, matchRequest);
        return Promise.all([
            search,
            matchPromise
        ]).then(([data, response])=>{
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const structuredData = $9d182d4720e39d79$export$a736992aaac2307a.getIssueDataFromSearch(data, parseIssueData);
            return this.filterData(structuredData) // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .then((filteredSearchData)=>{
                if (response == null || response.response == null || response.response.resultsByIssueId == null) throw new Error('Match response is invalid!');
                const matchedIssueIds = response.response.resultsByIssueId;
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const filteredMatchedIssueIdsData = [];
                Object.entries(matchedIssueIds).forEach(([key, value])=>{
                    if (value === 'RESULT_MATCH') filteredMatchedIssueIdsData.push({
                        id: parseInt(key, 10)
                    });
                });
                return new Promise((resolve)=>{
                    resolve({
                        reconciledIssues: (0, $4qvSX.mergeResponseData)(filteredSearchData, filteredMatchedIssueIdsData),
                        matchAPIResponse: response
                    });
                });
            }).catch(()=>new Promise((resolve)=>resolve({
                        reconciledIssues: structuredData,
                        matchAPIResponse: response
                    })));
        });
    }
}
const $9d182d4720e39d79$var$ecClient = new $9d182d4720e39d79$export$a736992aaac2307a();
function $9d182d4720e39d79$export$c9342bd32f51406b(tenantContext = {}) {
    $9d182d4720e39d79$export$a736992aaac2307a.setTenantDetails(tenantContext?.activationId, tenantContext?.cloudId, tenantContext?.atlassianAccountId);
    return $9d182d4720e39d79$var$ecClient;
}
var $9d182d4720e39d79$export$2e2bcd8739ae039 = $9d182d4720e39d79$var$ecClient;

});
parcelRegister("7S3WE", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed861ad8bfcfb81a$export$2e2bcd8739ae039);
// Issue Cache API is an internal tool and this file should not be edited. Please contact Odin team for any modifications.

var $kBiqn = parcelRequire("kBiqn");

var $gUUjF = parcelRequire("gUUjF");

var $1ybV0 = parcelRequire("1ybV0");

var $2OdyW = parcelRequire("2OdyW");

var $48mPv = parcelRequire("48mPv");

var $d7Wfe = parcelRequire("d7Wfe");

var $4qvSX = parcelRequire("4qvSX");
const $ed861ad8bfcfb81a$var$MAX_AGE_MIN = 5;
const $ed861ad8bfcfb81a$var$MAX_AGE = $ed861ad8bfcfb81a$var$MAX_AGE_MIN * 60000;
const $ed861ad8bfcfb81a$var$CACHE_SIZE = 100;
const $ed861ad8bfcfb81a$var$CACHE_KEY_PREFIX = '__storejs';
const $ed861ad8bfcfb81a$var$BE_CACHE_SAVE_ISSUE_MUTATION = '/gateway/api/jira-jql-service/api/v1/issue-mutation';
class $ed861ad8bfcfb81a$export$2e2bcd8739ae039 {
    #localCache;
    #sessionCache;
    constructor(namespace, maxAge = $ed861ad8bfcfb81a$var$MAX_AGE){
        this.maxAge = maxAge;
        this.namespace = namespace;
        // @ts-expect-error - TS7009 - 'new' expression, whose target lacks a construct signature, implicitly has an 'any' type.
        this.#localCache = new (0, $kBiqn.Cache)({
            size: $ed861ad8bfcfb81a$var$CACHE_SIZE,
            storageType: (0, $d7Wfe.CacheType).LOCAL,
            cacheKey: namespace
        });
        // @ts-expect-error - TS7009 - 'new' expression, whose target lacks a construct signature, implicitly has an 'any' type.
        this.#sessionCache = new (0, $kBiqn.Cache)({
            size: $ed861ad8bfcfb81a$var$CACHE_SIZE,
            storageType: (0, $d7Wfe.CacheType).SESSION,
            cacheKey: namespace
        });
    }
    /**
	 * A method to set tenant level details.
	 * These details include activation id, cloud id and user id
	 */ static setTenantDetails(activationID, cloudID, userID) {
        if (activationID && activationID !== $ed861ad8bfcfb81a$export$2e2bcd8739ae039.activationID) $ed861ad8bfcfb81a$export$2e2bcd8739ae039.activationID = activationID;
        if (cloudID && cloudID !== $ed861ad8bfcfb81a$export$2e2bcd8739ae039.cloudID) $ed861ad8bfcfb81a$export$2e2bcd8739ae039.cloudID = cloudID;
        if (userID && userID !== $ed861ad8bfcfb81a$export$2e2bcd8739ae039.userID) $ed861ad8bfcfb81a$export$2e2bcd8739ae039.userID = userID;
    }
    /**
	 * A util method to decide whether an issue mutation in cache is stale or not
	 */ static isIssueMutationStale(issueMutation) {
        const lastModified = new Date(issueMutation.lastModified).getTime();
        return Date.now() - lastModified < $ed861ad8bfcfb81a$var$MAX_AGE;
    }
    /**
	 * A util method to generate partial key containing username for storing in cache
	 */ static generateKey() {
        let anonymousId = window.localStorage.getItem('ajs_anonymous_id');
        anonymousId = anonymousId ? `.${anonymousId}` : '';
        anonymousId = anonymousId.replace(/["]+/g, '');
        // TODO : Replace this with something more generic
        return `jsis.ecCache.data${anonymousId}.newIssuesMutationList`;
    }
    /**
	 * A method to generate key containing username as well as namespace for storing in cache
	 */ generateReadKey() {
        return `${$ed861ad8bfcfb81a$var$CACHE_KEY_PREFIX}_${this.namespace}_${$ed861ad8bfcfb81a$export$2e2bcd8739ae039.generateKey()}`;
    }
    /**
	 * A method to get the issue mutations stored in the cache
	 * Accepts issueIds or array of issuesIds and returns corresponding issue mutations
	 * Returns all the issue mutations when provided with null argument in form of an array
	 * Cleans the cache before accessing issue mutations in order to avoid stale data
	 */ async get(key) {
        return this.cleanCache().then(()=>this.getWithoutClean(key));
    }
    /**
	 * A method to get the issue mutations stored in the cache
	 * Accepts issueIds or array of issuesIds to return selective issue mutations
	 * Returns all the issue mutations when provided with null argument
	 */ async getWithoutClean(key) {
        if (key == null) return new Promise((resolve)=>{
            this.#localCache.get(this.generateReadKey()).then((data)=>data ? resolve(data) : resolve({}));
        });
        return new Promise(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (resolve)=>{
            this.#localCache.get(this.generateReadKey()).then((data)=>{
                if (!data) resolve({});
                else {
                    const iterableData = data;
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const newData = {};
                    if (typeof key === 'string') newData[key] = iterableData[key];
                    else if (Array.isArray(key)) key.forEach((issueId)=>{
                        newData[issueId] = iterableData[issueId];
                    });
                    resolve(newData);
                }
            });
        });
    }
    /**
	 * A method to construct object to be stored in backend cache
	 * Can receive an issue mutation or an array of issue mutations to be saved in cache
	 */ static constructBackendCacheObject(value) {
        if (value instanceof (0, $48mPv.default)) return {
            issueId: value.issueId,
            mutationType: value.mutationType,
            mutationTimestamp: value.lastModified
        };
        const result = [];
        value.forEach((data)=>{
            result.push($ed861ad8bfcfb81a$export$2e2bcd8739ae039.constructBackendCacheObject(data));
        });
        return result;
    }
    /**
	 * A method to save the issue mutations in the backend cache
	 * Can receive an issue mutation or an array of issue mutations to be saved in cache
	 */ static setBackendCache(data) {
        try {
            let issueBody = $ed861ad8bfcfb81a$export$2e2bcd8739ae039.constructBackendCacheObject(data);
            let trackingId = '-1';
            if (data instanceof (0, $48mPv.default)) {
                trackingId = String(new Date(data.lastModified).valueOf()) + ($ed861ad8bfcfb81a$export$2e2bcd8739ae039.userID || '');
                issueBody = [
                    issueBody
                ];
            } else trackingId = String(new Date(data[0].lastModified).valueOf()) + ($ed861ad8bfcfb81a$export$2e2bcd8739ae039.userID || '');
            (0, $2OdyW.default)($ed861ad8bfcfb81a$var$BE_CACHE_SAVE_ISSUE_MUTATION, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'ATL-activationId': $ed861ad8bfcfb81a$export$2e2bcd8739ae039.activationID || '',
                    'atl-CloudId': $ed861ad8bfcfb81a$export$2e2bcd8739ae039.cloudID || '',
                    trackingId: trackingId
                },
                body: JSON.stringify({
                    issueMutations: issueBody
                })
            });
            return true;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            (0, $gUUjF.default).safeErrorWithoutCustomerData('jsis-ec-client', `${e?.toString() || ''}mutationObj: ${data}`);
            return false;
        }
    }
    /**
	 * A method to save the issue mutations in the cache
	 * Can receive an issue mutation or an array of issue mutations to be saved in cache
	 */ async set(value) {
        return this.getWithoutClean().then(async (cacheData)=>{
            if (value instanceof (0, $48mPv.default)) {
                const storeValue = {
                    [value.issueId]: value
                };
                return new Promise((resolve)=>{
                    try {
                        this.#localCache.set(this.generateReadKey(), (0, $4qvSX.mergeData)(cacheData, storeValue));
                        resolve(true);
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    } catch (e) {
                        resolve(false);
                    }
                });
            }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const storeData = {};
            value.forEach((data)=>{
                storeData[data.issueId] = data;
            });
            return new Promise((resolve)=>{
                try {
                    this.#localCache.set(this.generateReadKey(), (0, $4qvSX.mergeData)(cacheData, storeData));
                    resolve(true);
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (e) {
                    resolve(false);
                }
            });
        });
    }
    /**
	 * A method to create a new issue mutation in cache
	 * Can receive an issue ids or an array of issue ids to be created in cache
	 */ async create(value) {
        return this.cleanCache().then(()=>{
            if (!Array.isArray(value)) return this.set(new (0, $48mPv.default)(value, (0, $d7Wfe.MutationSource).CREATE, '1', [], new Date().toISOString()));
            const storeData = value.map((data)=>new (0, $48mPv.default)(data, (0, $d7Wfe.MutationSource).CREATE, '1', [], new Date().toISOString()));
            return this.set(storeData);
        });
    }
    /**
	 * A method to update an already existing issue mutation in cache
	 * Can receive an issue ids or an array of issue ids to be updated in cache
	 */ async update(value) {
        if ((0, $1ybV0.ff)('odin.enable.backend.cache.ec.client')) {
            if (typeof value === 'string') return this.set(new (0, $48mPv.default)(value, (0, $d7Wfe.MutationSource).UPDATE, '1', []));
            return this.set(value.map((issueId)=>new (0, $48mPv.default)(issueId, (0, $d7Wfe.MutationSource).UPDATE, '1', [])));
        }
        return this.getWithoutClean(value).then((data)=>{
            const valueToUpdate = [];
            Object.entries(data).forEach(([issueId, issueMutationObj])=>{
                if (issueMutationObj instanceof (0, $48mPv.default)) {
                    if ($ed861ad8bfcfb81a$export$2e2bcd8739ae039.isIssueMutationStale(issueMutationObj)) valueToUpdate.push(new (0, $48mPv.default)(String(issueId), (0, $d7Wfe.MutationSource).UPDATE, issueMutationObj.version, issueMutationObj.matchStatus, new Date().toISOString()));
                    else valueToUpdate.push(new (0, $48mPv.default)(String(issueId), (0, $d7Wfe.MutationSource).CREATE, '1', issueMutationObj.matchStatus, new Date().toISOString()));
                } else valueToUpdate.push(new (0, $48mPv.default)(String(issueId), (0, $d7Wfe.MutationSource).UPDATE, // TODO: Incorporate the version and match status and change the update method signature
                '1', [], new Date().toISOString()));
            });
            return this.set(valueToUpdate);
        });
    }
    /**
	 * A method to delete an issue mutation in cache
	 */ async delete(key) {
        if (typeof key === 'string') return this.set(new (0, $48mPv.default)(key, (0, $d7Wfe.MutationSource).DELETE, '', [], new Date().toISOString()));
        const storeData = key.map((data)=>new (0, $48mPv.default)(data, (0, $d7Wfe.MutationSource).DELETE, '', [], new Date().toISOString()));
        return this.set(storeData);
    }
    /**
	 * A method to clear the cache
	 */ async clear() {
        return this.#localCache.clear();
    }
    /**
	 * A method that selectively deletes the stale cache entries
	 */ async cleanCache() {
        // We don't clean the backend cache
        if ((0, $1ybV0.ff)('odin.enable.backend.cache.ec.client')) return Promise.resolve(true);
        return this.getWithoutClean(null).then((data)=>{
            const issuesToKeep = [];
            if (data && Object.keys(data).length !== 0 && Object.getPrototypeOf(data) === Object.prototype) Object.keys(data).forEach((issueId)=>{
                const issueMutationObj = data[issueId];
                if ($ed861ad8bfcfb81a$export$2e2bcd8739ae039.isIssueMutationStale(issueMutationObj)) issuesToKeep.push(issueMutationObj);
            });
            return this.clear().then(()=>this.set(issuesToKeep));
        });
    }
    /**
	 * A method to check if an issue id is present in the cache
	 */ isPresent(issueId) {
        return this.get(issueId).then((data)=>!!data && !!Object.values(data)[0]);
    }
    /**
	 * A method to check if any mutation is present in the cache
	 */ isEmpty() {
        return this.get(null).then((data)=>Object.keys(data).length === 0);
    }
    /**
	 * A method to find the size of the local storage for any given key
	 */ static getLocalStorageSizeForGivenKey(key) {
        const value = localStorage.getItem(key);
        if (value != null) {
            const keySize = value.length;
            return keySize;
        }
        return 0;
    }
    /**
	 * A method to find the size of the local storage for any given key
	 * It returns size of all the keys when provided with no key
	 */ static getLocalStorageSize(key) {
        if (key != null) return $ed861ad8bfcfb81a$export$2e2bcd8739ae039.getLocalStorageSizeForGivenKey(key);
        let totalSize = 0;
        Object.keys(localStorage).forEach((keys)=>{
            totalSize += $ed861ad8bfcfb81a$export$2e2bcd8739ae039.getLocalStorageSizeForGivenKey(keys);
        });
        return totalSize;
    }
}

});
parcelRegister("kBiqn", function(module, exports) {

$parcel$export(module.exports, "Cache", () => $32f02625ea3a7ccc$export$94affb487e701bf2);
$parcel$export(module.exports, "default", () => $32f02625ea3a7ccc$export$2e2bcd8739ae039);

var $aZaPn = parcelRequire("aZaPn");

var $89bO2 = parcelRequire("89bO2");

var $gUUjF = parcelRequire("gUUjF");


var $48k9t = parcelRequire("48k9t");
const $32f02625ea3a7ccc$var$calculateEntryAge = (timestamp)=>Date.now() - timestamp;
function $32f02625ea3a7ccc$export$94affb487e701bf2(props) {
    const cache = new Map();
    const { size: size } = props;
    let storage;
    let hasSyncedFromStorage = false;
    const devTools = window && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__.connect({
        name: `Cache ${props.cacheKey}`,
        serialize: true
    }) : null;
    const syncWithDevTools = (type, payload)=>{
        if ((0, $48k9t.default).devTools) devTools && devTools.send({
            type: type,
            payload: payload
        }, cache, {}, props.cacheKey);
    };
    const removeExpiredKeysFromStorage = async (store)=>{
        const updatedStore = {
            ...store
        };
        if (props.storageType === (0, $834cc2f16be60bc5$export$bf340b99118a1511)) return {};
        const { cacheKey: cacheKey, maxAge: maxAge } = props;
        if (maxAge !== undefined) {
            Object.keys(store).forEach((key)=>{
                // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                const keyAge = $32f02625ea3a7ccc$var$calculateEntryAge(store[key].timestamp);
                if (keyAge > maxAge) {
                    // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: any; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                    syncWithDevTools((0, $834cc2f16be60bc5$export$26d12233004a7a60), {
                        [String(key)]: updatedStore[key]
                    });
                    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                    delete updatedStore[key];
                    // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'K'.
                    cache.delete(key);
                }
            });
            storage.set(cacheKey, updatedStore);
        }
        return updatedStore;
    };
    const removeExpiredEntry = (key, val)=>{
        if (props.storageType !== (0, $834cc2f16be60bc5$export$bf340b99118a1511)) {
            const { maxAge: maxAge } = props;
            if (maxAge !== undefined && $32f02625ea3a7ccc$var$calculateEntryAge(val.timestamp) > maxAge) {
                // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V>; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
                syncWithDevTools((0, $834cc2f16be60bc5$export$26d12233004a7a60), {
                    [String(key)]: val
                });
                cache.delete(key);
                return true;
            }
        }
        return false;
    };
    const createStore = ()=>{
        if (props.storageType === (0, $834cc2f16be60bc5$export$2670cb7d5d4f7184)) storage = (0, $aZaPn.createLocalStorageProvider)((0, $48k9t.CACHE_PREFIX));
        else storage = (0, $89bO2.createSessionStorageProvider)((0, $48k9t.CACHE_PREFIX));
        return storage;
    };
    const set = async (key, value)=>{
        await load();
        // @ts-expect-error - TS2345 - Argument of type 'string | K' is not assignable to parameter of type 'K'.
        cache.delete(key);
        const entry = {
            value: value,
            timestamp: Date.now()
        };
        let storedContent = {};
        if (props.storageType !== (0, $834cc2f16be60bc5$export$bf340b99118a1511)) {
            storedContent = storage.get(props.cacheKey) || {};
            // @ts-expect-error - TS2536 - Type 'string | K' cannot be used to index type 'Partial<Record<K, Entry<V>>>'.
            storedContent[key] = entry;
        }
        // @ts-expect-error - TS2345 - Argument of type 'string | K' is not assignable to parameter of type 'K'.
        cache.set(key, entry);
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V>; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $834cc2f16be60bc5$export$5e8f180ef0142226), {
            [String(key)]: entry
        });
        if (cache.size > size) {
            const keys = cache.keys();
            const firstEntry = keys.next().value;
            if (firstEntry !== undefined) {
                cache.delete(firstEntry);
                syncWithDevTools((0, $834cc2f16be60bc5$export$a61768fefd33fcb1), firstEntry);
                if (props.storageType !== (0, $834cc2f16be60bc5$export$bf340b99118a1511)) // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                delete storedContent[firstEntry];
            }
        }
        props.storageType !== (0, $834cc2f16be60bc5$export$bf340b99118a1511) && storage.set(props.cacheKey, storedContent);
    };
    const load = async ()=>{
        if (false || hasSyncedFromStorage) return;
        hasSyncedFromStorage = true;
        if (props.storageType === (0, $834cc2f16be60bc5$export$bf340b99118a1511)) return;
        const { cacheKey: cacheKey } = props;
        storage = createStore();
        try {
            let data = storage.get(cacheKey) || {};
            data = await removeExpiredKeysFromStorage(data);
            syncWithDevTools((0, $834cc2f16be60bc5$export$61f74127e2b53cbe), data);
            const orderedKeys = Object.keys(data).sort(// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
            (key1, key2)=>data[key1].timestamp - data[key2].timestamp);
            await Promise.all(orderedKeys.map(async (key)=>{
                // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                await set(key, data[key].value);
            }));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $gUUjF.default).safeWarnWithoutCustomerData((0, $834cc2f16be60bc5$export$7271276960377470), `There was an error syncing with storage - ${cacheKey}`, err);
            throw err;
        }
    };
    const clear = async ()=>{
        await load();
        cache.clear();
        if (props.storageType !== (0, $834cc2f16be60bc5$export$bf340b99118a1511)) {
            const { cacheKey: cacheKey } = props;
            storage.remove(cacheKey);
        }
        syncWithDevTools((0, $834cc2f16be60bc5$export$6c4d37c7f376a1de), {});
    };
    const get = async (key)=>{
        await load();
        let val = cache.get(key);
        if (val) {
            if (removeExpiredEntry(key, val)) val = undefined;
        }
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V> | undefined; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $834cc2f16be60bc5$export$1bb358554aac31c1), {
            [String(key)]: val
        });
        return val && val.value;
    };
    const update = async (key, value)=>{
        await load();
        const previousValue = cache.get(key);
        if (!previousValue) return;
        const entry = {
            value: value,
            timestamp: previousValue.timestamp
        };
        let storedContent = {};
        if (props.storageType !== (0, $834cc2f16be60bc5$export$bf340b99118a1511)) {
            storedContent = storage.get(props.cacheKey) || {};
            storedContent[key] = entry;
        }
        cache.set(key, entry);
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V>; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $834cc2f16be60bc5$export$e271b26eefe41db8), {
            [String(key)]: entry
        });
        props.storageType !== (0, $834cc2f16be60bc5$export$bf340b99118a1511) && storage.set(props.cacheKey, storedContent);
    };
    const getEntries = async ()=>{
        await load();
        const entries = Array.from(cache.entries()).filter(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        ([key, value])=>!removeExpiredEntry(key, value));
        syncWithDevTools((0, $834cc2f16be60bc5$export$9eb68924983e00fb), entries);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return entries.map(([key, { value: value }])=>[
                key,
                value
            ]);
    };
    const deleteEntry = async (key)=>{
        await load();
        if (props.storageType !== (0, $834cc2f16be60bc5$export$bf340b99118a1511)) {
            const storedContent = storage.get(props.cacheKey) || {};
            delete storedContent[key];
            storage.set(props.cacheKey, storedContent);
        }
        cache.delete(key);
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V> | undefined; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $834cc2f16be60bc5$export$4bd2facc4a3e6aa1), {
            [String(key)]: cache.get(key)
        });
    };
    const refresh = async ()=>{
        if (props.storageType === (0, $834cc2f16be60bc5$export$bf340b99118a1511)) return;
        cache.clear();
        hasSyncedFromStorage = false;
        await load();
    };
    if ((0, $48k9t.default).scopes.current !== (0, $48k9t.default).scopes.prev) clear();
    return {
        cache: cache,
        get: get,
        set: set,
        delete: deleteEntry,
        clear: clear,
        load: load,
        update: update,
        getEntries: // @ts-expect-error - TS2322 - Type '() => Promise<any[][]>' is not assignable to type '() => Promise<[K, V][]>'.
        getEntries,
        refresh: refresh
    };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $32f02625ea3a7ccc$var$cacheMap = {};
const $32f02625ea3a7ccc$var$getCache = async (props)=>{
    await (0, $48k9t.scopeGuard)().catch((error)=>{
        (0, $gUUjF.default).safeErrorWithoutCustomerData('common.cache.scope', 'There was a failure within cache scopeGuard', error);
    });
    const { cacheKey: cacheKey } = props;
    // @ts-expect-error - TS7009 - 'new' expression, whose target lacks a construct signature, implicitly has an 'any' type.
    $32f02625ea3a7ccc$var$cacheMap[cacheKey] = $32f02625ea3a7ccc$var$cacheMap[cacheKey] || new $32f02625ea3a7ccc$export$94affb487e701bf2(props);
    return $32f02625ea3a7ccc$var$cacheMap[cacheKey];
};
const $32f02625ea3a7ccc$export$710d301bf26d9700 = ()=>{
    Object.values($32f02625ea3a7ccc$var$cacheMap).forEach((cache)=>cache.clear());
};
var $32f02625ea3a7ccc$export$2e2bcd8739ae039 = $32f02625ea3a7ccc$var$getCache;

});
const $834cc2f16be60bc5$export$7271276960377470 = 'common-cache';
const $834cc2f16be60bc5$export$a61768fefd33fcb1 = 'capacity exceeded';
const $834cc2f16be60bc5$export$6c4d37c7f376a1de = 'clear';
const $834cc2f16be60bc5$export$e271b26eefe41db8 = 'update';
const $834cc2f16be60bc5$export$4bd2facc4a3e6aa1 = 'delete';
const $834cc2f16be60bc5$export$26d12233004a7a60 = 'delete stale entry';
const $834cc2f16be60bc5$export$1bb358554aac31c1 = 'get';
const $834cc2f16be60bc5$export$61f74127e2b53cbe = 'hydrate';
const $834cc2f16be60bc5$export$5e8f180ef0142226 = 'set';
const $834cc2f16be60bc5$export$9eb68924983e00fb = 'get entries';
const $834cc2f16be60bc5$export$bf340b99118a1511 = 'memory';
const $834cc2f16be60bc5$export$2670cb7d5d4f7184 = 'local';
const $834cc2f16be60bc5$export$b796061ff0c82e1a = 'session';


parcelRegister("48mPv", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce578c493ad96d9e$export$2e2bcd8739ae039);
class $ce578c493ad96d9e$export$2e2bcd8739ae039 {
    constructor(issueId, mutationType, version = '1', matchStatus = [], // eslint-disable-next-line @typescript-eslint/no-unused-vars
    lastModified){
        this.issueId = issueId;
        this.mutationType = mutationType;
        this.version = version;
        this.matchStatus = matchStatus;
        // create a new timeStamp whenever an object is initialized
        this.lastModified = new Date().toISOString();
    }
}

});

parcelRegister("d7Wfe", function(module, exports) {

$parcel$export(module.exports, "MutationSource", () => $598bd411eca1df87$export$17f28c4c94a74282);
$parcel$export(module.exports, "CacheType", () => $598bd411eca1df87$export$ba193b555633db78);
const $598bd411eca1df87$export$17f28c4c94a74282 = {
    CREATE: 0,
    UPDATE: 1,
    DELETE: 2
};
const $598bd411eca1df87$export$ba193b555633db78 = {
    LOCAL: 'local',
    SESSION: 'session'
};

});

parcelRegister("4qvSX", function(module, exports) {

$parcel$export(module.exports, "mergeData", () => $1b463beed4d472c8$export$696bf4df45a0ddde);
$parcel$export(module.exports, "mergeResponseData", () => $1b463beed4d472c8$export$71923bad28063cb1);
$parcel$export(module.exports, "createAnalyticsMetadata", () => $1b463beed4d472c8$export$eeaad9fa1f02ef4a);

var $6rW04 = parcelRequire("6rW04");
function $1b463beed4d472c8$export$696bf4df45a0ddde(oldData, newData) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const result = {};
    Object.keys(oldData).forEach((issueId)=>{
        result[issueId] = oldData[issueId];
    });
    Object.keys(newData).forEach((issueId)=>{
        result[issueId] = newData[issueId];
    });
    return result;
}
function $1b463beed4d472c8$export$71923bad28063cb1(searchData, matchData) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const mergedData = [];
    const issueData = new Map();
    if (matchData.length) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    matchData.forEach((element)=>{
        issueData.set(element.id, element);
    });
    if (searchData.length) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    searchData.forEach((element)=>{
        // TODO: if issueVersion in Match is less than Search, we should not be overwriting that issueID.
        if (issueData.has(element.id)) {
            mergedData.push(issueData.get(element.id));
            issueData.delete(element.id);
        } else mergedData.push(element);
    });
    if (issueData.size) issueData.forEach((value)=>{
        mergedData.push(value);
    });
    return mergedData;
}
function $1b463beed4d472c8$export$eeaad9fa1f02ef4a(customKeys) {
    return {
        shard: (0, $6rW04.default)('ajs-shard') || '',
        userId: (0, $6rW04.default)('ajs-atlassian-account-id') || '',
        projectId: (0, $6rW04.default)('ajs-project-key') || '',
        ...customKeys
    };
}

});



parcelRegister("3syrf", function(module, exports) {

$parcel$export(module.exports, "useWrmBundleLoader", () => $a9879a1d258235ad$export$d4d2c76eab941a24);

var $eUqFw = parcelRequire("eUqFw");

var $gUUjF = parcelRequire("gUUjF");

var $azMNr = parcelRequire("azMNr");

var $lB25E = parcelRequire("lB25E");
const $a9879a1d258235ad$var$actions = {
    initGhContext: ()=>({ setState: setState, getState: getState })=>{
            const { hasGHContextLoaded: hasGHContextLoaded, isGhContextLoading: isGhContextLoading } = getState();
            if (!hasGHContextLoaded && !isGhContextLoading) {
                setState({
                    isGhContextLoading: true
                });
                setState({
                    hasGHContextLoaded: true,
                    isGhContextLoading: false
                });
            }
        }
};
const $a9879a1d258235ad$export$d4d2c76eab941a24 = ()=>{
    const { data: wrmBundleDescriptor, error: errorGHContext } = (0, $lB25E.useResource)((0, $azMNr.wrmBundleResource));
    (0, $eUqFw.useEffect)(()=>{
        if (errorGHContext != null) (0, $gUUjF.default).safeErrorWithoutCustomerData('classic.wrm.bundle.error', 'Failed to load WRM bundle for Rapidboards', errorGHContext);
    }, [
        errorGHContext
    ]);
    // @ts-expect-error - TS2322 - Type 'Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error) | null' is not assignable to type 'Error | null'.
    return {
        hasGHContextLoaded: !!wrmBundleDescriptor,
        errorGHContext: errorGHContext
    };
};

});

parcelRegister("l4zPY", function(module, exports) {

$parcel$export(module.exports, "useCalendarSideEffects", () => $8bf2ddb1039ccf20$export$460514a547ad8b3d);

var $eUqFw = parcelRequire("eUqFw");

var $4xHig = parcelRequire("4xHig");

var $cYPRW = parcelRequire("cYPRW");
const $8bf2ddb1039ccf20$export$460514a547ad8b3d = ()=>{
    const [haveMonkeyPatchedStartSprint, setHaveMonkeyPatchedStartSprint] = (0, $eUqFw.useState)(false);
    const locale = (0, $4xHig.useLocale)();
    const contentLoadedStatus = (0, $cYPRW.useRapidBoardContentListener)();
    (0, $eUqFw.useEffect)(()=>{
        try {
            const { moment: moment, Calendar: Calendar, GH: GH } = window;
            if (!moment || !Calendar) return;
            const langData = moment.localeData('jira');
            if (!langData) return;
            // Calendar.js needs 8 element array for days (starting and ending with sunday)
            Calendar._DN = langData._weekdays.concat(langData._weekdays[0]);
            Calendar._SDN = langData._weekdaysShort.concat(langData._weekdaysShort[0]);
            Calendar._MN = [].concat(langData._months);
            Calendar._SMN = [].concat(langData._monthsShort);
            if (GH?.SprintController?.openStartSprintDialog && locale === 'ja_JP' && !haveMonkeyPatchedStartSprint) {
                const originalFunction = GH.SprintController.openStartSprintDialog;
                // @ts-expect-error - TS7019 - Rest parameter 'args' implicitly has an 'any[]' type.
                GH.SprintController.openStartSprintDialog = (...args)=>{
                    Calendar._TT.AM = '\u5348\u524D';
                    Calendar._TT.PM = '\u5348\u5F8C';
                    Calendar._TT.am = '\u5348\u524D';
                    Calendar._TT.pm = '\u5348\u5F8C';
                    originalFunction(...args);
                };
                setHaveMonkeyPatchedStartSprint(true);
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any, no-empty
        } catch (e) {}
    }, [
        haveMonkeyPatchedStartSprint,
        contentLoadedStatus,
        locale
    ]);
};

});

parcelRegister("gbkeC", function(module, exports) {

$parcel$export(module.exports, "cleanupResources", () => $1517b18db924a8e9$export$687fcdb18310652e);
$parcel$export(module.exports, "cleanupDOM", () => $1517b18db924a8e9$export$94699122a7a283af);
$parcel$export(module.exports, "cleanupGH", () => $1517b18db924a8e9$export$f2a8626034055d0);
$parcel$export(module.exports, "hideGhControllers", () => $1517b18db924a8e9$export$2ac2fbe6032ae006);

var $lEfVV = parcelRequire("lEfVV");

var $3T07y = parcelRequire("3T07y");
const $1517b18db924a8e9$export$687fcdb18310652e = (resources)=>{
    if (resources && resources.length > 0) resources.forEach((resource)=>{
        if (window.GH?.spa) delete window.GH.spa[resource];
    });
};
const $1517b18db924a8e9$export$94699122a7a283af = (doc)=>(initialClasslist, metaTags, isBentoOn)=>{
        if (doc.body) {
            const documentBody = doc.body;
            metaTags.forEach((metaTag)=>{
                metaTag.parentNode && metaTag.parentNode.removeChild(metaTag);
            });
            if (isBentoOn === true) {
                const bentoRoot = doc.getElementById((0, $3T07y.BENTO_ROOT));
                bentoRoot && (0, $lEfVV.unmountComponentAtNode)(bentoRoot);
            }
            const currentClassList = Array.from(documentBody.classList);
            currentClassList.forEach((className)=>{
                documentBody.classList.remove(className);
            });
            initialClasslist.filter((className)=>className !== 'deferred').forEach((className)=>{
                documentBody.classList.add(className);
            });
        }
    };
const $1517b18db924a8e9$var$WINDOW_EVENTS = [
    'confluence',
    'hashchange',
    'messageClose',
    'remove',
    'statechange',
    'blur.rapidboardSpa',
    'popstate.rapidboardSpa',
    'resize.rapidboardSpa',
    'unload.rapidboardSpa',
    'focus.rapidboardSpa'
];
const $1517b18db924a8e9$export$f2a8626034055d0 = (win, doc)=>()=>{
        const { GH: GH, AJS: AJS } = win;
        if (AJS) {
            AJS.$(win).off($1517b18db924a8e9$var$WINDOW_EVENTS.join(' '));
            AJS.$(doc.body).off('click.rapidboardSpa');
            AJS.$('[draggable=true]').die('dragstart');
        }
        if (GH) {
            GH.spa = null;
            if (GH.Poller) {
                // removeAll just pauses the event listener. We need to manually call remove on individual pollers
                GH.Poller.removeAll && GH.Poller.removeAll();
                GH.Poller.removePoller && GH.Poller.removePoller('WorkPoller');
                GH.Poller.removePoller && GH.Poller.removePoller('linkedPagePoller');
            }
        }
        /**
	 * On cleanup we need to re-register the global issue create event handlers which will override the
	 * rapidboard specific ones
	 *
	 * NOTE: do not destructure this above to avoid confusing the bundler.
	 */ win.require('jira/common/header').initialize();
    };
const $1517b18db924a8e9$export$2ac2fbe6032ae006 = ()=>{
    try {
        const { GH: GH } = window;
        if (GH) {
            GH.WorkController && GH.WorkController.hide();
            GH.ReportController && GH.ReportController.hide();
            GH.PlanController && GH.PlanController.hide();
        }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, no-empty
    } catch (e) {}
};
const $1517b18db924a8e9$export$de863c629cb9919d = (initialClasslist, metaTags, isBentoOn)=>{
    try {
        $1517b18db924a8e9$export$94699122a7a283af(document)(initialClasslist, metaTags, isBentoOn);
        $1517b18db924a8e9$export$f2a8626034055d0(window, document)();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, no-empty
    } catch (e) {}
};

});

parcelRegister("6U8he", function(module, exports) {

$parcel$export(module.exports, "addEventListenersEcClient", () => $1ae259546bdf0582$export$71e9c8663835c915);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $2BvS3 = parcelRequire("2BvS3");

var $1ybV0 = parcelRequire("1ybV0");

var $hlnTO = parcelRequire("hlnTO");

var $bFzGY = parcelRequire("bFzGY");
const $1ae259546bdf0582$export$71e9c8663835c915 = (isRapidBoardsReady, hasWrmLoaded, routeName)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const experiences = (0, $1ybV0.getFeatureFlagValue)('odin.ec.client.integration.cbb', '');
    if (experiences.length === 0) return null;
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const subscriptionHandle = (0, $eUqFw.useRef)((0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))));
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const analyticsEventObj = createAnalyticsEvent({});
    const setMutationEvents = // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $hlnTO.useIssueMutationEventsFactoryBacklogAndBoard)({
        analyticsEventObj: analyticsEventObj
    });
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eUqFw.useEffect)(()=>{
        if (isRapidBoardsReady && hasWrmLoaded) // eslint-disable-next-line jira/wrm/no-load-bridge
        (0, $2BvS3.loadBridge)({
            name: 'jira/util/events',
            wrmKeys: 'wrc!jira.webresources:jira-events'
        }).then((Events)=>{
            const issueMutationEventsFactoryBacklogAndBoard = setMutationEvents(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            Events);
            issueMutationEventsFactoryBacklogAndBoard.initialize();
            issueMutationEventsFactoryBacklogAndBoard.bind();
            subscriptionHandle.current = ()=>{
                issueMutationEventsFactoryBacklogAndBoard.unbind();
            };
        });
        return ()=>{
            subscriptionHandle.current();
            subscriptionHandle.current = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)));
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isRapidBoardsReady,
        hasWrmLoaded,
        routeName,
        subscriptionHandle
    ]);
    return null;
};

});
parcelRegister("hlnTO", function(module, exports) {

$parcel$export(module.exports, "useIssueMutationEventsFactoryBacklogAndBoard", () => $6c54a050a1278d84$export$b3aebfb164fa2226);

var $bsdZ2 = parcelRequire("bsdZ2");

var $5P2vG = parcelRequire("5P2vG");
const $6c54a050a1278d84$export$b3aebfb164fa2226 = (props)=>{
    const ecClientObj = (0, $bsdZ2.useEcClient)();
    return (events)=>new (0, $5P2vG.default)({
            events: events,
            ...props,
            ecClientObj: ecClientObj
        });
};

});
parcelRegister("bsdZ2", function(module, exports) {

$parcel$export(module.exports, "useEcClient", () => $b40c4387cd757cd5$export$9da409beb25e67da);

var $eUqFw = parcelRequire("eUqFw");

var $gUUjF = parcelRequire("gUUjF");

var $gd0Sp = parcelRequire("gd0Sp");

var $65uQX = parcelRequire("65uQX");
const $b40c4387cd757cd5$export$9da409beb25e67da = ()=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let tenantContext;
    try {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        tenantContext = (0, $gd0Sp.useTenantContext)();
    } catch (e) {
        (0, $gUUjF.default).safeErrorWithoutCustomerData('jsis-ec-client', `tenant context : ${e?.toString() || ''}`);
    }
    (0, $eUqFw.useEffect)(()=>{
        (0, $65uQX.EcClient).setTenantDetails(tenantContext?.activationId, tenantContext?.cloudId, tenantContext?.atlassianAccountId);
    }, [
        tenantContext
    ]);
    const saveIssueMutationToCache = (0, $eUqFw.useCallback)((issueMutation, key = {
        analyticsMetadata: {
            scenario: 'unknown'
        }
    }, analyticsFailureEventObj = {})=>(0, $65uQX.default).saveIssueMutationToCache(issueMutation, key, analyticsFailureEventObj), []);
    const saveIssueMutationsToCache = (0, $eUqFw.useCallback)((issueMutations, key = {
        analyticsMetadata: {
            scenario: 'unknown'
        }
    }, analyticsFailureEventObj = {})=>(0, $65uQX.default).saveIssueMutationsToCache(issueMutations, key, analyticsFailureEventObj), []);
    const searchAndReconcile = (0, $eUqFw.useCallback)((matchApiUrl, jqlMatchingKey, search, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    parseIssueData, capability)=>(0, $65uQX.default).searchAndReconcile(matchApiUrl, jqlMatchingKey, search, parseIssueData, capability), []);
    const getIssueMutationFromCache = (key)=>(0, $65uQX.default).getIssueMutationFromCache(key);
    return {
        saveIssueMutationToCache: saveIssueMutationToCache,
        saveIssueMutationsToCache: saveIssueMutationsToCache,
        searchAndReconcile: searchAndReconcile,
        getIssueMutationFromCache: getIssueMutationFromCache
    };
};

});

parcelRegister("5P2vG", function(module, exports) {

$parcel$export(module.exports, "default", () => $07e17df61a3b69d4$export$2e2bcd8739ae039);

var $aUSBv = parcelRequire("aUSBv");

var $1ybV0 = parcelRequire("1ybV0");

var $3FyZ4 = parcelRequire("3FyZ4");

var $48mPv = parcelRequire("48mPv");

var $4qvSX = parcelRequire("4qvSX");

var $jmIuM = parcelRequire("jmIuM");
class $07e17df61a3b69d4$export$2e2bcd8739ae039 {
    constructor(props){
        this.events = props.events;
        this.analyticsEventObj = props.analyticsEventObj;
        this.ecClientObj = props.ecClientObj;
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        this.ecClientIIC = ()=>{};
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        this.ecClientGIC = ()=>{};
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        this.ecClientEpicIssueAdded = ()=>{};
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        this.ecClientVersionIssueAdded = ()=>{};
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        this.ecClientVersion = ()=>{};
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        this.ecClientEpic = ()=>{};
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        this.ecClientSplitIssue = ()=>{};
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        this.ecClientIssueRank = ()=>{};
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        this.ecClientIssueTransition = ()=>{};
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        this.ecClientIssueFlagged = ()=>{};
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        this.ecClientRemovingIssuesFromSprint = ()=>{};
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        this.ecClientIssueDelete = ()=>{};
    }
    static generateIssueMutations(issueIds, mutationSource, issueVersion, matchStatus, timeOfMutation) {
        const issueMutations = [];
        issueIds.forEach((issueId)=>{
            issueMutations.push(new (0, $48mPv.default)(issueId.toString(), mutationSource, issueVersion, matchStatus, timeOfMutation));
        });
        return issueMutations;
    }
    /**
	 * A util method to create a handler used to save issue mutations in cache
	 * It also fires analytics events in case of errors
	 */ async createHandler(experience, payload, handlerData, event) {
        try {
            if (!this.analyticsEventObj) {
                const analyticsClient = await (0, $3FyZ4.getAnalyticsWebClientPromise)();
                // @ts-expect-error Type 'AnalyticsWebClient' is missing the following properties from type 'UIAnalyticsEvent': context, handlers, hasFired, _isUIAnalyticsEvent, and 5 more
                this.analyticsEventObj = analyticsClient.getInstance();
            }
            const customKeys = {
                boardId: (0, $aUSBv.getBoardId)(window.location.href) || '',
                boardType: window.GH?.RapidBoard?.State?.getBoardTypeForAnalytics() || ''
            };
            const analyticsDataKey = {
                analyticsEventObj: this.analyticsEventObj,
                analyticsMetadata: {
                    ...(0, $4qvSX.createAnalyticsMetadata)(customKeys),
                    scenario: event.type
                }
            };
            const experiences = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            (0, $1ybV0.getFeatureFlagValue)('odin.ec.client.integration.cbb', '').split(',');
            if (!experiences || !experiences.includes(experience)) return new Promise((resolve)=>resolve());
            if (experience === 'inline-issue-create' || experience === 'modify-version' || experience === 'modify-epic' || experience === 'delete-issues') {
                await this.ecClientObj.saveIssueMutationToCache(new (0, $48mPv.default)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                payload, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                handlerData.mutationSource, handlerData.issueVersion, handlerData.matchStatus, handlerData.timeOfMutation), analyticsDataKey, {
                    ...handlerData.analyticsObject
                });
                return new Promise((resolve)=>resolve());
            }
            if (experience === 'global-issue-create' && /* eslint-disable @typescript-eslint/consistent-type-assertions */ payload.attributes.feature !== 'IIC') {
                await this.ecClientObj.saveIssueMutationToCache(new (0, $48mPv.default)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                payload.objectId, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                handlerData.mutationSource, handlerData.issueVersion, handlerData.matchStatus, handlerData.timeOfMutation), analyticsDataKey, {
                    ...handlerData.analyticsObject
                });
                return new Promise((resolve)=>resolve());
            }
            if (experience === 'split-issues') {
                const issueMutations = $07e17df61a3b69d4$export$2e2bcd8739ae039.generateIssueMutations(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                payload.newIssueId, /* eslint-disable @typescript-eslint/consistent-type-assertions */ handlerData.mutationSource/* eslint-enable @typescript-eslint/consistent-type-assertions */ .newIssues, handlerData.issueVersion, handlerData.matchStatus, handlerData.timeOfMutation);
                if ((0, $1ybV0.ff)('odin.enable.backend.cache.ec.client')) {
                    issueMutations.push(new (0, $48mPv.default)(/* eslint-disable @typescript-eslint/consistent-type-assertions */ payload/* eslint-enable @typescript-eslint/consistent-type-assertions */ .oldIssueId.toString(), /* eslint-disable @typescript-eslint/consistent-type-assertions */ handlerData.mutationSource/* eslint-enable @typescript-eslint/consistent-type-assertions */ .originalIssue, handlerData.issueVersion, handlerData.matchStatus, handlerData.timeOfMutation));
                    await this.ecClientObj.saveIssueMutationsToCache(issueMutations, analyticsDataKey, {
                        ...handlerData.analyticsObject
                    });
                } else {
                    await this.ecClientObj.saveIssueMutationToCache(new (0, $48mPv.default)(/* eslint-disable @typescript-eslint/consistent-type-assertions */ payload/* eslint-enable @typescript-eslint/consistent-type-assertions */ .oldIssueId.toString(), /* eslint-disable @typescript-eslint/consistent-type-assertions */ handlerData.mutationSource.originalIssue, /* eslint-enable @typescript-eslint/consistent-type-assertions */ handlerData.issueVersion, handlerData.matchStatus, handlerData.timeOfMutation), analyticsDataKey, {
                        ...handlerData.analyticsObject
                    });
                    await this.ecClientObj.saveIssueMutationsToCache(issueMutations, analyticsDataKey, {
                        ...handlerData.analyticsObject
                    });
                }
                return new Promise((resolve)=>resolve());
            }
            if (experience === 'flag-issues' || experience === 'remove-from-sprint-issues' || experience === 'rank-issues' || experience === 'issue-drop-in-epic' || experience === 'issue-drop-in-version' || experience === 'drag-amongst-columns-issues') {
                const issueMutations = $07e17df61a3b69d4$export$2e2bcd8739ae039.generateIssueMutations(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                payload.issueIds, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                handlerData.mutationSource, handlerData.issueVersion, handlerData.matchStatus, handlerData.timeOfMutation);
                await this.ecClientObj.saveIssueMutationsToCache(issueMutations, analyticsDataKey, {
                    ...handlerData.analyticsObject
                });
                return new Promise((resolve)=>resolve());
            }
            return new Promise((resolve)=>resolve());
        } catch (e) {
            return new Promise((resolve)=>resolve());
        }
    }
    /**
	 * A util method to define callbacks which are to be bind with the events.
	 * Each time the event is triggered, these callbacks will be fired in response to that
	 */ createCallback(experience, handlerData) {
        if (experience === 'inline-issue-create') // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return (event, payload)=>{
            this.createHandler(experience, payload?.issueId, handlerData, event);
        };
        if (experience === 'global-issue-create') // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return (event, payload)=>{
            this.createHandler(experience, payload, handlerData, event);
        };
        if (experience === 'issue-drop-in-epic') // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return (event, payload)=>{
            this.createHandler(experience, payload, handlerData, event);
        };
        if (experience === 'issue-drop-in-version') // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return (event, payload)=>{
            this.createHandler(experience, payload, handlerData, event);
        };
        if (experience === 'modify-version') // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return (event, payload)=>{
            this.createHandler(experience, payload?.toString(), handlerData, event);
        };
        if (experience === 'modify-epic') // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return (event, payload)=>{
            this.createHandler(experience, payload?.toString(), handlerData, event);
        };
        if (experience === 'split-issues') // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return (event, payload)=>{
            this.createHandler(experience, payload, handlerData, event);
        };
        if (experience === 'rank-issues') // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return (event, payload)=>{
            this.createHandler(experience, payload, handlerData, event);
        };
        if (experience === 'drag-amongst-columns-issues') // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return (event, payload)=>{
            this.createHandler(experience, payload, handlerData, event);
        };
        if (experience === 'flag-issues') // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return (event, payload)=>{
            this.createHandler(experience, payload, handlerData, event);
        };
        if (experience === 'remove-from-sprint-issues') // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return (event, payload)=>{
            this.createHandler(experience, payload, handlerData, event);
        };
        if (experience === 'delete-issues') // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return (event, payload)=>{
            this.createHandler(experience, payload, handlerData, event);
        };
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ()=>{};
    }
    /**
	 * A method to intialize all the callbacks
	 */ initialize() {
        this.ecClientIIC = this.createCallback('inline-issue-create', (0, $jmIuM.eventsDataBacklogAndBoard).ecClientIIC);
        this.ecClientGIC = this.createCallback('global-issue-create', (0, $jmIuM.eventsDataBacklogAndBoard).ecClientGIC);
        this.ecClientEpic = this.createCallback('modify-epic', (0, $jmIuM.eventsDataBacklogAndBoard).ecClientEpic);
        this.ecClientEpicIssueAdded = this.createCallback('issue-drop-in-epic', (0, $jmIuM.eventsDataBacklogAndBoard).ecClientEpicIssueAdded);
        this.ecClientVersionIssueAdded = this.createCallback('issue-drop-in-version', (0, $jmIuM.eventsDataBacklogAndBoard).ecClientVersionIssueAdded);
        this.ecClientVersion = this.createCallback('modify-version', (0, $jmIuM.eventsDataBacklogAndBoard).ecClientVersion);
        this.ecClientSplitIssue = this.createCallback('split-issues', (0, $jmIuM.eventsDataBacklogAndBoard).ecClientSplitIssue);
        this.ecClientIssueRank = this.createCallback('rank-issues', (0, $jmIuM.eventsDataBacklogAndBoard).ecClientIssueRank);
        this.ecClientIssueTransition = this.createCallback('drag-amongst-columns-issues', (0, $jmIuM.eventsDataBacklogAndBoard).ecClientIssueTransition);
        this.ecClientIssueFlagged = this.createCallback('flag-issues', (0, $jmIuM.eventsDataBacklogAndBoard).ecClientIssueFlagged);
        this.ecClientRemovingIssuesFromSprint = this.createCallback('remove-from-sprint-issues', (0, $jmIuM.eventsDataBacklogAndBoard).ecClientRemovingIssuesFromSprint);
        this.ecClientIssueDelete = this.createCallback('delete-issues', (0, $jmIuM.eventsDataBacklogAndBoard).ecClientIssueDelete);
    }
    /**
	 * A method to bind the callbacks with the events that are being fired
	 */ bind() {
        this.events.bind((0, $jmIuM.eventsDataBacklogAndBoard).ecClientIIC.captureEventName, this.ecClientIIC);
        this.events.bind((0, $jmIuM.eventsDataBacklogAndBoard).ecClientGIC.captureEventName, this.ecClientGIC);
        this.events.bind((0, $jmIuM.eventsDataBacklogAndBoard).ecClientEpicIssueAdded.captureEventName, this.ecClientEpicIssueAdded);
        this.events.bind((0, $jmIuM.eventsDataBacklogAndBoard).ecClientVersionIssueAdded.captureEventName, this.ecClientVersionIssueAdded);
        this.events.bind((0, $jmIuM.eventsDataBacklogAndBoard).ecClientVersion.captureEventName, this.ecClientVersion);
        this.events.bind((0, $jmIuM.eventsDataBacklogAndBoard).ecClientEpic.captureEventName, this.ecClientEpic);
        this.events.bind((0, $jmIuM.eventsDataBacklogAndBoard).ecClientSplitIssue.captureEventName, this.ecClientSplitIssue);
        this.events.bind((0, $jmIuM.eventsDataBacklogAndBoard).ecClientIssueRank.captureEventName, this.ecClientIssueRank);
        this.events.bind((0, $jmIuM.eventsDataBacklogAndBoard).ecClientIssueTransition.captureEventName, this.ecClientIssueTransition);
        this.events.bind((0, $jmIuM.eventsDataBacklogAndBoard).ecClientIssueFlagged.captureEventName, this.ecClientIssueFlagged);
        this.events.bind((0, $jmIuM.eventsDataBacklogAndBoard).ecClientRemovingIssuesFromSprint.captureEventName, this.ecClientRemovingIssuesFromSprint);
        this.events.bind((0, $jmIuM.eventsDataBacklogAndBoard).ecClientIssueDelete.captureEventName, this.ecClientIssueDelete);
    }
    /**
	 * A method to unbind the callbacks with the events that are being fired
	 */ unbind() {
        this.events.unbind((0, $jmIuM.eventsDataBacklogAndBoard).ecClientIIC.captureEventName, this.ecClientIIC);
        this.events.unbind((0, $jmIuM.eventsDataBacklogAndBoard).ecClientGIC.captureEventName, this.ecClientGIC);
        this.events.unbind((0, $jmIuM.eventsDataBacklogAndBoard).ecClientEpicIssueAdded.captureEventName, this.ecClientEpicIssueAdded);
        this.events.unbind((0, $jmIuM.eventsDataBacklogAndBoard).ecClientVersionIssueAdded.captureEventName, this.ecClientVersionIssueAdded);
        this.events.unbind((0, $jmIuM.eventsDataBacklogAndBoard).ecClientVersion.captureEventName, this.ecClientVersion);
        this.events.unbind((0, $jmIuM.eventsDataBacklogAndBoard).ecClientEpic.captureEventName, this.ecClientEpic);
        this.events.unbind((0, $jmIuM.eventsDataBacklogAndBoard).ecClientSplitIssue.captureEventName, this.ecClientSplitIssue);
        this.events.unbind((0, $jmIuM.eventsDataBacklogAndBoard).ecClientIssueRank.captureEventName, this.ecClientIssueRank);
        this.events.unbind((0, $jmIuM.eventsDataBacklogAndBoard).ecClientIssueTransition.captureEventName, this.ecClientIssueTransition);
        this.events.unbind((0, $jmIuM.eventsDataBacklogAndBoard).ecClientIssueFlagged.captureEventName, this.ecClientIssueFlagged);
        this.events.unbind((0, $jmIuM.eventsDataBacklogAndBoard).ecClientRemovingIssuesFromSprint.captureEventName, this.ecClientRemovingIssuesFromSprint);
        this.events.unbind((0, $jmIuM.eventsDataBacklogAndBoard).ecClientIssueDelete.captureEventName, this.ecClientIssueDelete);
    }
}

});
parcelRegister("jmIuM", function(module, exports) {

$parcel$export(module.exports, "eventsDataBacklogAndBoard", () => $43de273624cdb894$export$f0195549881a6853);

var $d7Wfe = parcelRequire("d7Wfe");
const $43de273624cdb894$export$f0195549881a6853 = {
    ecClientIIC: {
        captureEventName: 'inlineIssueCreatedOnBacklog',
        mutationSource: (0, $d7Wfe.MutationSource).CREATE,
        issueVersion: '1',
        matchStatus: [],
        timeOfMutation: new Date().toISOString(),
        eventName: 'jira-frontend.classic-software.controllers.rapidboard-state.issue.mutated',
        analyticsObject: {
            errorMsg: 'FAILED_IIC',
            error: true
        }
    },
    ecClientGIC: {
        captureEventName: 'legacyIssueCreated',
        mutationSource: (0, $d7Wfe.MutationSource).CREATE,
        issueVersion: '1',
        matchStatus: [],
        timeOfMutation: new Date().toISOString(),
        eventName: 'jira-frontend.classic-software.controllers.rapidboard-state.issue.mutated',
        analyticsObject: {
            errorMsg: 'FAILED_GIC',
            error: true
        }
    },
    ecClientEpicIssueAdded: {
        captureEventName: 'issueAddedToEpic',
        mutationSource: (0, $d7Wfe.MutationSource).UPDATE,
        issueVersion: '1',
        matchStatus: [],
        timeOfMutation: new Date().toISOString(),
        eventName: 'jira-frontend.classic-software.controllers.rapidboard-state.issue.mutated',
        analyticsObject: {
            errorMsg: 'FAILED_ISSUE_EPIC',
            error: true
        }
    },
    ecClientVersionIssueAdded: {
        captureEventName: 'issueAddedToVersion',
        mutationSource: (0, $d7Wfe.MutationSource).UPDATE,
        issueVersion: '1',
        matchStatus: [],
        timeOfMutation: new Date().toISOString(),
        eventName: 'jira-frontend.classic-software.controllers.rapidboard-state.issue.mutated',
        analyticsObject: {
            errorMsg: 'FAILED_ISSUE_VERSION',
            error: true
        }
    },
    ecClientVersion: {
        captureEventName: 'versionModified',
        mutationSource: (0, $d7Wfe.MutationSource).UPDATE,
        issueVersion: '1',
        matchStatus: [],
        timeOfMutation: new Date().toISOString(),
        eventName: 'jira-frontend.classic-software.controllers.rapidboard-state.issue.mutated',
        analyticsObject: {
            errorMsg: 'FAILED_VERSION',
            error: true
        }
    },
    ecClientEpic: {
        captureEventName: 'epicChanged',
        mutationSource: (0, $d7Wfe.MutationSource).UPDATE,
        issueVersion: '1',
        matchStatus: [],
        timeOfMutation: new Date().toISOString(),
        eventName: 'jira-frontend.classic-software.controllers.rapidboard-state.issue.mutated',
        analyticsObject: {
            errorMsg: 'FAILED_EPIC',
            error: true
        }
    },
    ecClientSplitIssue: {
        captureEventName: 'issueSplit',
        mutationSource: {
            originalIssue: (0, $d7Wfe.MutationSource).UPDATE,
            newIssues: (0, $d7Wfe.MutationSource).CREATE
        },
        issueVersion: '1',
        matchStatus: [],
        timeOfMutation: new Date().toISOString(),
        eventName: 'jira-frontend.classic-software.controllers.rapidboard-state.issue.mutated',
        analyticsObject: {
            errorMsg: 'FAILED_SPLIT',
            error: true
        }
    },
    ecClientIssueRank: {
        captureEventName: 'issueRankChanged',
        mutationSource: (0, $d7Wfe.MutationSource).UPDATE,
        issueVersion: '1',
        matchStatus: [],
        timeOfMutation: new Date().toISOString(),
        eventName: 'jira-frontend.classic-software.controllers.rapidboard-state.issue.mutated',
        analyticsObject: {
            errorMsg: 'FAILED_ISSUE_RANK',
            error: true
        }
    },
    ecClientIssueTransition: {
        captureEventName: 'issueTransitioned',
        mutationSource: (0, $d7Wfe.MutationSource).UPDATE,
        issueVersion: '1',
        matchStatus: [],
        timeOfMutation: new Date().toISOString(),
        eventName: 'jira-frontend.classic-software.controllers.rapidboard-state.issue.mutated',
        analyticsObject: {
            errorMsg: 'FAILED_ISSUE_TRANSITIONED',
            error: true
        }
    },
    ecClientRemovingIssuesFromSprint: {
        captureEventName: 'removedIssueFromSprint',
        mutationSource: (0, $d7Wfe.MutationSource).UPDATE,
        issueVersion: '1',
        matchStatus: [],
        timeOfMutation: new Date().toISOString(),
        eventName: 'jira-frontend.classic-software.controllers.rapidboard-state.issue.mutated',
        analyticsObject: {
            errorMsg: 'FAILED_REMOVE_FROM_SPRINT',
            error: true
        }
    },
    ecClientIssueFlagged: {
        captureEventName: 'flagIssueFromSprint',
        mutationSource: (0, $d7Wfe.MutationSource).UPDATE,
        issueVersion: '1',
        matchStatus: [],
        timeOfMutation: new Date().toISOString(),
        eventName: 'jira-frontend.classic-software.controllers.rapidboard-state.issue.mutated',
        analyticsObject: {
            errorMsg: 'FAILED_FLAG_UNFLAG',
            error: true
        }
    },
    ecClientIssueDelete: {
        captureEventName: 'issueDeleted',
        mutationSource: (0, $d7Wfe.MutationSource).DELETE,
        issueVersion: '1',
        matchStatus: [],
        timeOfMutation: new Date().toISOString(),
        eventName: 'jira-frontend.classic-software.controllers.rapidboard-state.issue.mutated',
        analyticsObject: {
            errorMsg: 'FAILED_DELETE',
            error: true
        }
    }
};

});




parcelRegister("1HT5A", function(module, exports) {

$parcel$export(module.exports, "setupConfigResources", () => $1d560fa48add3c5e$export$963012c7d2677232);
$parcel$export(module.exports, "setUpWrmData", () => $1d560fa48add3c5e$export$275cbf368775940c);
$parcel$export(module.exports, "setUpHistory", () => $1d560fa48add3c5e$export$7d0780c27da6c901);
$parcel$export(module.exports, "initDOM", () => $1d560fa48add3c5e$export$e96bbd4368cedb83);
$parcel$export(module.exports, "resetWorkControllerFilters", () => $1d560fa48add3c5e$export$674b9bcb259a86ae);
$parcel$export(module.exports, "renderRapidboardDom", () => $1d560fa48add3c5e$export$87937eecd895a618);
$parcel$export(module.exports, "afterRenderSetup", () => $1d560fa48add3c5e$export$3d209c045bb39744);

var $E0NNP = parcelRequire("E0NNP");

var $5Yqat = parcelRequire("5Yqat");

var $4QA2B = parcelRequire("4QA2B");

var $htljE = parcelRequire("htljE");

var $gCCx4 = parcelRequire("gCCx4");

var $8i1R8 = parcelRequire("8i1R8");

var $6ZDS2 = parcelRequire("6ZDS2");

var $fUTZC = parcelRequire("fUTZC");

var $fcWBJ = parcelRequire("fcWBJ");

var $6G5mG = parcelRequire("6G5mG");

var $8blac = parcelRequire("8blac");

var $hTLlD = parcelRequire("hTLlD");

var $feGjZ = parcelRequire("feGjZ");

var $4ZYEI = parcelRequire("4ZYEI");

var $4vTMF = parcelRequire("4vTMF");

var $8nrDO = parcelRequire("8nrDO");

var $iTvqy = parcelRequire("iTvqy");

var $eo8NR = parcelRequire("eo8NR");

var $aksMB = parcelRequire("aksMB");

var $8dloj = parcelRequire("8dloj");

var $03i9R = parcelRequire("03i9R");

var $3G3gn = parcelRequire("3G3gn");

var $a576Y = parcelRequire("a576Y");

var $14fFu = parcelRequire("14fFu");

var $gUUjF = parcelRequire("gUUjF");

var $3T07y = parcelRequire("3T07y");

var $cjsFv = parcelRequire("cjsFv");

var $eKEd6 = parcelRequire("eKEd6");

var $N5thU = parcelRequire("N5thU");
const $1d560fa48add3c5e$var$doHandshake = ()=>{
    window.dispatchEvent((0, $14fFu.default)((0, $3T07y.GH_SPA_RESOURCES_READY)));
    window.removeEventListener((0, $3T07y.GH_SPA_RB_READY), $1d560fa48add3c5e$var$doHandshake);
};
const $1d560fa48add3c5e$export$963012c7d2677232 = (dataPromise, key, update)=>{
    const { GH: GH } = window;
    if (!GH) return;
    GH.spa = GH.spa || {
        [(0, $3T07y.INITIAL_DATA)]: {}
    };
    GH.spa[0, $3T07y.CONFIG_DATA] = GH.spa[0, $3T07y.CONFIG_DATA] || {};
    if (dataPromise) {
        GH.spa[0, $3T07y.CONFIG_DATA][key] = dataPromise;
        GH.spa[0, $3T07y.CONFIG_DATA].key = key;
        GH.spa[0, $3T07y.CONFIG_DATA].refresh = (0, $N5thU.refresh);
        GH.spa[0, $3T07y.CONFIG_DATA].update = update;
    }
};
const $1d560fa48add3c5e$export$e402d0e4003b41fb = // eslint-disable-next-line @typescript-eslint/no-explicit-any
(win)=>(allDataPromise)=>{
        const { GH: GH } = win;
        if (!GH) return;
        GH.spa = GH.spa || {
            [(0, $3T07y.INITIAL_DATA)]: {}
        };
        if (allDataPromise) {
            GH.spa[0, $3T07y.INITIAL_DATA][0, $3T07y.ALL_DATA_PROMISE] = allDataPromise;
            win.addEventListener((0, $3T07y.GH_SPA_RB_READY), $1d560fa48add3c5e$var$doHandshake);
            win.dispatchEvent((0, $14fFu.default)((0, $3T07y.GH_SPA_RESOURCES_READY)));
        }
    };
const $1d560fa48add3c5e$export$275cbf368775940c = $1d560fa48add3c5e$export$e402d0e4003b41fb(window);
const $1d560fa48add3c5e$export$d1f98e05eef0997a = (win)=>(history, urlState)=>{
        const { GH: GH } = win;
        if (!GH) return;
        GH.spa = GH.spa || {
            [(0, $3T07y.INITIAL_DATA)]: {}
        };
        GH.spa.history = history;
        GH.spa.urlState = {
            ...urlState
        };
        GH.spa.lodash = {
            each: (/*@__PURE__*/$parcel$interopDefault($htljE)),
            forEach: (/*@__PURE__*/$parcel$interopDefault($fUTZC)),
            compact: (/*@__PURE__*/$parcel$interopDefault($5Yqat)),
            reject: (/*@__PURE__*/$parcel$interopDefault($03i9R)),
            extend: (/*@__PURE__*/$parcel$interopDefault($gCCx4)),
            isString: (/*@__PURE__*/$parcel$interopDefault($4ZYEI)),
            clone: (/*@__PURE__*/$parcel$interopDefault($E0NNP)),
            isEmpty: (/*@__PURE__*/$parcel$interopDefault($8blac)),
            kebabCase: (/*@__PURE__*/$parcel$interopDefault($4vTMF)),
            min: (/*@__PURE__*/$parcel$interopDefault($aksMB)),
            sortBy: (/*@__PURE__*/$parcel$interopDefault($3G3gn)),
            last: (/*@__PURE__*/$parcel$interopDefault($iTvqy)),
            groupBy: (/*@__PURE__*/$parcel$interopDefault($fcWBJ)),
            isObject: (/*@__PURE__*/$parcel$interopDefault($feGjZ)),
            map: (/*@__PURE__*/$parcel$interopDefault($eo8NR)),
            keys: (/*@__PURE__*/$parcel$interopDefault($8nrDO)),
            defaults: (/*@__PURE__*/$parcel$interopDefault($4QA2B)),
            find: (/*@__PURE__*/$parcel$interopDefault($8i1R8)),
            pick: (/*@__PURE__*/$parcel$interopDefault($8dloj)),
            has: (/*@__PURE__*/$parcel$interopDefault($6G5mG)),
            throttle: (/*@__PURE__*/$parcel$interopDefault($a576Y)),
            flatten: (/*@__PURE__*/$parcel$interopDefault($6ZDS2)),
            isEqual: (/*@__PURE__*/$parcel$interopDefault($hTLlD))
        };
        GH.spa.slaUtil = (0, $cjsFv.getSLAResult);
    };
const $1d560fa48add3c5e$export$7d0780c27da6c901 = $1d560fa48add3c5e$export$d1f98e05eef0997a(window);
const $1d560fa48add3c5e$export$eb9b2e269373b6d3 = (doc)=>(isBentoOn, projectKey, projectId)=>{
        const sidebarMeta = (0, $eKEd6.addMetaToHead)('ajs-sidebar-enabled', 'true');
        const atlGeneralMeta = (0, $eKEd6.addMetaToHead)('decorator', 'atl.general');
        const projectIdMeta = (0, $eKEd6.addMetaToHead)('ghx-project-id', projectId || '');
        const metaTags = [
            sidebarMeta,
            atlGeneralMeta,
            projectIdMeta
        ];
        if (projectKey != null && projectKey !== '') {
            const projectKeyMeta = (0, $eKEd6.addMetaToHead)('ghx-project-key', projectKey || '');
            metaTags.push(projectKeyMeta);
        } else {
            // SSR returns a project key meta tag for every SPA page so we need to manually remove it so rapidboards recognises the user context
            const projectKeyMeta = document.querySelector('meta[name="ghx-project-key"]');
            projectKeyMeta && projectKeyMeta.parentNode && projectKeyMeta.parentNode.removeChild(projectKeyMeta);
            const userMetaTag = (0, $eKEd6.addMetaToHead)('ghx-container-type', 'USER');
            metaTags.push(userMetaTag);
        }
        if (doc.body) {
            const documentBody = doc.body;
            documentBody.classList.remove('adg3');
            [
                'aui-layout',
                'aui-theme-default',
                'adg3',
                'ghx-agile'
            ].forEach((className)=>{
                documentBody.classList.add(className);
            });
            const bentoMeta = (0, $eKEd6.addMetaToHead)('ghx-user-bento-enabled', 'true');
            metaTags.push(bentoMeta);
            (0, $eKEd6.addDivToDom)((0, $3T07y.BENTO_ROOT));
            documentBody.classList.add('bento-enabled');
            documentBody.classList.add('ghx-ondemand');
        } else (0, $gUUjF.default).safeErrorWithoutCustomerData('rapidboard-status.utils.set-up', 'body not in the dom');
        // @ts-expect-error - TS2322 - Type 'Element[]' is not assignable to type 'HTMLElement[]'.
        return metaTags;
    };
const $1d560fa48add3c5e$export$e96bbd4368cedb83 = $1d560fa48add3c5e$export$eb9b2e269373b6d3(document);
const $1d560fa48add3c5e$export$674b9bcb259a86ae = ()=>{
    const { GH: GH } = window;
    if (GH && GH.WorkController) {
        GH.WorkController.activeFilters.searchText = '';
        GH.WorkController.activeFilters.assigneeList = [];
    }
};
const $1d560fa48add3c5e$export$87937eecd895a618 = (isWorkMode = false)=>{
    const { AJS: AJS, GH: GH } = window;
    AJS.$('body').removeClass('ghx-board-configure');
    AJS.$('#gh').html(GH.tpl.board.x.renderRapidBoard({
        isWorkMode: isWorkMode
    }));
    AJS.$('#ghx-operations').append(GH.tpl.viewcontroller.renderOperationsBar());
};
const $1d560fa48add3c5e$export$3d209c045bb39744 = ()=>{
    const { GH: GH, AJS: AJS } = window;
    AJS.$(window).off([
        'blur.rapidboardSpa',
        'unload.rapidboardSpa',
        'focus.rapidboardSpa'
    ].join(' '));
    GH?.windowActivityNotifier?._bindFocusBlur();
    /**
	 * We need to unregister the SPA global issue create event handlers so that rapidboard can use its
	 * default ones which render the success and error flag in a different place.
	 *
	 * NOTE: do not destructure this above to avoid confusing the bundler.
	 */ window.require('jira/common/header').unbind();
};

});
parcelRegister("E0NNP", function(module, exports) {

var $ee7Ev = parcelRequire("ee7Ev");
/** Used to compose bitmasks for cloning. */ var $07845bdb18fff27f$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */ function $07845bdb18fff27f$var$clone(value) {
    return $ee7Ev(value, $07845bdb18fff27f$var$CLONE_SYMBOLS_FLAG);
}
module.exports = $07845bdb18fff27f$var$clone;

});

parcelRegister("5Yqat", function(module, exports) {
/**
 * Creates an array with all falsey values removed. The values `false`, `null`,
 * `0`, `""`, `undefined`, and `NaN` are falsey.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to compact.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * _.compact([0, 1, false, 2, '', 3]);
 * // => [1, 2, 3]
 */ function $4596dac18914dac8$var$compact(array) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (value) result[resIndex++] = value;
    }
    return result;
}
module.exports = $4596dac18914dac8$var$compact;

});

parcelRegister("htljE", function(module, exports) {

module.exports = (parcelRequire("fUTZC"));

});

parcelRegister("gCCx4", function(module, exports) {

module.exports = (parcelRequire("8QOTu"));

});
parcelRegister("8QOTu", function(module, exports) {

var $i31gq = parcelRequire("i31gq");

var $3Bqj8 = parcelRequire("3Bqj8");

var $5ovM8 = parcelRequire("5ovM8");
/**
 * This method is like `_.assign` except that it iterates over own and
 * inherited source properties.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @alias extend
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assign
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assignIn({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
 */ var $671aa88e1b2e86b3$var$assignIn = $3Bqj8(function(object, source) {
    $i31gq(source, $5ovM8(source), object);
});
module.exports = $671aa88e1b2e86b3$var$assignIn;

});


parcelRegister("8i1R8", function(module, exports) {

var $e5OGm = parcelRequire("e5OGm");

var $k61d1 = parcelRequire("k61d1");
/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */ var $609171b9cff1596d$var$find = $e5OGm($k61d1);
module.exports = $609171b9cff1596d$var$find;

});
parcelRegister("e5OGm", function(module, exports) {

var $7qARj = parcelRequire("7qARj");

var $jxg5X = parcelRequire("jxg5X");

var $8nrDO = parcelRequire("8nrDO");
/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */ function $a428d8bbecbff7a6$var$createFind(findIndexFunc) {
    return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!$jxg5X(collection)) {
            var iteratee = $7qARj(predicate, 3);
            collection = $8nrDO(collection);
            predicate = function(key) {
                return iteratee(iterable[key], key, iterable);
            };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
    };
}
module.exports = $a428d8bbecbff7a6$var$createFind;

});

parcelRegister("k61d1", function(module, exports) {

var $9mB9u = parcelRequire("9mB9u");

var $7qARj = parcelRequire("7qARj");

var $hNahz = parcelRequire("hNahz");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $ea154e499f779271$var$nativeMax = Math.max;
/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */ function $ea154e499f779271$var$findIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = fromIndex == null ? 0 : $hNahz(fromIndex);
    if (index < 0) index = $ea154e499f779271$var$nativeMax(length + index, 0);
    return $9mB9u(array, $7qARj(predicate, 3), index);
}
module.exports = $ea154e499f779271$var$findIndex;

});


parcelRegister("aksMB", function(module, exports) {

var $77fbL = parcelRequire("77fbL");

var $iDjne = parcelRequire("iDjne");

var $3QMTK = parcelRequire("3QMTK");
/**
 * Computes the minimum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the minimum value.
 * @example
 *
 * _.min([4, 2, 8, 6]);
 * // => 2
 *
 * _.min([]);
 * // => undefined
 */ function $7852195066d5c66c$var$min(array) {
    return array && array.length ? $77fbL(array, $3QMTK, $iDjne) : undefined;
}
module.exports = $7852195066d5c66c$var$min;

});
parcelRegister("77fbL", function(module, exports) {

var $8aco7 = parcelRequire("8aco7");
/**
 * The base implementation of methods like `_.max` and `_.min` which accepts a
 * `comparator` to determine the extremum value.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The iteratee invoked per iteration.
 * @param {Function} comparator The comparator used to compare values.
 * @returns {*} Returns the extremum value.
 */ function $52e4f805c3622ecd$var$baseExtremum(array, iteratee, comparator) {
    var index = -1, length = array.length;
    while(++index < length){
        var value = array[index], current = iteratee(value);
        if (current != null && (computed === undefined ? current === current && !$8aco7(current) : comparator(current, computed))) var computed = current, result = value;
    }
    return result;
}
module.exports = $52e4f805c3622ecd$var$baseExtremum;

});

parcelRegister("iDjne", function(module, exports) {
/**
 * The base implementation of `_.lt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is less than `other`,
 *  else `false`.
 */ function $d90ae5b52ef23625$var$baseLt(value, other) {
    return value < other;
}
module.exports = $d90ae5b52ef23625$var$baseLt;

});


parcelRegister("03i9R", function(module, exports) {

var $904yO = parcelRequire("904yO");

var $9vvKC = parcelRequire("9vvKC");

var $7qARj = parcelRequire("7qARj");

var $1c8hB = parcelRequire("1c8hB");

var $bRX4x = parcelRequire("bRX4x");
/**
 * The opposite of `_.filter`; this method returns the elements of `collection`
 * that `predicate` does **not** return truthy for.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.filter
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': false },
 *   { 'user': 'fred',   'age': 40, 'active': true }
 * ];
 *
 * _.reject(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.reject(users, { 'age': 40, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.reject(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.reject(users, 'active');
 * // => objects for ['barney']
 */ function $009e5dc1ea78ed8e$var$reject(collection, predicate) {
    var func = $1c8hB(collection) ? $904yO : $9vvKC;
    return func(collection, $bRX4x($7qARj(predicate, 3)));
}
module.exports = $009e5dc1ea78ed8e$var$reject;

});
parcelRegister("9vvKC", function(module, exports) {

var $awetI = parcelRequire("awetI");
/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $6ebfa35ee06f887f$var$baseFilter(collection, predicate) {
    var result = [];
    $awetI(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) result.push(value);
    });
    return result;
}
module.exports = $6ebfa35ee06f887f$var$baseFilter;

});


parcelRegister("cjsFv", function(module, exports) {

$parcel$export(module.exports, "getSLAResult", () => $ffe7b0757db7cdea$export$e631974996a4cdc0);

var $3T07y = parcelRequire("3T07y");

var $jT7aq = parcelRequire("jT7aq");
const $ffe7b0757db7cdea$var$isBoardLoadComplete = (rapidBoard)=>{
    if (rapidBoard === null) return false;
    const columns = rapidBoard.querySelectorAll('.ghx-swimlane.ghx-first .ghx-columns .ghx-column');
    const issues = rapidBoard.querySelectorAll('.ghx-issue');
    const emptyColumns = rapidBoard.querySelectorAll('.ghx-sad-columns .ghx-column');
    const emptyBoard = rapidBoard.querySelectorAll('.ghx-no-active-sprint-message');
    const { GH: GH } = window;
    const filters = GH && GH.WorkController?.activeFilters;
    const haveFiltersApplied = filters && filters?.assigneeList && filters.assigneeList.length > 0 || filters?.issueTypeList && filters.issueTypeList.length > 0 || filters?.searchText && filters.searchText.length > 0;
    const haveQuickFiltersApplied = GH?.WorkControls?.quickfilters && // @ts-expect-error - TS7006 - Parameter 'filter' implicitly has an 'any' type.
    GH.WorkControls.quickfilters.getQuickFilters().filter((filter)=>filter.isActive).length > 0;
    return emptyBoard.length === 1 || columns.length > 0 && (issues.length > 0 || haveFiltersApplied || haveQuickFiltersApplied) || emptyColumns.length > 0 && issues.length === 0;
};
const $ffe7b0757db7cdea$var$isBackLogLoadComplete = (rapidBoard)=>{
    if (rapidBoard === null) return false;
    const issues = rapidBoard.querySelectorAll('.ghx-backlog-card');
    const emptyBacklogMessage = rapidBoard.querySelectorAll('.ghx-onboarding-fillyourbacklog-group');
    const backlogHeader = rapidBoard.querySelectorAll('.ghx-backlog-header.js-marker-backlog-header');
    return issues.length > 0 || emptyBacklogMessage.length > 0 || issues.length === 0 && backlogHeader && backlogHeader.length >= 1;
};
const $ffe7b0757db7cdea$export$e631974996a4cdc0 = (statusCode, mode)=>{
    // Used in Legacy Code. Caution in modifying the params is required.
    const { GH: GH } = window;
    if (GH !== null && GH !== undefined) {
        if ((0, $jT7aq.isWorkMode)(mode) && $ffe7b0757db7cdea$var$isBoardLoadComplete(document.getElementById('ghx-work')) || (0, $jT7aq.isPlanningMode)(mode) && $ffe7b0757db7cdea$var$isBackLogLoadComplete(document.getElementById('ghx-backlog'))) return {
            state: (0, $3T07y.SUCCESS),
            statusCode: statusCode,
            href: window.location.href
        };
    }
    if (statusCode !== null) {
        if (statusCode >= 400 && statusCode < 500) return {
            state: (0, $3T07y.SUCCESS),
            statusCode: statusCode,
            href: window.location.href
        };
    }
    return {
        state: (0, $3T07y.FAILURE),
        statusCode: statusCode,
        href: window.location.href
    };
};

});

parcelRegister("eKEd6", function(module, exports) {

$parcel$export(module.exports, "addMetaToHead", () => $19743f69704c44fe$export$9e7e16a3dbced495);
$parcel$export(module.exports, "addDivToDom", () => $19743f69704c44fe$export$d0a7e6e6dd396a00);
const $19743f69704c44fe$export$9e7e16a3dbced495 = (name, value)=>{
    const existingMetaTag = document.querySelector(`meta[name="${name}"]`);
    const metaTag = existingMetaTag || document.createElement('meta');
    metaTag.setAttribute('name', name);
    metaTag.setAttribute('content', value);
    if (!existingMetaTag) document.head && document.head.insertBefore(metaTag, document.head.childNodes[0]);
    return metaTag;
};
const $19743f69704c44fe$export$d0a7e6e6dd396a00 = (id)=>{
    if (document.body && !document.getElementById(id)) {
        const documentBody = document.body;
        const div = document.createElement('div');
        div.setAttribute('id', id);
        documentBody.insertBefore(div, documentBody.lastChild);
    }
};

});

parcelRegister("N5thU", function(module, exports) {

$parcel$export(module.exports, "refresh", () => $eb260dc44af7c54a$export$2d6e9b4c68afb6c8);

var $2OdyW = parcelRequire("2OdyW");
const $eb260dc44af7c54a$var$getUrl = (url, query)=>{
    const queryParams = new URLSearchParams(query).toString();
    return url.indexOf('?') > 0 ? `${url}&${queryParams}` : `${url}?${queryParams}`;
};
const $eb260dc44af7c54a$export$dbfe50710819f38 = 300; // Avoid subsequent call happening within 300ms
const $eb260dc44af7c54a$var$refreshWrapper = ({ stallTimeout: stallTimeout })=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const reqCache = {};
    const getXHRData = (key)=>{
        const data = {
            timestamp: 0
        };
        if (reqCache[key]) return reqCache[key];
        reqCache[key] = data;
        return reqCache[key];
    };
    const clearXHRMap = (key)=>{
        const reqCacheKeyMap = getXHRData(key);
        if (reqCacheKeyMap.xhr) {
            delete reqCacheKeyMap.xhr;
            delete reqCacheKeyMap.abortController;
        }
    };
    const executeRequest = (key, finalUrl)=>{
        const reqCacheKeyMap = getXHRData(key);
        const abortController = new AbortController();
        reqCacheKeyMap.abortController = abortController;
        return (0, $2OdyW.default)(finalUrl, {
            method: 'GET',
            signal: reqCacheKeyMap.abortController.signal
        }).then((res)=>{
            clearXHRMap(key);
            return res;
        }).catch((err)=>{
            clearXHRMap(key);
            // request successfully completed, remove xhr object from registry
            throw err;
        });
    };
    const makeAPICall = (options)=>{
        const { key: key, url: url, query: query } = options;
        const reqCacheKeyMap = getXHRData(key);
        if (reqCacheKeyMap.xhr) {
            // Call is already in progress so kill the previous one
            reqCacheKeyMap.abortController?.abort();
            delete reqCacheKeyMap.xhr;
            clearTimeout(reqCacheKeyMap.timeoutId); //
            reqCacheKeyMap.timeoutId = null;
        }
        // Check whether call is made within stallTimeout
        const { timestamp: timestamp } = reqCacheKeyMap;
        reqCacheKeyMap.timestamp = Date.now();
        if (reqCacheKeyMap.timestamp - timestamp < stallTimeout) {
            // Call is make recently
            // WIll schedule the next call after stallTimeout  time
            reqCacheKeyMap.timeoutId = setTimeout(()=>{
                reqCacheKeyMap.xhr = makeAPICall(options);
            }, stallTimeout);
            // Add mock xhr value to reqCacheKeyMap so that if the call happens within 5 min it will clear all those
            clearXHRMap(key);
            reqCacheKeyMap.xhr = Promise.resolve();
        } else reqCacheKeyMap.xhr = executeRequest(key, $eb260dc44af7c54a$var$getUrl(url, query));
        return reqCacheKeyMap.xhr;
    };
    return {
        makeAPICall: makeAPICall,
        getXHRData: getXHRData
    };
};
let $eb260dc44af7c54a$var$refreshCache = null;
const $eb260dc44af7c54a$var$getRefreshCache = ({ stallTimeout: stallTimeout })=>{
    const stallTime = stallTimeout !== undefined ? stallTimeout : $eb260dc44af7c54a$export$dbfe50710819f38;
    if ($eb260dc44af7c54a$var$refreshCache === null) $eb260dc44af7c54a$var$refreshCache = $eb260dc44af7c54a$var$refreshWrapper({
        stallTimeout: stallTime
    });
    return $eb260dc44af7c54a$var$refreshCache;
};
const $eb260dc44af7c54a$export$2d6e9b4c68afb6c8 = (options)=>{
    const cache = $eb260dc44af7c54a$var$getRefreshCache({
        stallTimeout: options.stallTimeout
    });
    return cache.makeAPICall(options);
};
const $eb260dc44af7c54a$export$624505b4e8def1c0 = (key, stallTimeout)=>{
    const cache = $eb260dc44af7c54a$var$getRefreshCache({
        stallTimeout: stallTimeout
    });
    return cache.getXHRData(key);
};
const $eb260dc44af7c54a$export$fd16eac4b058c4b4 = ()=>{
    $eb260dc44af7c54a$var$refreshCache = null;
};

});


parcelRegister("jAeda", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("5CHNc").then(()=>parcelRequire('lJSys'));

});



parcelRegister("3rlFA", function(module, exports) {

$parcel$export(module.exports, "ArchivedProjectRedirect", () => $c4611224216e7ea4$export$6e1a5929022745db);

var $eUqFw = parcelRequire("eUqFw");

var $SEaoU = parcelRequire("SEaoU");

var $eI64M = parcelRequire("eI64M");
const $c4611224216e7ea4$export$6e1a5929022745db = ()=>{
    const [{ data: data, error: error }] = (0, $SEaoU.useContainerContext)();
    // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
    const projectData = data && data.project || {};
    const { key: projectKey } = projectData;
    if (error || !data) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eI64M.default), {
        projectKey: projectKey || null
    });
};

});
parcelRegister("eI64M", function(module, exports) {

$parcel$export(module.exports, "isProjectArchivedCondition", () => $949f89d276fadb14$export$34040938aec58f90);
$parcel$export(module.exports, "RedirectToArchivedPage", () => $949f89d276fadb14$export$36db2ddf32573bd8);
$parcel$export(module.exports, "default", () => $949f89d276fadb14$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bNe1g = parcelRequire("bNe1g");

var $lB25E = parcelRequire("lB25E");

const $949f89d276fadb14$export$34040938aec58f90 = (projectContextData)=>projectContextData && projectContextData.isProjectArchived || false;
const $949f89d276fadb14$var$RedirectIfProjectArchived = ({ projectKey: projectKey })=>{
    if (projectKey === null) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bNe1g.ProjectContextProvider), null, (projectContext)=>$949f89d276fadb14$export$34040938aec58f90(projectContext.data) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
            to: (0, $8b47e2956ab1dffe$export$9a6ccb84170b615b)
        }) : null);
};
const $949f89d276fadb14$export$36db2ddf32573bd8 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
        to: (0, $8b47e2956ab1dffe$export$9a6ccb84170b615b)
    });
var $949f89d276fadb14$export$2e2bcd8739ae039 = $949f89d276fadb14$var$RedirectIfProjectArchived;

});
const $8b47e2956ab1dffe$export$9a6ccb84170b615b = '/jira/errors/project-archived';



parcelRegister("9m00l", function(module, exports) {

$parcel$export(module.exports, "DocumentTitle", () => $06178d8401f9a17e$export$dd5ad0b65cf665da);

var $eUqFw = parcelRequire("eUqFw");

var $heNSb = parcelRequire("heNSb");

var $4ksts = parcelRequire("4ksts");

var $SEaoU = parcelRequire("SEaoU");

var $dKMzK = parcelRequire("dKMzK");
const $06178d8401f9a17e$export$dd5ad0b65cf665da = ({ useIntl: useIntl = (0, $4ksts.useIntlV2), useContainerContext: useContainerContext = (0, $SEaoU.useContainerContext), GlobalDocumentTitle: // @ts-expect-error - TS2322 - Type 'typeof DocumentTitle' is not assignable to type 'ComponentType<{ title: string; }>'.
GlobalDocumentTitle = (0, $heNSb.DocumentTitle) })=>{
    const { formatMessage: formatMessage } = useIntl();
    const [{ data: data, error: error }] = useContainerContext();
    const boardName = data?.scope?.name;
    if (boardName == null || error) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(GlobalDocumentTitle, {
        title: `${boardName} - ${formatMessage((0, $dKMzK.messages).agileBoard)}`
    });
};

});
parcelRegister("heNSb", function(module, exports) {

$parcel$export(module.exports, "DocumentTitle", () => $44af95caa6ad02db$export$dd5ad0b65cf665da);

var $eUqFw = parcelRequire("eUqFw");

var $1TtYL = parcelRequire("1TtYL");

class $44af95caa6ad02db$export$dd5ad0b65cf665da extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            TitleSubscriber: (0, $1TtYL.DocumentTitleSubscriber)
        };
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.title !== this.props.title;
    }
    render() {
        const { title: title, TitleSubscriber: TitleSubscriber } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(TitleSubscriber, null, ({ contextArray: contextArray }, { setTitle: setTitle, addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1TtYL.DocumentTitleHelper), {
                title: title,
                setTitle: setTitle,
                addDocumentTitle: addDocumentTitle,
                contextArray: contextArray,
                removeDocumentTitle: removeDocumentTitle,
                TitleSubscriber: TitleSubscriber
            }));
    }
}

});

parcelRegister("dKMzK", function(module, exports) {

$parcel$export(module.exports, "messages", () => $72d7d4e68c759d25$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $72d7d4e68c759d25$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    agileBoard: {
        "id": "classic-software.document-title.agile-board",
        "defaultMessage": "Agile Board"
    }
});

});


parcelRegister("fhupA", function(module, exports) {

$parcel$export(module.exports, "NextGenRedirect", () => $3a1eb821dcca8e14$export$a35e559b9dc401ee);

var $eUqFw = parcelRequire("eUqFw");

var $SEaoU = parcelRequire("SEaoU");

var $lB25E = parcelRequire("lB25E");

var $g3DZb = parcelRequire("g3DZb");
const $3a1eb821dcca8e14$export$a35e559b9dc401ee = ()=>{
    const [{ data: data, error: error }] = (0, $SEaoU.useContainerContext)();
    const { boardId: boardId } = (0, $g3DZb.useUrlState)();
    if (error || !data) return null;
    const scopeId = data.scope && data.scope.id;
    if (// @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
    data.project && // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
    data.project.isSimplified && scopeId != null && scopeId === Number(boardId)) // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lB25E.Redirect), {
        to: `/jira/software/projects/${data.project.key}/boards/${scopeId}`
    });
    return null;
};

});

parcelRegister("d55eu", function(module, exports) {

$parcel$export(module.exports, "PerformanceMarks", () => $0b894ac21e88a4ef$export$c336aabab9fe0470);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $eZGdd = parcelRequire("eZGdd");

var $7vf5z = parcelRequire("7vf5z");

var $a5edq = parcelRequire("a5edq");

var $lB25E = parcelRequire("lB25E");

var $apShl = parcelRequire("apShl");

var $kQ5lq = parcelRequire("kQ5lq");

var $3syrf = parcelRequire("3syrf");

var $f9KPu = parcelRequire("f9KPu");
const $0b894ac21e88a4ef$export$c336aabab9fe0470 = ({ isRendered: isRendered, isInteractive: isInteractive })=>{
    const [{ route: route, query: query }] = (0, $lB25E.useRouter)();
    const { hasGHContextLoaded: hasGHContextLoaded } = (0, $3syrf.useWrmBundleLoader)();
    const { data: data } = (0, $kQ5lq.useRapidBoardResource)({
        resource: (0, $a5edq.getRapidBoardDataResource)()
    });
    const metric = (0, $f9KPu.getBM3Metric)(route.name);
    // @ts-expect-error - TS2339
    const allDataRequestTraceId = data?.allDataTraceId;
    const metricTag = metric && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7vf5z.default), {
        appName: route.name,
        key: route.name,
        extra: {
            allDataRequestTraceId: allDataRequestTraceId,
            ...(0, $f9KPu.getApdexAttributes)(query)
        },
        // @ts-expect-error - TS2769 - No overload matches this call.
        metric: metric,
        emitOnAnimationFrame: (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences'),
        waitForLongTaskIdleTTI: (0, $1ybV0.ff)('jsw-measure-tti-alternate')
    });
    if (!metricTag) // eslint-disable-next-line no-console
    console.warn('Performance metric not defined for this route');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $apShl.default), {
        name: "is-interactive",
        hold: !isInteractive
    }), hasGHContextLoaded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eZGdd.default), {
        name: "wrm_done"
    }), isRendered && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eZGdd.default), {
        name: "classic_software_ttr"
    }), isInteractive && route && metricTag);
};

});
parcelRegister("eZGdd", function(module, exports) {

$parcel$export(module.exports, "default", () => $1717fc440f3604c9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3viaK = parcelRequire("3viaK");

var $0S0fK = parcelRequire("0S0fK");
class $1717fc440f3604c9$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    render() {
        const { name: name } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0S0fK.default).Consumer, null, ({ pageId: pageId, onCustomMark: onCustomMark })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3viaK.default), {
                op: onCustomMark,
                args: [
                    name,
                    pageId
                ]
            }));
    }
}

});

parcelRegister("7vf5z", function(module, exports) {

$parcel$export(module.exports, "checkAndEmitApdexSignal", () => $074ba9858fda469d$export$3082c88b693a5230);
$parcel$export(module.exports, "default", () => $074ba9858fda469d$export$2e2bcd8739ae039);
$parcel$export(module.exports, "baseDefaultProps", () => $074ba9858fda469d$export$9b3029ee6188a41f);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $3iMaY = parcelRequire("3iMaY");

var $eJ3kO = parcelRequire("eJ3kO");

var $51JrV = parcelRequire("51JrV");

var $4nnPJ = parcelRequire("4nnPJ");

var $22iQy = parcelRequire("22iQy");

var $brm1D = parcelRequire("brm1D");

var $ifyPR = parcelRequire("ifyPR");

var $aS0xb = parcelRequire("aS0xb");

var $45wsB = parcelRequire("45wsB");
const $074ba9858fda469d$export$3082c88b693a5230 = (appName, metricKey)=>{
    var emitSignal;
};
class $074ba9858fda469d$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            isExpectedToHaveSsr: false,
            withMarks: [],
            extra: {},
            emitOnAnimationFrame: false
        };
    }
    render() {
        const { appName: appName, metricKey: metricKey, extra: extra, metric: metric, emitOnAnimationFrame: emitOnAnimationFrame, waitForLongTaskIdleTTI: waitForLongTaskIdleTTI } = this.props;
        $074ba9858fda469d$export$3082c88b693a5230(appName, metricKey);
        const isUFODefined = (0, $1ybV0.ff)('uip.ufo') && (0, $4nnPJ.GlobalPageLoadExperience).loadingPageLoadId !== 'UNKNOWN';
        if (isUFODefined) (0, $aS0xb.addUFOSSRDoneAsFMPToInteraction)();
        if (metric) {
            // https://product-fabric.atlassian.net/browse/UFO-323
            (0, $ifyPR.addBM3SSRDoneAsFMPToInteraction)(metric);
            (0, $45wsB.trackBM3FeatureFlagsAccessed)(metric);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3iMaY.default), {
            data: extra
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eJ3kO.UFOBM3TimingsToUFO), {
            marks: metric?.getData()?.marks,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            timings: metric?.getData()?.config?.timings
        }), isUFODefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $brm1D.StopUfo), {
            appName: appName,
            customData: extra,
            key: (0, $51JrV.getInteractionId)().current
        }) : metric && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $22iQy.StopBrowserMetrics3), {
            metric: metric,
            customData: extra,
            emitOnAnimationFrame: emitOnAnimationFrame,
            waitForLongTaskIdleTTI: waitForLongTaskIdleTTI
        }));
    }
}
const $074ba9858fda469d$export$9b3029ee6188a41f = $074ba9858fda469d$export$2e2bcd8739ae039.defaultProps;

});
parcelRegister("eJ3kO", function(module, exports) {

$parcel$export(module.exports, "getBm3Timings", () => $8841aa10a213faf4$export$f02972da195a43bb);
$parcel$export(module.exports, "UFOBM3TimingsToUFO", () => $8841aa10a213faf4$export$30f0b5e5acd268bf);
$parcel$export(module.exports, "addBM3TimingsToUFO", () => $8841aa10a213faf4$export$d93d677ef2f33c5c);

var $eUqFw = parcelRequire("eUqFw");

var $3Hphq = parcelRequire("3Hphq");

var $51JrV = parcelRequire("51JrV");

var $fYqUr = parcelRequire("fYqUr");
function $8841aa10a213faf4$export$f02972da195a43bb(marks, timingConfigs) {
    const bm3Timings = {};
    if (!marks || !timingConfigs) return bm3Timings;
    timingConfigs.forEach((item)=>{
        if (!item.startMark || !item.endMark) return;
        const startTime = marks[item.startMark];
        if (!startTime) return;
        const endTime = marks[item.endMark];
        if (!endTime) return;
        bm3Timings[item.key] = {
            startTime: startTime,
            endTime: endTime
        };
    });
    return bm3Timings;
}
function $8841aa10a213faf4$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
    const interactionContext = (0, $eUqFw.useContext)((0, $3Hphq.default));
    const interactionId = (0, $51JrV.getInteractionId)().current;
    (0, $eUqFw.useMemo)(()=>{
        if (interactionContext != null && interactionId != null && marks != null && timings != null) {
            const interactionType = (0, $fYqUr.getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $8841aa10a213faf4$export$f02972da195a43bb(marks, timings);
            interactionContext.addCustomTimings(bm3Timings);
        }
    }, [
        interactionContext,
        interactionId,
        marks,
        timings
    ]);
    return null;
}
function $8841aa10a213faf4$export$d93d677ef2f33c5c(marks, timingsConfig) {
    const interactionId = (0, $51JrV.getInteractionId)().current;
    if (interactionId) {
        const interactionType = (0, $fYqUr.getCurrentInteractionType)(interactionId);
        if (interactionType === 'press') return;
        const bm3Timings = $8841aa10a213faf4$export$f02972da195a43bb(marks, timingsConfig);
        (0, $fYqUr.addCustomTiming)(interactionId, [], bm3Timings);
    }
}

});

parcelRegister("22iQy", function(module, exports) {

$parcel$export(module.exports, "StopBrowserMetrics3", () => $c48b51f586335ad5$export$575e93c0f9905999);

var $eUqFw = parcelRequire("eUqFw");

var $acbV3 = parcelRequire("acbV3");

var $6iz4v = parcelRequire("6iz4v");

var $6xYPC = parcelRequire("6xYPC");

var $1ybV0 = parcelRequire("1ybV0");

var $cNlZD = parcelRequire("cNlZD");

var $6M8Uw = parcelRequire("6M8Uw");

var $2B87Z = parcelRequire("2B87Z");

var $87isp = parcelRequire("87isp");

var $3Hphq = parcelRequire("3Hphq");

const $c48b51f586335ad5$var$emitMetrics = (metric, customData, stopTime)=>{
    !(0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
    (0, $2B87Z.setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
    if (stopTime !== undefined) {
        if (!(0, $1ybV0.ff)('bm3.wait-for-long-task')) {
            metric.mark((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
            (0, $6iz4v.setMark)((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
            (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $37f655a4e4d5690e$export$99c08ec92759c71c));
        }
        metric.stop({
            customData: customData,
            stopTime: stopTime
        });
    } else metric.stop({
        customData: customData
    });
    if ((0, $87isp.isAutomaticExposureCollectionEnabled)()) (0, $6xYPC.stopLowPriorityEventDelay)();
};
class $c48b51f586335ad5$export$575e93c0f9905999 extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { metric: metric, customData: customData, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        if (!metric) return;
        const start = (0, $1ybV0.ff)('bm3.wait-for-long-task') ? (0, $acbV3.browserMetrics).getPageLoadMetric().getData()?.start || 0 : 0;
        (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_START', {
            startTime: start
        });
        (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_END');
        (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_END');
        const bm3Data = metric.getData();
        if (this.props.waitForLongTaskIdleTTI) {
            const stopTime = performance.now();
            (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
            (0, $cNlZD.getTTIValue)().then((tti)=>{
                (0, $cNlZD.resetTTIObserver)();
                (0, $6iz4v.setMark)('BROWSER_METRICS_LONG_TASK_TTI_END', {
                    startTime: tti
                });
                (0, $6iz4v.setMeasure)('BROWSER_METRICS_LONG_TASK_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_LONG_TASK_TTI_END');
                $c48b51f586335ad5$var$emitMetrics(metric, customData, stopTime);
            });
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
        } else if (emitOnAnimationFrame) {
            const stopTime = performance.now();
            (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
            if (typeof queueMicrotask !== 'undefined') queueMicrotask(()=>{
                (0, $6iz4v.setMark)('BROWSER_METRICS_TTI_TASK_END');
                (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_TASK', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_TASK_END');
            });
            requestAnimationFrame(()=>{
                if ((0, $1ybV0.ff)('bm3.wait-for-long-task')) {
                    metric.mark((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                    (0, $6iz4v.setMark)((0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                    (0, $6iz4v.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $37f655a4e4d5690e$export$99c08ec92759c71c));
                }
                if ((0, $1ybV0.ff)('bm3.wait-for-long-task')) setTimeout(()=>{
                    $c48b51f586335ad5$var$emitMetrics(metric, customData, stopTime);
                }, 500);
                else $c48b51f586335ad5$var$emitMetrics(metric, customData, stopTime);
            });
        } else {
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: performance.now()
            });
            (0, $1ybV0.ff)('bm3.emit-on-raf.top-experiences') && (0, $2B87Z.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $6M8Uw.PRODUCT_START_MARK), true);
            $c48b51f586335ad5$var$emitMetrics(metric, customData);
        }
    }
    static{
        this.contextType = (0, $3Hphq.default);
    }
    render() {
        return null;
    }
}

});
parcelRegister("cNlZD", function(module, exports) {

$parcel$export(module.exports, "resetTTIObserver", () => $2134fd1f8b4ec9b6$export$1250c0c41b64ee5c);
$parcel$export(module.exports, "startTTIObserver", () => $2134fd1f8b4ec9b6$export$d2209a9a3184ff99);
$parcel$export(module.exports, "getTTIValue", () => $2134fd1f8b4ec9b6$export$e67176cf000b0a2e);

var $ba8ih = parcelRequire("ba8ih");
// Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
let $2134fd1f8b4ec9b6$var$resolveTti = (_v)=>{};
let $2134fd1f8b4ec9b6$var$observerStarted = false;
/**
 * Initialize module state and return the promise a consumer can use to wait
 * for the TTI event.
 */ function $2134fd1f8b4ec9b6$var$initTtiPromise() {
    return new Promise((resolve)=>{
        let hasResolved = false;
        const callback = (ttiResult)=>{
            if (hasResolved) return;
            hasResolved = true;
            resolve(ttiResult);
        };
        $2134fd1f8b4ec9b6$var$resolveTti = callback;
    });
}
let $2134fd1f8b4ec9b6$var$ttiPromise = $2134fd1f8b4ec9b6$var$initTtiPromise();
function $2134fd1f8b4ec9b6$export$1250c0c41b64ee5c() {
    $2134fd1f8b4ec9b6$var$ttiPromise = $2134fd1f8b4ec9b6$var$initTtiPromise();
    $2134fd1f8b4ec9b6$var$observerStarted = false;
}
function $2134fd1f8b4ec9b6$export$d2209a9a3184ff99() {
    $2134fd1f8b4ec9b6$var$observerStarted = true;
    let cleanupObserver = null;
    let lastSeenEventTime = performance.now();
    const callback = ()=>{
        cleanupObserver?.();
        $2134fd1f8b4ec9b6$var$resolveTti(lastSeenEventTime);
    };
    let timeoutId = setTimeout(callback, 5000);
    cleanupObserver = (0, $ba8ih.startLongTaskObserver)(()=>{
        lastSeenEventTime = performance.now();
        clearTimeout(timeoutId);
        timeoutId = setTimeout(callback, 5000);
    });
}
function $2134fd1f8b4ec9b6$export$e67176cf000b0a2e() {
    const promise = $2134fd1f8b4ec9b6$var$ttiPromise ?? $2134fd1f8b4ec9b6$var$initTtiPromise();
    if (!$2134fd1f8b4ec9b6$var$observerStarted) $2134fd1f8b4ec9b6$export$d2209a9a3184ff99();
    return promise;
}

});
parcelRegister("ba8ih", function(module, exports) {

$parcel$export(module.exports, "startLongTaskObserver", () => $c3f66a1c0c2d8c9c$export$af412d3da3bf848a);
/**
 * Starts a long-task observer that will call `cb` on each observation.
 * Returns a disposal function
 */ function $c3f66a1c0c2d8c9c$export$af412d3da3bf848a(cb) {
    const observer = new PerformanceObserver(()=>{
        cb();
    });
    observer.observe({
        type: 'longtask'
    });
    return ()=>{
        observer.disconnect();
    };
}

});


parcelRegister("6M8Uw", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_START_MARK", () => $e57b25b6033962a3$export$8e54fca0a680fdfd);
$parcel$export(module.exports, "MarkProductStart", () => $e57b25b6033962a3$export$2a999c5f84501025);

var $6iz4v = parcelRequire("6iz4v");
const $e57b25b6033962a3$export$8e54fca0a680fdfd = 'PRODUCT_START';
const $e57b25b6033962a3$export$2a999c5f84501025 = ()=>{
    if (!false) {
        performance.clearMarks($e57b25b6033962a3$export$8e54fca0a680fdfd);
        (0, $6iz4v.setMark)($e57b25b6033962a3$export$8e54fca0a680fdfd);
    }
    return null;
};

});

const $37f655a4e4d5690e$export$56940a9488e85199 = 'jira.fe.spa-';
const $37f655a4e4d5690e$export$45c4b6bf7935c69a = `${$37f655a4e4d5690e$export$56940a9488e85199}start`;
const $37f655a4e4d5690e$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $37f655a4e4d5690e$export$ff834eccc35b9089 = 'appBundleReady';
const $37f655a4e4d5690e$export$86b05e34d462ead8 = 'prefetchApiReady';
const $37f655a4e4d5690e$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $37f655a4e4d5690e$export$1211adfff27a31fe = 'issueViewInitialDataReady';
const $37f655a4e4d5690e$export$3ae43cc1782d058f = 'jswRenderStart';
const $37f655a4e4d5690e$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $37f655a4e4d5690e$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $37f655a4e4d5690e$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $37f655a4e4d5690e$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $37f655a4e4d5690e$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $37f655a4e4d5690e$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $37f655a4e4d5690e$export$99c08ec92759c71c = 'tti-raf-mark';
const $37f655a4e4d5690e$export$48552baa9db8ce1d = 'tti-raf';


parcelRegister("brm1D", function(module, exports) {

$parcel$export(module.exports, "StopUfo", () => $aa08c3eb931d9705$export$d91154f099475c5);

var $eUqFw = parcelRequire("eUqFw");

var $3Hphq = parcelRequire("3Hphq");

var $4nnPJ = parcelRequire("4nnPJ");
class $aa08c3eb931d9705$export$d91154f099475c5 extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { customData: customData, appName: appName } = this.props;
        (0, $4nnPJ.GlobalPageLoadExperience).success({
            force: true,
            metadata: customData
        });
        const name = appName || (0, $4nnPJ.GlobalPageLoadExperience).loadingPageLoadId;
        if (name) this.context?.addApdex({
            key: name,
            stopTime: performance.now()
        });
    }
    static{
        this.contextType = (0, $3Hphq.default);
    }
    render() {
        return null;
    }
}

});

parcelRegister("ifyPR", function(module, exports) {

$parcel$export(module.exports, "addBM3SSRDoneAsFMPToInteraction", () => $d6714c8d166fb68b$export$bf239ac2bfb04967);

var $51JrV = parcelRequire("51JrV");

var $fYqUr = parcelRequire("fYqUr");
function $d6714c8d166fb68b$export$bf239ac2bfb04967(metric) {
    const interactionId = (0, $51JrV.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // Use BM3 SSR mark as FMP config for UFO if it exists, temporarily.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && data?.isInitial) (0, $fYqUr.addMetadata)(currentInteractionId, {
        __legacy__bm3ConfigSSRDoneAsFmp: config.ssr?.doneAsFmp || false
    });
}

});

parcelRegister("aS0xb", function(module, exports) {

$parcel$export(module.exports, "addUFOSSRDoneAsFMPToInteraction", () => $714e33db0dc77e43$export$e63862cd888fe05a);

var $51JrV = parcelRequire("51JrV");

var $fYqUr = parcelRequire("fYqUr");

var $4nnPJ = parcelRequire("4nnPJ");
var $aPkDp = parcelRequire("aPkDp");
async function $714e33db0dc77e43$export$e63862cd888fe05a() {
    const interactionId = (0, $51JrV.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    // Use UFO SSR mark as FMP config for rUFO if it exists, temporarily.
    const data = await (0, $4nnPJ.GlobalPageLoadExperience).exportData();
    const fmpMark = data.metrics.marks.find((mark)=>mark.name === 'fmp') || (0, $aPkDp.payloadPublisher).ssr?.getDoneMark();
    if (data.initial && fmpMark) (0, $fYqUr.addMetadata)(currentInteractionId, {
        __legacy__ufoConfigSSRDoneAsFmp: true
    });
}

});

parcelRegister("45wsB", function(module, exports) {

$parcel$export(module.exports, "trackBM3FeatureFlagsAccessed", () => $58cb476ec3ec20ed$export$f00f1e874ce869e9);

var $aWbzA = parcelRequire("aWbzA");

var $51JrV = parcelRequire("51JrV");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$startsAsObject = (value)=>{
    try {
        if (value.charAt(0) === '{') return true;
    } catch (e) {
        return false;
    }
    return false;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $58cb476ec3ec20ed$var$isString = (input)=>{
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (err) {
        // swallow any errors
        result = false;
    }
    return result;
};
const $58cb476ec3ec20ed$export$7b4abba432e57989 = (value)=>$58cb476ec3ec20ed$var$isString(value) && $58cb476ec3ec20ed$var$startsAsObject(value) || $58cb476ec3ec20ed$var$isObject(value);
const $58cb476ec3ec20ed$export$fcc03ee4c944962f = (featureFlagValue)=>$58cb476ec3ec20ed$export$7b4abba432e57989(featureFlagValue) ? 'non_boolean' : featureFlagValue;
const $58cb476ec3ec20ed$export$d2818866b4acbea4 = new Map();
const $58cb476ec3ec20ed$export$f00f1e874ce869e9 = (metric)=>{
    const interactionId = (0, $51JrV.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && config?.featureFlags?.length) {
        const allFeatureFlags = (0, $aWbzA.default)();
        config.featureFlags.forEach((featureFlagName)=>{
            const value = allFeatureFlags[featureFlagName];
            if (value === undefined) return;
            const featureFlagValue = $58cb476ec3ec20ed$export$fcc03ee4c944962f(value);
            $58cb476ec3ec20ed$export$d2818866b4acbea4.set(featureFlagName, featureFlagValue);
        });
    }
};

});


parcelRegister("f9KPu", function(module, exports) {

$parcel$export(module.exports, "getApdexAttributes", () => $5d5d021171651cbf$export$aea4445805b46987);
$parcel$export(module.exports, "getBM3Metric", () => $5d5d021171651cbf$export$8c234930b6ba46bd);

var $exb0h = parcelRequire("exb0h");

var $gUUjF = parcelRequire("gUUjF");

var $iJHZm = parcelRequire("iJHZm");

var $5Su61 = parcelRequire("5Su61");
const $5d5d021171651cbf$var$LOCATION = 'spa.rapidboard';
// PREFETCH ONLY FOR ISSUE VIEW AND PROJECTS-DIRECTORY
// TO-DO: Add it in constant file
const $5d5d021171651cbf$var$PREFETCH_USER_LOCATIONS = new Set([
    `${(0, $exb0h.ROUTE_GROUPS_DIRECTORIES)}:${(0, $exb0h.ROUTE_NAMES_PROJECTS_DIRECTORY)}`,
    `${(0, $exb0h.ROUTE_GROUPS_ISSUE)}:${(0, $exb0h.ROUTE_NAMES_ISSUE)}`
]);
// check if the apps loaded on last page contain any app on which prefetching was done.
const $5d5d021171651cbf$var$isPrefetchRoute = ()=>{
    const lastUserLocation = (0, $iJHZm.getSpaStateLastUserLocation)();
    // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
    return $5d5d021171651cbf$var$PREFETCH_USER_LOCATIONS.has(lastUserLocation);
};
const $5d5d021171651cbf$export$aea4445805b46987 = (query)=>{
    const { GH: GH } = window;
    try {
        const { modal: modal, selectedIssue: selectedIssue, view: view, quickFilter: quickFilter = '', assignee: assignee = '' } = query;
        const defaultAttributes = {
            isDetailView: (modal === 'detail' || view === 'detail' || view === 'planning') && selectedIssue !== '',
            isQuickFilterView: quickFilter !== '' || assignee !== '',
            isPrefetchRoute: $5d5d021171651cbf$var$isPrefetchRoute()
        };
        return GH && GH.RapidBoard && GH.RapidBoard.State ? {
            ...defaultAttributes,
            ...GH.RapidBoard.State.getApdexAttributes()
        } : defaultAttributes;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $gUUjF.default).safeWarnWithoutCustomerData($5d5d021171651cbf$var$LOCATION, 'Error getting rapidboard apdex attributes', err);
        return {};
    }
};
const $5d5d021171651cbf$export$8c234930b6ba46bd = (routeName)=>{
    switch(routeName){
        case 0, $exb0h.ROUTE_NAMES_RAPIDBOARD_BACKLOG:
        case 0, $exb0h.ROUTE_NAMES_RAPIDBOARD_USER_BACKLOG:
            return 0, $5Su61.classicBacklog;
        case 0, $exb0h.ROUTE_NAMES_RAPIDBOARD_BOARD:
        case 0, $exb0h.ROUTE_NAMES_RAPIDBOARD_USER_BOARD:
            return 0, $5Su61.classicBoard;
        case 0, $exb0h.ROUTE_NAMES_RAPIDBOARD_REPORT:
        case 0, $exb0h.ROUTE_NAMES_RAPIDBOARD_USER_REPORT:
            return 0, $5Su61.classicReport;
        default:
            return undefined;
    }
};

});
parcelRegister("5Su61", function(module, exports) {

$parcel$export(module.exports, "classicBoard", () => $7bcbd40fe7e50f1d$export$d4f7403fc0b93706);
$parcel$export(module.exports, "classicBacklog", () => $7bcbd40fe7e50f1d$export$cda6491ffae325ef);
$parcel$export(module.exports, "classicReport", () => $7bcbd40fe7e50f1d$export$f3b1b3a5ead4897d);
$parcel$export(module.exports, "classicBoardInsightButton", () => $7bcbd40fe7e50f1d$export$75e19a7330a91f11);

var $lNfG4 = parcelRequire("lNfG4");

const $7bcbd40fe7e50f1d$export$d4f7403fc0b93706 = (0, $lNfG4.metrics).pageLoad({
    key: 'classic-board',
    featureFlags: [
        'jsw.classic.rapid.board.refresh.button',
        'jsw.classic.board.api-calls.modern-frontend',
        'jsw-classic-override-force-consistency-after-issue-create'
    ]
});
const $7bcbd40fe7e50f1d$export$cda6491ffae325ef = (0, $lNfG4.metrics).pageLoad({
    key: 'classic-backlog',
    featureFlags: [
        'jsw.classic.board.api-calls.modern-frontend',
        'jsw-classic-override-force-consistency-after-issue-create'
    ]
});
const $7bcbd40fe7e50f1d$export$f3b1b3a5ead4897d = (0, $lNfG4.metrics).pageLoad({
    key: 'classic-report'
});
const $7bcbd40fe7e50f1d$export$75e19a7330a91f11 = (0, $lNfG4.metrics).interaction({
    key: (0, $a67acacf7bef125d$export$6c88c619664a31e5)
});

});
const $a67acacf7bef125d$export$6c88c619664a31e5 = 'jira.frontend.classic-board.insight-button';
const $a67acacf7bef125d$export$e4716a51ada35df4 = 'LOAD_START_INSIGHT_BUTTON_MARK_KEY';
const $a67acacf7bef125d$export$f600aeb37520c5ee = 'READY_START_INSIGHT_BUTTON_MARK_KEY';




parcelRegister("6di80", function(module, exports) {

$parcel$export(module.exports, "PrettyUrlRedirect", () => $6f047eb34bea32fe$export$e8ad4dd123297db2);

var $eUqFw = parcelRequire("eUqFw");

var $4vTMF = parcelRequire("4vTMF");

var $53ciZ = parcelRequire("53ciZ");

var $SEaoU = parcelRequire("SEaoU");

var $atRHQ = parcelRequire("atRHQ");

var $lB25E = parcelRequire("lB25E");
const $6f047eb34bea32fe$var$LEGACY_PATH = '/secure/RapidBoard.jspa';
const $6f047eb34bea32fe$export$e8ad4dd123297db2 = ()=>{
    const [{ query: query, location: location }] = (0, $lB25E.useRouter)();
    const [{ data: data, error: error }] = (0, $SEaoU.useContainerContext)();
    if (!data || error) return null;
    const isLegacyRoute = location.pathname === $6f047eb34bea32fe$var$LEGACY_PATH;
    if (!isLegacyRoute) return null;
    // If query contains locationless param then do nothing
    if (query.locationless) return null;
    const { scope: scope } = data;
    const boardId = scope?.id ?? '';
    const prettyUrlQueryParams = {
        ...query
    };
    const mode = prettyUrlQueryParams.view || '';
    let url = '';
    // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
    if (!data.project) // @ts-expect-error - TS2339 - Property 'user' does not exist on type 'ContainerContext'.
    url += `/jira/people/${data.user.accountId}`;
    else // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
    url += `/jira/software/c/projects/${data.project.key}`;
    url += `/boards/${boardId}`;
    if (mode.includes('planning')) url += '/backlog';
    else if (mode.includes('reporting')) url += `/reports/${(0, (/*@__PURE__*/$parcel$interopDefault($4vTMF)))(prettyUrlQueryParams.chart)}`;
    delete prettyUrlQueryParams.view;
    delete prettyUrlQueryParams.chart;
    delete prettyUrlQueryParams.rapidView;
    delete prettyUrlQueryParams.projectKey;
    if (mode === 'planning') prettyUrlQueryParams.view = 'detail';
    const queryParams = (0, $53ciZ.stringify)(prettyUrlQueryParams);
    url += queryParams ? `?${queryParams}` : '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $atRHQ.ScreenRedirect), {
        to: url,
        persistSearchParams: false
    });
};

});

parcelRegister("04x3f", function(module, exports) {

$parcel$export(module.exports, "RapidBoardApps", () => $567937225d588f89$export$9c5ad1ed47ff812a);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $5GxEP = parcelRequire("5GxEP");

var $gGtKh = parcelRequire("gGtKh");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $567937225d588f89$var$LazyRapidApps = (0, $7rh0R.lazy)(()=>(parcelRequire("1D0gI")), {
    ssr: false,
    moduleId: "./src/packages/classic-software/src/ui/rapidboard-app/index.tsx"
});
const $567937225d588f89$export$9c5ad1ed47ff812a = ({ shouldLoad: shouldLoad })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
        id: "async.rapidboard-button.bridge.defer",
        packageName: "jiraClassicBoardAndBacklog"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7rh0R.LazyWait), {
        until: shouldLoad
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "rapid-apps",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($567937225d588f89$var$LazyRapidApps, null))));

});
parcelRegister("1D0gI", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("eWtoa").then(()=>parcelRequire('lcK2e'));

});


parcelRegister("1FK6i", function(module, exports) {

$parcel$export(module.exports, "default", () => $1724408b52677759$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $h97Af = parcelRequire("h97Af");

var $5GxEP = parcelRequire("5GxEP");

var $gGtKh = parcelRequire("gGtKh");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $1724408b52677759$var$IssueView = (0, $7rh0R.lazy)(()=>(parcelRequire("5pi09")), {
    ssr: false,
    moduleId: "./src/packages/classic-software/src/ui/rapidboard-app/issue-view/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1724408b52677759$export$2e2bcd8739ae039 = ({ shouldLoad: shouldLoad })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
        id: "async.issue-view.bridge.defer",
        packageName: "jiraClassicBoardAndBacklog"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7rh0R.LazyWait), {
        until: shouldLoad
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "issue-view",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
            metricKey: (0, $94e06ae2da48a84c$export$94060b41ddf911d)
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1724408b52677759$var$IssueView, null))));

});
const $94e06ae2da48a84c$export$4068827414983759 = 'jira.frontend.classic-board.issue-view';
const $94e06ae2da48a84c$export$94060b41ddf911d = 'LOAD_START_ISSUE_VIEW_RAPIDBOARD_MARK_KEY';
const $94e06ae2da48a84c$export$3b8d28547514aa88 = 'READY_START_ISSUE_VIEW_RAPIDBOARD_MARK_KEY';

parcelRegister("5pi09", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("hPzOn"),
    $d1Cng("auzXa")
]).then(()=>parcelRequire('8EZjl'));

});


parcelRegister("2xaXW", function(module, exports) {

$parcel$export(module.exports, "RapidBoardConfig", () => $04f7e8f00de56ba6$export$86140101e99ba5df);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $5GxEP = parcelRequire("5GxEP");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $04f7e8f00de56ba6$var$LazyRapidApps = (0, $7rh0R.lazy)(()=>(parcelRequire("7O25q")), {
    ssr: false,
    moduleId: "./src/packages/classic-software/src/ui/rapidboard-config/index.tsx"
});
const $04f7e8f00de56ba6$export$86140101e99ba5df = ({ shouldLoad: shouldLoad })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
        id: "async.rapidboard-config.bridge.defer",
        packageName: "jira.insights"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7rh0R.LazyWait), {
        until: shouldLoad
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "rapid-board-config",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($04f7e8f00de56ba6$var$LazyRapidApps, null))));

});
parcelRegister("7O25q", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("aQKil").then(()=>parcelRequire('h8f7a'));

});


parcelRegister("9xMnT", function(module, exports) {

$parcel$export(module.exports, "RapidboardContent", () => $e23efdd2bbf1b53e$export$da1744159516b653);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $c76ap = parcelRequire("c76ap");

var $exb0h = parcelRequire("exb0h");

var $g9fk8 = parcelRequire("g9fk8");

var $10fdS = parcelRequire("10fdS");

var $SEaoU = parcelRequire("SEaoU");

var $cyQ1m = parcelRequire("cyQ1m");

var $8HMCF = parcelRequire("8HMCF");

var $gYoIR = parcelRequire("gYoIR");

var $4s3Pb = parcelRequire("4s3Pb");

var $jT7aq = parcelRequire("jT7aq");

var $lMr0e = parcelRequire("lMr0e");

var $2X0lQ = parcelRequire("2X0lQ");

var $2m6fd = parcelRequire("2m6fd");

var $84DNy = parcelRequire("84DNy");

var $6Is19 = parcelRequire("6Is19");

var $6viyJ = parcelRequire("6viyJ");

var $lr4tk = parcelRequire("lr4tk");
const $e23efdd2bbf1b53e$export$da1744159516b653 = /*#__PURE__*/ (0, $eUqFw.memo)(({ isRapidBoardsReady: isRapidBoardsReady, isBentoEnabled: isBentoEnabled, mode: mode })=>{
    const route = (0, $10fdS.useCurrentRoute)();
    const [{ data: data }] = (0, $SEaoU.useContainerContext)();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const projectData = data;
    const projectKey = projectData?.project?.key;
    const projectId = projectData?.project?.id;
    (0, $4s3Pb.useGICSidebarForcer)();
    const Wrapper = route.name === (0, $exb0h.ROUTE_NAMES_SERVICEDESK_BOARDS) ? (0, $2m6fd.LicenseCheckGeneric) : (0, $84DNy.LicenseCheck);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Wrapper, null, !isRapidBoardsReady && route.skeleton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(route.skeleton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6Is19.LocationlessDialog), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gYoIR.KeyboardShortcuts), {
        isBentoEnabled: isBentoEnabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e23efdd2bbf1b53e$export$f0e43f4dfe473c20, {
        shouldHide: !isRapidBoardsReady
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cyQ1m.StorageLimitsBanner), null), isRapidBoardsReady && ((0, $jT7aq.isPlanningMode)(mode) || (0, $jT7aq.isWorkMode)(mode)) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8HMCF.UpFlowPersistentUpgradeBanner), {
        isBannerEnabled: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lMr0e.BreadcrumbsWrapper), {
        "data-testid": "rapidboard-breadcrumbs"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c76ap.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lr4tk.StyleReset), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2X0lQ.Breadcrumbs), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6viyJ.RapidBoardRoot), null), projectKey != null && projectId != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g9fk8.AsyncLaunchToolchainSpotlight), {
        projectId: projectId,
        projectKey: projectKey
    })))));
});
const $e23efdd2bbf1b53e$export$f0e43f4dfe473c20 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldHide: shouldHide, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            __cmplp.shouldHide ? "_1e0cglyw" : "_1e0c1ule",
            __cmplp.className
        ])
    });
});

});
parcelRegister("g9fk8", function(module, exports) {

$parcel$export(module.exports, "AsyncLaunchToolchainSpotlight", () => $411a8d0cf076a730$export$9ef3659da7a0bb31);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $411a8d0cf076a730$var$ContainerLinking = (0, $7rh0R.lazy)(()=>(parcelRequire("fd1WQ")), {
    moduleId: "./src/packages/devops/launch-toolchain-spotlight/src/ui/main.tsx"
});
const $411a8d0cf076a730$export$9ef3659da7a0bb31 = ({ projectId: projectId, projectKey: projectKey })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "cotainer-linking",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($411a8d0cf076a730$var$ContainerLinking, {
        projectId: projectId,
        projectKey: projectKey
    }));

});
parcelRegister("fd1WQ", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("fhBw9")
]).then(()=>parcelRequire('cPLnp'));

});


parcelRegister("cyQ1m", function(module, exports) {

$parcel$export(module.exports, "StorageLimitsBanner", () => $dfd96f3cb7f5a040$export$3250e2c90ae56dd9);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $5GxEP = parcelRequire("5GxEP");

var $gGtKh = parcelRequire("gGtKh");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $dfd96f3cb7f5a040$var$LazyStorageLimitBanner = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("63W5H")), {
    ssr: false,
    moduleId: "./src/packages/growth/storage-limits/src/ui/index.tsx"
});
const $dfd96f3cb7f5a040$export$3250e2c90ae56dd9 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
        id: (0, $8cd287fa797c55ed$export$5dec3c05c01dac30),
        packageName: (0, $8cd287fa797c55ed$export$b8b9d90f9e5bd72b),
        teamName: "growth-tako",
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "storage-limits-banner",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($dfd96f3cb7f5a040$var$LazyStorageLimitBanner, props)));

});
const $8cd287fa797c55ed$export$bab748d4654ac4a5 = 0.9;
const $8cd287fa797c55ed$export$b8b9d90f9e5bd72b = 'jiraGrowthStorageLimits';
const $8cd287fa797c55ed$export$df9953733f41292a = 'storageLimitsBanner';
const $8cd287fa797c55ed$export$5dec3c05c01dac30 = 'asyncStorageLimitsBanner';
const $8cd287fa797c55ed$export$3aad3de2cc377789 = 'jira_software_free_is_ccp_billing_admins';

parcelRegister("63W5H", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("iBTRu").then(()=>parcelRequire('i4DKK'));

});


parcelRegister("8HMCF", function(module, exports) {

$parcel$export(module.exports, "UpFlowPersistentUpgradeBanner", () => $1ded51f6d1fe0671$export$39832316603e4613);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $5GxEP = parcelRequire("5GxEP");

var $gGtKh = parcelRequire("gGtKh");

var $bNa2U = parcelRequire("bNa2U");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $1ded51f6d1fe0671$var$LazyUpFlowPersistentUpgradeBanner = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("h5kof")), {
    ssr: false,
    moduleId: "./src/packages/growth/up-flow/persistent-upgrade-banner/src/main.tsx"
});
const $1ded51f6d1fe0671$export$39832316603e4613 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
        id: (0, $bNa2U.PERSISTENT_UPGRADE_ANALYTICS_SOURCE),
        packageName: (0, $bNa2U.PERSISTENT_UPGRADE_TOUCHPOINT_BANNER),
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "up-flow-persistent-upgrade-banner",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1ded51f6d1fe0671$var$LazyUpFlowPersistentUpgradeBanner, props)));

});
parcelRegister("bNa2U", function(module, exports) {

$parcel$export(module.exports, "PERSISTENT_UPGRADE_PRE_TRIAL_FREE_EDITION", () => $d4c4bcb569ddbdc8$export$75e961f06f21e171);
$parcel$export(module.exports, "PERSISTENT_UPGRADE_ANALYTICS_SOURCE", () => $d4c4bcb569ddbdc8$export$bebf43b5d37dab0);
$parcel$export(module.exports, "PERSISTENT_UPGRADE_ANALYTICS_UPGRADE_FLOW", () => $d4c4bcb569ddbdc8$export$cbfd75a8d4af5ce5);
$parcel$export(module.exports, "PERSISTENT_UPGRADE_UPFLOW_MODAL_FLOW", () => $d4c4bcb569ddbdc8$export$a2684b22124cc502);
$parcel$export(module.exports, "PERSISTENT_UPGRADE_TOUCHPOINT_BANNER", () => $d4c4bcb569ddbdc8$export$e54a73280ddbd89);
$parcel$export(module.exports, "PERSISTENT_UPGRADE_TOUCHPOINT_BANNER_VIEWED", () => $d4c4bcb569ddbdc8$export$96913d5371f745ad);
$parcel$export(module.exports, "MAX_CADENCE_INDEX", () => $d4c4bcb569ddbdc8$export$b8743c23616e54ee);
$parcel$export(module.exports, "KEY_USER_PROPERTIES_JSW", () => $d4c4bcb569ddbdc8$export$6a69b5601e7d435);
$parcel$export(module.exports, "KEY_USER_PROPERTIES_JSM", () => $d4c4bcb569ddbdc8$export$364c2b43630f5cb5);
$parcel$export(module.exports, "BANNER_CADENCE_INFO", () => $d4c4bcb569ddbdc8$export$ec6ce1b450620e5c);
$parcel$export(module.exports, "SEND_OPERATIONAL_EVENT", () => $d4c4bcb569ddbdc8$export$8b4682bf35504518);
$parcel$export(module.exports, "API_SUCCESS", () => $d4c4bcb569ddbdc8$export$6d01cae610456af2);
$parcel$export(module.exports, "API_FAIL", () => $d4c4bcb569ddbdc8$export$6a238c78062d3b8d);
$parcel$export(module.exports, "GET_USER_PROPERTY_API_CALL", () => $d4c4bcb569ddbdc8$export$d094ee3fcda994eb);
$parcel$export(module.exports, "GET_USER_PROPERTY_API_CALL_SUCCESS", () => $d4c4bcb569ddbdc8$export$8357ebd56fd8e5ea);
$parcel$export(module.exports, "GET_USER_PROPERTY_API_CALL_FAIL", () => $d4c4bcb569ddbdc8$export$252ee5e4ed4943dc);
$parcel$export(module.exports, "SET_USER_PROPERTY_API_CALL", () => $d4c4bcb569ddbdc8$export$f3310dd86ae4284b);
$parcel$export(module.exports, "SET_USER_PROPERTY_API_CALL_SUCCESS", () => $d4c4bcb569ddbdc8$export$5e4635b476d2b497);
$parcel$export(module.exports, "SET_USER_PROPERTY_API_CALL_FAIL", () => $d4c4bcb569ddbdc8$export$b49d6161d5ea4a0a);
$parcel$export(module.exports, "PERSISTENT_PRETRIAL_BANNER_CADENCES_MS", () => $d4c4bcb569ddbdc8$export$55aa1fd7f74b53);
const $d4c4bcb569ddbdc8$export$75e961f06f21e171 = 'pre-trial';
const $d4c4bcb569ddbdc8$export$bebf43b5d37dab0 = 'persistentUpgrade';
const $d4c4bcb569ddbdc8$export$cbfd75a8d4af5ce5 = 'upgradeFlow';
const $d4c4bcb569ddbdc8$export$a2684b22124cc502 = 'persistent-upgrade';
const $d4c4bcb569ddbdc8$export$e54a73280ddbd89 = 'persistentUpgradeBanner';
const $d4c4bcb569ddbdc8$export$96913d5371f745ad = 'persistentUpgradeBanner viewed';
const $d4c4bcb569ddbdc8$export$b8743c23616e54ee = 3;
const $d4c4bcb569ddbdc8$export$6a69b5601e7d435 = 'growth-puet-banner-cadence';
const $d4c4bcb569ddbdc8$export$364c2b43630f5cb5 = 'growth-puet-banner-cadence-jsm';
const $d4c4bcb569ddbdc8$export$ec6ce1b450620e5c = 'Banner Cadence Info';
const $d4c4bcb569ddbdc8$export$8b4682bf35504518 = 'sendOperationalEvent';
const $d4c4bcb569ddbdc8$export$6d01cae610456af2 = 'success';
const $d4c4bcb569ddbdc8$export$6a238c78062d3b8d = 'failed';
const $d4c4bcb569ddbdc8$export$d094ee3fcda994eb = 'getUserPropertyApiCall';
const $d4c4bcb569ddbdc8$export$8357ebd56fd8e5ea = 'getUserPropertyApiCall success';
const $d4c4bcb569ddbdc8$export$252ee5e4ed4943dc = 'getUserPropertyApiCall failed';
const $d4c4bcb569ddbdc8$export$f3310dd86ae4284b = 'setUserPropertyApiCall';
const $d4c4bcb569ddbdc8$export$5e4635b476d2b497 = 'setUserPropertyApiCall success';
const $d4c4bcb569ddbdc8$export$b49d6161d5ea4a0a = 'setUserPropertyApiCall failed';
const $d4c4bcb569ddbdc8$export$55aa1fd7f74b53 = [
    0,
    604800000,
    1814400000,
    3628800000
];

});

parcelRegister("h5kof", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("g8JKE").then(()=>parcelRequire('27Md7'));

});


parcelRegister("gYoIR", function(module, exports) {

$parcel$export(module.exports, "KeyboardShortcuts", () => $c0f7d1625def2296$export$5176144edf2bef2b);

var $eUqFw = parcelRequire("eUqFw");

var $9aFSa = parcelRequire("9aFSa");
const $c0f7d1625def2296$var$invokeGhShortcut = (shortcutFunc, params)=>{
    const { GH: GH } = window;
    if (GH && GH.Shortcut) GH.Shortcut[shortcutFunc](...params || []);
};
const $c0f7d1625def2296$var$invokeGlobalShortcut = (shortcutFunc, params)=>{
    const { gh: gh } = window;
    if (gh && gh.app && gh.app.globalkeyboardshortcuts) gh.app.globalkeyboardshortcuts[shortcutFunc](...params || []);
};
const $c0f7d1625def2296$var$baseKeyMap = {
    'g g': {
        callback: ()=>{
            const { JIRA: JIRA, requestAnimationFrame: requestAnimationFrame } = window;
            requestAnimationFrame(()=>JIRA?.Shifter?.show?.());
        }
    },
    'g h': {
        callback: ()=>$c0f7d1625def2296$var$invokeGlobalShortcut('goToAgile')
    },
    'g a': {
        callback: ()=>$c0f7d1625def2296$var$invokeGlobalShortcut('goToAgile')
    },
    's t': {
        callback: ()=>$c0f7d1625def2296$var$invokeGlobalShortcut('sendToTop', [
                'KeyboardShortcut',
                null,
                'st'
            ])
    },
    's b': {
        callback: ()=>$c0f7d1625def2296$var$invokeGlobalShortcut('sendToBottom', [
                'KeyboardShortcut',
                null,
                'sb'
            ])
    },
    b: {
        callback: ()=>$c0f7d1625def2296$var$invokeGhShortcut('focusBoardSearch', [
                'b'
            ])
    },
    n: {
        callback: ()=>$c0f7d1625def2296$var$invokeGhShortcut('nextBox', [
                'n'
            ])
    },
    p: {
        callback: ()=>$c0f7d1625def2296$var$invokeGhShortcut('previousBox', [
                'p'
            ])
    },
    t: {
        callback: ()=>$c0f7d1625def2296$var$invokeGhShortcut('toggleIssue', [
                't'
            ])
    },
    j: {
        callback: ()=>$c0f7d1625def2296$var$invokeGhShortcut('nextIssue', [
                'j'
            ])
    },
    k: {
        callback: ()=>$c0f7d1625def2296$var$invokeGhShortcut('previousIssue', [
                'k'
            ])
    },
    o: {
        callback: ()=>$c0f7d1625def2296$var$invokeGhShortcut('viewIssue')
    },
    e: {
        callback: ()=>$c0f7d1625def2296$var$invokeGhShortcut('editIssue', [
                'e'
            ])
    },
    '.': {
        callback: ()=>{
            const { JIRA: JIRA, GH: GH, requestAnimationFrame: requestAnimationFrame } = window;
            if (GH?.IssueOperationShortcuts?.getSelectedIssueKey?.()) requestAnimationFrame(()=>$c0f7d1625def2296$var$invokeGhShortcut('showOperationsDialog', [
                    '.'
                ]));
            else requestAnimationFrame(()=>JIRA?.Shifter?.show?.());
        }
    },
    z: {
        callback: ()=>$c0f7d1625def2296$var$invokeGhShortcut('projector', [
                'z'
            ])
    },
    '-': {
        callback: ()=>$c0f7d1625def2296$var$invokeGhShortcut('toggleSwimlanes', [
                '-'
            ])
    },
    '1': {
        callback: ()=>$c0f7d1625def2296$var$invokeGhShortcut('planMode', [
                '1'
            ])
    },
    '2': {
        callback: ()=>$c0f7d1625def2296$var$invokeGhShortcut('workMode', [
                '2'
            ])
    },
    '3': {
        callback: ()=>$c0f7d1625def2296$var$invokeGhShortcut('reportMode', [
                '3'
            ])
    }
};
const $c0f7d1625def2296$var$legacyIssueKeyMap = {
    ...$c0f7d1625def2296$var$baseKeyMap,
    a: {
        callback: ()=>$c0f7d1625def2296$var$invokeGhShortcut('assignIssue', [
                'a'
            ])
    },
    i: {
        callback: ()=>$c0f7d1625def2296$var$invokeGhShortcut('assignIssueToMe', [
                'i'
            ])
    },
    m: {
        callback: ()=>$c0f7d1625def2296$var$invokeGhShortcut('commentIssue', [
                'm'
            ])
    },
    l: {
        callback: ()=>$c0f7d1625def2296$var$invokeGhShortcut('editIssueLabels', [
                'l'
            ])
    }
};
const $c0f7d1625def2296$export$5176144edf2bef2b = ({ children: children, isBentoEnabled: isBentoEnabled })=>{
    const keyMap = isBentoEnabled ? $c0f7d1625def2296$var$baseKeyMap : $c0f7d1625def2296$var$legacyIssueKeyMap;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9aFSa.default), {
        keyMap: keyMap
    }), children);
};
var $c0f7d1625def2296$export$2e2bcd8739ae039 = $c0f7d1625def2296$export$5176144edf2bef2b;

});
parcelRegister("9aFSa", function(module, exports) {

$parcel$export(module.exports, "default", () => $80173688b586a9b5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7Q1yP = parcelRequire("7Q1yP");

var $cIhGE = parcelRequire("cIhGE");

var $haeC1 = parcelRequire("haeC1");

var $fVFUy = parcelRequire("fVFUy");

var $kGQen = parcelRequire("kGQen");

var $h80SI = parcelRequire("h80SI");
let $80173688b586a9b5$var$shortcutsCount = 0;
let $80173688b586a9b5$var$subscription = null;
const $80173688b586a9b5$var$ShortcutsSubscriber = false ? ()=>null : ({ keyMap: keyMap, label: label, location: location })=>{
    const parentRegistry = (0, $eUqFw.useContext)((0, $kGQen.ShortcutRegistryContext)) || (0, $fVFUy.rootRegistry);
    const addKeyMap = (0, $eUqFw.useCallback)(()=>parentRegistry.addKeyMap(()=>({
                keyMap: (0, $h80SI.bindKeyMapWithErrorHandling)(keyMap, location),
                label: label
            })), [
        label,
        parentRegistry,
        keyMap,
        location
    ]);
    (0, $eUqFw.useEffect)(()=>{
        $80173688b586a9b5$var$shortcutsCount += 1;
        const removeKeyMap = addKeyMap();
        return ()=>{
            removeKeyMap();
            $80173688b586a9b5$var$shortcutsCount -= 1;
            if ($80173688b586a9b5$var$subscription && $80173688b586a9b5$var$shortcutsCount === 0) {
                $80173688b586a9b5$var$subscription.unsubscribe();
                $80173688b586a9b5$var$subscription = null;
            }
        };
    }, [
        addKeyMap
    ]);
    (0, $eUqFw.useEffect)(()=>{
        $80173688b586a9b5$var$subscription = $80173688b586a9b5$var$subscription || // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $cIhGE.default)().subscribe((0, $haeC1.default));
    }, [
        parentRegistry,
        keyMap
    ]);
    return null;
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$80173688b586a9b5$export$2e2bcd8739ae039 = ({ useKeyboardShortcutsToggle: useKeyboardShortcutsToggle = (0, $7Q1yP.useKeyboardShortcutsToggle), ...props })=>{
    const [{ isEnabled: isEnabled }] = useKeyboardShortcutsToggle();
    return isEnabled && !false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($80173688b586a9b5$var$ShortcutsSubscriber, props) : null;
};

});
parcelRegister("7Q1yP", function(module, exports) {

$parcel$export(module.exports, "useKeyboardShortcutsToggle", () => $e8e091cfd61e9197$export$a33a81f1fc5458ad);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $6rW04 = parcelRequire("6rW04");

var $jMP2a = parcelRequire("jMP2a");

var $WBLbN = parcelRequire("WBLbN");
const $e8e091cfd61e9197$var$URL_FRAGMENT = '/rest/internal/latest/user/preferences/keyboardShortcuts?turn=';
const $e8e091cfd61e9197$export$b62f67be35e65859 = (analyticsEvent)=>async ({ setState: setState, getState: getState })=>{
        const currentState = getState().isEnabled;
        const status = currentState ? 'off' : 'on';
        const url = `${$e8e091cfd61e9197$var$URL_FRAGMENT}${status}`;
        try {
            await (0, $lRmyA.performPutRequest)(url);
            setState({
                isEnabled: !currentState,
                error: null
            });
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'keyboardShortcutsToggle', {
                isEnabled: !currentState
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setState({
                error: err
            });
            (0, $guiFP.default)({
                meta: {
                    id: 'keyboardShortcutToggleFailure',
                    packageName: 'jiraCommonLegacyDoNotAddAnythingNew'
                },
                error: err
            });
        }
    };
const $e8e091cfd61e9197$var$Store = (0, $WBLbN.createStore)({
    initialState: {
        isEnabled: false ? false : !((0, $6rW04.default)('ajs-keyboard-shortcuts-enabled') === 'false'),
        error: null
    },
    actions: {
        // @ts-expect-error - TS2322 - Type '( analyticsEvent: UIAnalyticsEventInterface) => ({ setState, getState }: StoreActionApi<State>) => Promise<void>' is not assignable to type 'ActionThunk<{ isEnabled: boolean; error: null; }, { toggle: ( analyticsEvent: UIAnalyticsEventInterface) => ({ setState, getState }: StoreActionApi<State>) => Promise<void>; }>'.
        toggle: $e8e091cfd61e9197$export$b62f67be35e65859
    }
});
const $e8e091cfd61e9197$export$a33a81f1fc5458ad = (0, $WBLbN.createHook)($e8e091cfd61e9197$var$Store);

});

parcelRegister("cIhGE", function(module, exports) {

$parcel$export(module.exports, "default", () => $61e80b5974f2eb64$export$2e2bcd8739ae039);
$parcel$export(module.exports, "flush", () => $61e80b5974f2eb64$export$4909b86c8034bf73);
/**
 * An observable that emits key sequences as a string representation
 *
 * Examples:
 *
 * g i
 * shift+enter
 */ 
var $3JafE = parcelRequire("3JafE");

var $70s4u = parcelRequire("70s4u");
parcelRequire("fRdoC");
parcelRequire("5dKXv");
parcelRequire("8OtG5");
parcelRequire("fWv6o");
parcelRequire("flmol");
parcelRequire("7Rus6");
parcelRequire("azOPD");
parcelRequire("1d9Hc");

var $1YqdI = parcelRequire("1YqdI");
const $61e80b5974f2eb64$var$ignoredKeys = {
    Control: true,
    Meta: true,
    Shift: true,
    Alt: true,
    AltGraph: true,
    CapsLock: true,
    Fn: true,
    FnLock: true,
    Hyper: true,
    NumLock: true,
    OS: true,
    ScrollLock: true,
    Super: true,
    Symbol: true,
    SymbolLock: true
};
/**
 * Skipping few input types to allow keydown event propagation to it's parent element
 * inputMode - react-select or select or combo
 * type - skipping these inputtypes (checkbox, radio) to support shortcuts like
 *        e(EPIC panel) or v(VERSION panel) or n(board card selection) in board and backlog
 * This condition added as a part of https://a11y.atlassian.net/browse/JCA11Y-1317
 */ const $61e80b5974f2eb64$var$isNonTextInput = ({ inputMode: inputMode = '', type: type })=>inputMode === 'none' || type === 'checkbox';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $61e80b5974f2eb64$var$isEditable = (node)=>node.nodeName === 'INPUT' && !$61e80b5974f2eb64$var$isNonTextInput(node) || node.nodeName === 'TEXTAREA' || node.isContentEditable === true;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $61e80b5974f2eb64$var$isRelevantKeyEvent = (e)=>typeof e.key === 'string' && // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly Control: true; readonly Meta: true; readonly Shift: true; readonly Alt: true; readonly AltGraph: true; readonly CapsLock: true; readonly Fn: true; readonly FnLock: true; readonly Hyper: true; ... 5 more ...; readonly SymbolLock: true; }'.
    (e.key === 'Escape' || !$61e80b5974f2eb64$var$isEditable(e.target) && !$61e80b5974f2eb64$var$ignoredKeys[e.key]);
const $61e80b5974f2eb64$export$25d1b8252b4c49b7 = ()=>{
    const elBlankets = document.querySelectorAll('.aui-blanket');
    if (elBlankets.length === 0) // no aui-blanket in DOM, so it means it's closed
    return true;
    const isAllHidden = Array.from(elBlankets || []).every((el)=>{
        if (el.getAttribute('aria-hidden') === 'true' || // when `el.getAttribute('hidden')` returns an empty string, it means the element has the `hidden` attribute and it's invisible.
        el.getAttribute('hidden') !== null) return true;
        return false;
    });
    return isAllHidden;
};
let $61e80b5974f2eb64$var$key$;
const $61e80b5974f2eb64$var$flush$ = new (0, $70s4u.Subject)();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$61e80b5974f2eb64$export$2e2bcd8739ae039 = ()=>{
    if (!$61e80b5974f2eb64$var$key$) {
        $61e80b5974f2eb64$var$key$ = false ? new (0, $70s4u.Subject)() : (0, $3JafE.Observable).fromEvent(document, 'keydown').filter($61e80b5974f2eb64$var$isRelevantKeyEvent).filter($61e80b5974f2eb64$export$25d1b8252b4c49b7).map((0, $1YqdI.toKeyWithModifiers));
        const sequence$ = $61e80b5974f2eb64$var$key$.scan((seq, key)=>{
            if (!key || !seq) return undefined;
            return {
                sequence: `${String(seq.sequence)} ${String(key.sequence)}`,
                e: key.e
            };
        });
        $61e80b5974f2eb64$var$key$ = $61e80b5974f2eb64$var$key$.debounceTime(1000).startWith(null).merge($61e80b5974f2eb64$var$flush$).switchMapTo(sequence$);
    }
    return $61e80b5974f2eb64$var$key$;
};
const $61e80b5974f2eb64$export$4909b86c8034bf73 = ()=>{
    $61e80b5974f2eb64$var$flush$.next();
};

});
parcelRegister("1YqdI", function(module, exports) {

$parcel$export(module.exports, "toKeyWithModifiers", () => $1b99fa3356e664b3$export$8cf0d2c3d060a0c2);
$parcel$export(module.exports, "isValidShortcut", () => $1b99fa3356e664b3$export$8e231506c5580162);
$parcel$export(module.exports, "isShortcutCollision", () => $1b99fa3356e664b3$export$4add9e50cb49d130);
/**
 * Converts a KeyboardEvent to a normalised string representation of
 * modifiers and key.
 *
 * Ordering of modifier keys is taken from Apple's guidelines:
 * https://developer.apple.com/macos/human-interface-guidelines/input-and-output/keyboard/
 *
 * Example representation of ArrowUp key with all modifiers present:
 * ctrl+shift+meta+arrowup
 *
 * Character keys never include the 'shift' modifier,.
 * as it changes the character itself.
 * Examples:
 *  - instead of 'shift+a' the normal form is 'A'
 *  - instead of 'shift+/' the normal form is '?'
 *
 * The 'alt' modifier is NOT supported at all due to inconsistent behaviour
 * across platforms. On Mac, it changes the character input, e.g.
 * 'alt+z' is 'Ω' - which becomes the `event.key`. To properly support
 * this, a reverse-mapping of all these characters needs to be added.
 * Alternatively, `String.fromCharCode(event.which)` can be used, but
 * 1. This is a deprecated property
 * 2. The char code is still for the modified character for some keys on Mac
 *    (e.g. The char code for 'alt+/' is '¿')
 */ // Special keys such as 'Escape', 'ArrowUp' or ' '
const $1b99fa3356e664b3$var$isNonCharacterKey = (e)=>e.key.length > 1 || e.key === ' ';
const $1b99fa3356e664b3$var$modifiers = [
    {
        name: 'ctrl',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.ctrlKey
    },
    {
        name: 'shift',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.shiftKey && $1b99fa3356e664b3$var$isNonCharacterKey(e)
    },
    {
        // Command key on MacOS, Windows key on Windows
        name: 'meta',
        // @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type.
        test: (e)=>e.metaKey || e.getModifierState && e.getModifierState('OS')
    }
];
const $1b99fa3356e664b3$var$toKey = (e)=>{
    if ($1b99fa3356e664b3$var$isNonCharacterKey(e)) return e.key.toLowerCase();
    // Ignore accidental CapsLock
    return e.shiftKey ? e.key.toUpperCase() : e.key.toLowerCase();
};
const $1b99fa3356e664b3$export$8cf0d2c3d060a0c2 = (e)=>{
    if (!e || !e.key) // There are still browsers out there that do not support e.key;
    // Just today (Oct 2018) I have observed Chrome 47 in Sentry, but it started supporting e.key since 51.
    // So instead of crashing the page with TypeError let's not detect keyboard shortcuts.
    return {
        sequence: '',
        e: e
    };
    return {
        sequence: $1b99fa3356e664b3$var$modifiers.filter((modifier)=>modifier.test(e)).map((modifier)=>modifier.name).concat($1b99fa3356e664b3$var$toKey(e)).join('+'),
        e: e
    };
};
/*
 *  Selected special key values disjunction for regex. All lowercase, ordered alphabethically.
 *  See https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values.
 */ const $1b99fa3356e664b3$var$orSpecialChars = ' |arrowdown|arrowleft|arrowright|arrowup|backspace|clear|delete|end|enter|escape|home|insert|pagedown|pageup|pause|printscreen|tab';
/*
 * This string when used as a regular expression:
 * 1. Allows lowercase only with a single exception (see 3)
 * 2. Allows optional ctrl, shift, meta followed by "+" in that specific order in the beginning
 * 3. Allows any printable character (may be uppercase letter) or a special key value
 * 4. If shift modifier is used it can only be followed by a special char
 * 5. Is based on toKeyWithModifiers, uses orSpecialChars whitelist for shift chars
 * 6. Does not capture redundant groups
 */ const $1b99fa3356e664b3$var$singleShortcutEntry = `(ctrl\\+)?(shift\\+(?=(?:(?:meta\\+)?(?:${$1b99fa3356e664b3$var$orSpecialChars}))))?(meta\\+)?(${$1b99fa3356e664b3$var$orSpecialChars}|[!-~])`;
/*
 * Any number of singleShortcutEntry separated by a single space
 * We are not specifying "g" flag, so it's fine to reuse the same regex object.
 */ const $1b99fa3356e664b3$var$shortcutRegex = RegExp(`^${$1b99fa3356e664b3$var$singleShortcutEntry}( ${$1b99fa3356e664b3$var$singleShortcutEntry})*$`);
const $1b99fa3356e664b3$export$8e231506c5580162 = (shortcut)=>$1b99fa3356e664b3$var$shortcutRegex.test(shortcut);
const $1b99fa3356e664b3$export$4add9e50cb49d130 = (leftShortcut, rightShortcut)=>{
    if (!leftShortcut || !rightShortcut) return leftShortcut === rightShortcut;
    if (rightShortcut === leftShortcut) return true;
    if (leftShortcut.indexOf(rightShortcut) === 0) return leftShortcut[rightShortcut.length] === ' ';
    if (rightShortcut.indexOf(leftShortcut) === 0) return rightShortcut[leftShortcut.length] === ' ';
    return false;
};

});


parcelRegister("haeC1", function(module, exports) {

$parcel$export(module.exports, "default", () => $44bf9c8ab51bd76c$export$2e2bcd8739ae039);

var $cIhGE = parcelRequire("cIhGE");

var $fVFUy = parcelRequire("fVFUy");
const $44bf9c8ab51bd76c$var$matches = (prefix)=>(definedSequence)=>definedSequence.startsWith(`${prefix} `);
var /**
 * Manages key sequence inputs to execute predefined actions or clear unmatched sequences. This function ensures efficient handling of user inputs by checking against existing sequences and preparing for potential future matches.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$44bf9c8ab51bd76c$export$2e2bcd8739ae039 = (keySequence)=>{
    const { sequence: sequence, e: e } = keySequence || {};
    const activeKeyMap = (0, $fVFUy.rootRegistry).getActiveKeyMap();
    if (sequence !== undefined && activeKeyMap[sequence]) {
        activeKeyMap[sequence].callback(e);
        (0, $cIhGE.flush)();
    } else {
        // Are there any sequences that might be activated with more key presses?
        const isFutureMatchPossible = sequence !== undefined && Object.keys(activeKeyMap).some($44bf9c8ab51bd76c$var$matches(sequence));
        if (!isFutureMatchPossible) (0, $cIhGE.flush)();
    }
};

});
parcelRegister("fVFUy", function(module, exports) {

$parcel$export(module.exports, "ShortcutRegistry", () => $3843ad0413ec519e$export$ca1c75b575abf5ff);
$parcel$export(module.exports, "rootRegistry", () => $3843ad0413ec519e$export$1dd4c61d1ce1fa15);
/* eslint-disable jira/js/no-reduce-accumulator-spread */ /**
 * A tree-like registry of shortcuts, with a default, root registry.
 */ 
var $fUTZC = parcelRequire("fUTZC");

var $6G5mG = parcelRequire("6G5mG");

var $ldoFd = parcelRequire("ldoFd");

var $bFXjh = parcelRequire("bFXjh");

var $1YqdI = parcelRequire("1YqdI");
const $3843ad0413ec519e$var$validateKeyMaps = (keyMaps)=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(keyMaps, (keyMap, keyMapIndex)=>{
        const shortcuts = Object.keys(keyMap);
        (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(shortcuts, (shortcut, shortcutIndex)=>{
            if (!(0, $1YqdI.isValidShortcut)(shortcut)) // eslint-disable-next-line no-console
            console.error(`"${shortcut}" is an incorrect shortcut. Please, update it according to a playbook entry on shortcuts.`);
            for(let indexForOtherKeymaps = keyMapIndex + 1; indexForOtherKeymaps < keyMaps.length; indexForOtherKeymaps += 1){
                const anotherKeyMap = keyMaps[indexForOtherKeymaps];
                (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(anotherKeyMap, (anotherAction, anotherShortcut)=>{
                    if ((0, $1YqdI.isShortcutCollision)(anotherShortcut, shortcut)) // If neither shortcut has a priority we have a conflict.. You should ideally
                    // put a priority on one of these conflicting shortcut configs so you definitively
                    // know which one should be active when there is a conflict.
                    {
                        if ((0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(keyMap[shortcut].priority) && (0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(anotherKeyMap[anotherShortcut].priority) || keyMap[shortcut].priority === anotherKeyMap[anotherShortcut].priority) // DO NOT LET THIS HAPPEN. ADD A PRIORITY!!!
                        // eslint-disable-next-line no-console
                        console.error(`"${shortcut}" has a collision with "${anotherShortcut}" shortcut from another keyMap.`);
                    }
                });
            }
            for(let indexToCompareSelf = shortcutIndex + 1; indexToCompareSelf < shortcuts.length; indexToCompareSelf += 1)if ((0, $1YqdI.isShortcutCollision)(shortcut, shortcuts[indexToCompareSelf])) // eslint-disable-next-line no-console
            console.error(`"${shortcut}" has a collision with "${shortcuts[indexToCompareSelf]}" shortcut from the same keyMap.`);
        });
    });
};
const $3843ad0413ec519e$var$mergeKeyMaps = (keyMapsToMerge)=>// Instead of doing the standard Object.assign({}, ...keyMapsToMerge)
    // we want to have a bit more control over what we can and can't override
    // through the use of the priority
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    keyMapsToMerge.reduce((prev, keyMap)=>({
            ...prev,
            // Add the keys that can be overridden
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            ...Object.keys(keyMap).reduce((newAccumulator, newKey)=>{
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($6G5mG)))(prev, newKey) || (prev[newKey].priority ?? 0) < (keyMap[newKey].priority ?? 1 // Default behaviour is override
                )) return {
                    ...newAccumulator,
                    [newKey]: keyMap[newKey]
                };
                return newAccumulator;
            }, {})
        }), {});
class $3843ad0413ec519e$export$ca1c75b575abf5ff {
    addChildRegistry(child) {
        this.children.push(child);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($bFXjh)))(this.children, child);
        };
    }
    addKeyMap(getKeyMap) {
        this.keyMapRetrievers.push(getKeyMap);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($bFXjh)))(this.keyMapRetrievers, getKeyMap);
        };
    }
    getActiveKeyMap() {
        const keyMaps = this.children.length ? this.children.map((child)=>child.getActiveKeyMap()) : this.keyMapRetrievers.map((getKeyMap)=>getKeyMap().keyMap);
        return {
            ...$3843ad0413ec519e$var$mergeKeyMaps(keyMaps)
        };
    }
    getKeyMapInfo() {
        const info = this.children.length ? this.children.map((child)=>child.getKeyMapInfo()) : this.keyMapRetrievers.map((getInfo)=>getInfo());
        // @ts-expect-error - TS2769 - No overload matches this call.
        const flattenedInfo = [].concat(...info);
        return flattenedInfo;
    }
    constructor(){
        // go/jfe-eslint
        this.children = [];
        this.keyMapRetrievers = [];
    }
}
const $3843ad0413ec519e$export$1dd4c61d1ce1fa15 = new $3843ad0413ec519e$export$ca1c75b575abf5ff();

});


parcelRegister("kGQen", function(module, exports) {

$parcel$export(module.exports, "ShortcutRegistryContext", () => $082205e2100625d8$export$ebbb59327adb551a);
$parcel$export(module.exports, "default", () => $082205e2100625d8$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $fVFUy = parcelRequire("fVFUy");
const $082205e2100625d8$export$ebbb59327adb551a = /*#__PURE__*/ (0, $eUqFw.createContext)((0, $fVFUy.rootRegistry));
const $082205e2100625d8$var$ShortcutScope = ({ children: children = null })=>{
    const registry = (0, $eUqFw.useMemo)(()=>new (0, $fVFUy.ShortcutRegistry)(), []);
    const parentRegistry = (0, $eUqFw.useContext)($082205e2100625d8$export$ebbb59327adb551a) || (0, $fVFUy.rootRegistry);
    (0, $eUqFw.useEffect)(()=>{
        // "This only happens ONCE.  But it happens AFTER the initial render."
        const removeRegistry = parentRegistry.addChildRegistry(registry);
        return removeRegistry;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($082205e2100625d8$export$ebbb59327adb551a.Provider, {
        value: registry
    }, children);
};
var $082205e2100625d8$export$2e2bcd8739ae039 = false ? ({ children: children = null })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children) : $082205e2100625d8$var$ShortcutScope;

});

parcelRegister("h80SI", function(module, exports) {

$parcel$export(module.exports, "bindKeyMapWithErrorHandling", () => $2297a6a3d8ab933d$export$77477772a9b904da);

var $gUUjF = parcelRequire("gUUjF");
const $2297a6a3d8ab933d$var$wrapCallbackWithErrorHandling = (key, callback, location = 'keyboard-shortcuts.common')=>(e)=>{
        try {
            callback(e);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $gUUjF.default).safeErrorWithoutCustomerData(location, `Error firing shortcut '${key}': ${error.message} (commandPaletteBlockNativeShortcutFF=true)`, error);
        }
    };
const $2297a6a3d8ab933d$export$77477772a9b904da = (keyMap, location)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(keyMap).reduce((map, key)=>({
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...map,
            [key]: {
                ...keyMap[key],
                callback: $2297a6a3d8ab933d$var$wrapCallbackWithErrorHandling(key, keyMap[key].callback, location)
            }
        }), {});

});



parcelRegister("4s3Pb", function(module, exports) {

$parcel$export(module.exports, "useGICSidebarForcer", () => $ee6f3d6a837c0a8e$export$23d2fbe817b1786c);

var $eUqFw = parcelRequire("eUqFw");

var $dNWQB = parcelRequire("dNWQB");

var $2gOs4 = parcelRequire("2gOs4");

var $6wTCJ = parcelRequire("6wTCJ");

var $ctR9z = parcelRequire("ctR9z");
const $ee6f3d6a837c0a8e$export$23d2fbe817b1786c = ()=>{
    const [{ minimizableModalView: minimizableModalView, isModalOpen: isModalOpen }] = (0, $ctR9z.useTriggerIssueCreateModal)();
    const { subscribe: subscribe } = (0, $2gOs4.useGICLifeCycleEvents)();
    /*
    Force issue view into sidebar when gic modal is docked or minimized.
    In the case where a gic modal is opened inside a issue view modal, we prevent forcing the issue view into sidebar as this causes weird visual artifacts.
    This is the only scenario where the issue view and gic modal are opened both simultaneously in modal state.
    */ (0, $eUqFw.useEffect)(()=>{
        if (isModalOpen && (minimizableModalView === 'mini' || minimizableModalView === 'minimized')) // Force CMP issue view into sidebar through monolith
        (0, $6wTCJ.default).setIsGlobalIssueCreateOpen(true);
    }, [
        isModalOpen,
        minimizableModalView
    ]);
    (0, $eUqFw.useEffect)(()=>subscribe((0, $dNWQB.GIC_LIFECYCLE_EVENTS).MODAL_CLOSED, async ()=>{
            // Reset CMP issue-view's view mode to its previous state
            (0, $6wTCJ.default).setIsGlobalIssueCreateOpen(false);
        }), [
        subscribe
    ]);
};

});
parcelRegister("dNWQB", function(module, exports) {

$parcel$export(module.exports, "GIC_LIFECYCLE_EVENTS", () => $21eb2e23e0bf69c0$export$876003a5b887f37e);
const $21eb2e23e0bf69c0$export$876003a5b887f37e = {
    MODAL_OPENED: 'MODAL_OPENED',
    MODAL_CLOSED: 'MODAL_CLOSED',
    MODAL_KEEP_EDITING_EXISTING_ISSUE: 'MODAL_KEEP_EDITING',
    MODAL_DISCARD_EXISTING_IN_PROGRESS_ISSUE: 'MODAL_DISCARD',
    MODAL_DISCARD_SUGGESTED_ISSUE: 'MODAL_DISCARD_SUGGESTED_ISSUE',
    MODAL_DISCARD_SUGGESTED_ISSUE_CHANGES: 'MODAL_DISCARD_SUGGESTED_ISSUE_CHANGES',
    MODAL_DISCARD_ALL_SUGGESTED_ISSUES: 'MODAL_DISCARD_ALL_SUGGESTED_ISSUES',
    CREATE_FORM_FIELD_CONFIG_UPDATE: 'CREATE_FORM_FIELD_CONFIG_UPDATE',
    CREATE_FORM_FIELD_VALUE_CHANGE: 'CREATE_FORM_FIELD_VALUE_CHANGE',
    ISSUE_CREATE_SUCCESS: 'ISSUE_CREATE_SUCCESS',
    PROJECT_FIELD_VALUE_CHANGE: 'PROJECT_FIELD_VALUE_CHANGE',
    ISSUE_TYPE_FIELD_VALUE_CHANGE: 'ISSUE_TYPE_FIELD_VALUE_CHANGE',
    RESET_FORM_FIELDS_FOR_CREATE_ANOTHER: 'RESET_FORM_FIELDS_FOR_CREATE_ANOTHER',
    USE_TRIGGER_ISSUE_CREATE_MODAL_STATE_CHANGE: 'USE_TRIGGER_ISSUE_CREATE_MODAL_STATE_CHANGE',
    STATUS_FIELD_STATE_CHANGE: 'STATUS_FIELD_STATE_CHANGE',
    CREATE_FORM_FIELD_BLUR: 'CREATE_FORM_FIELD_BLUR',
    CLASSIFICATION_LEVEL_FIELD_CHANGE: 'CLASSIFICATION_LEVEL_FIELD_CHANGE',
    FORM_CONTEXT_STATE_CHANGE: 'FORM_CONTEXT_STATE_CHANGE'
};

});

parcelRegister("2gOs4", function(module, exports) {

$parcel$export(module.exports, "useGICLifeCycleEvents", () => $c9d12900db50c35b$export$e3ff72f196296fcc);

var $jcERi = parcelRequire("jcERi");
const $c9d12900db50c35b$var$GICLifeCycleEventsService = new (0, $jcERi.PubSubHub)();
const $c9d12900db50c35b$export$e3ff72f196296fcc = ()=>({
        ...$c9d12900db50c35b$var$GICLifeCycleEventsService
    });

});
parcelRegister("jcERi", function(module, exports) {

$parcel$export(module.exports, "PubSubHub", () => $a1db2e8ca1046c74$export$e3607828f8f2c01e);
class $a1db2e8ca1046c74$export$e3607828f8f2c01e {
    constructor(){
        this.subscribers = {};
        this.subscribe = (event, subscriber)=>{
            let subs = this.subscribers[event];
            if (!subs) {
                subs = [];
                this.subscribers[event] = subs;
            }
            subs?.push(subscriber);
            return ()=>this.unsubscribe(event, subscriber);
        };
        this.unsubscribe = (event, subscriber)=>{
            const subs = this.subscribers[event];
            if (subs) this.subscribers[event] = subs.filter((subscription)=>subscription !== subscriber);
        };
        this.publish = (event, data)=>{
            const subs = this.subscribers[event];
            if (subs?.length) subs?.forEach((subscriber)=>subscriber(data));
        };
        this.clearAll = ()=>{
            this.subscribers = {};
        };
    }
}

});


parcelRegister("6wTCJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d54e79288ae17b1$export$2e2bcd8739ae039);

var $gUUjF = parcelRequire("gUUjF");
const $3d54e79288ae17b1$var$emitEventToLegacyApp = (event, data)=>{
    const container = document.getElementById('ghx-issue-fragment');
    if (window.AJS && container) window.AJS.$(container).trigger(event, data);
    else (0, $gUUjF.default).safeErrorWithoutCustomerData('issue.rapid-board', 'Could not find container to send event for rapid board');
};
const $3d54e79288ae17b1$var$BOARD_EVENT = {
    REFRESH_SPRINT_ON_BOARD: 'refresh-sprints-on-board',
    HIDE: 'hide',
    VIEW_ISSUE_MODAL: 'issue.details.view.switch-to-modal',
    VIEW_ISSUE_SIDEBAR: 'issue.details.view.switch-to-sidebar',
    SET_IS_GLOBAL_ISSUE_CREATE_OPEN: 'issue.details.view.set-is-global-issue-create-open'
};
const $3d54e79288ae17b1$var$refreshSprintOnBoard = (sprintId)=>$3d54e79288ae17b1$var$emitEventToLegacyApp($3d54e79288ae17b1$var$BOARD_EVENT.REFRESH_SPRINT_ON_BOARD, {
        sprintIds: [
            sprintId
        ]
    });
const $3d54e79288ae17b1$var$hideIssueView = ()=>$3d54e79288ae17b1$var$emitEventToLegacyApp($3d54e79288ae17b1$var$BOARD_EVENT.HIDE);
// Handling for view mode switching resides in the Legacy JS code
// We are currently supporting view mode switching from Bento
// See https://extranet.atlassian.com/display/JPLAT/Bento+Sidebar+on+Boards
const $3d54e79288ae17b1$var$switchIssueViewToModal = ()=>$3d54e79288ae17b1$var$emitEventToLegacyApp($3d54e79288ae17b1$var$BOARD_EVENT.VIEW_ISSUE_MODAL);
const $3d54e79288ae17b1$var$switchIssueViewToSidebar = ()=>$3d54e79288ae17b1$var$emitEventToLegacyApp($3d54e79288ae17b1$var$BOARD_EVENT.VIEW_ISSUE_SIDEBAR);
const $3d54e79288ae17b1$var$setIsGlobalIssueCreateOpen = (newValue)=>$3d54e79288ae17b1$var$emitEventToLegacyApp($3d54e79288ae17b1$var$BOARD_EVENT.SET_IS_GLOBAL_ISSUE_CREATE_OPEN, newValue);
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3d54e79288ae17b1$export$2e2bcd8739ae039 = {
    refreshSprintOnBoard: $3d54e79288ae17b1$var$refreshSprintOnBoard,
    hideIssueView: $3d54e79288ae17b1$var$hideIssueView,
    switchIssueViewToModal: $3d54e79288ae17b1$var$switchIssueViewToModal,
    switchIssueViewToSidebar: $3d54e79288ae17b1$var$switchIssueViewToSidebar,
    setIsGlobalIssueCreateOpen: $3d54e79288ae17b1$var$setIsGlobalIssueCreateOpen
};

});

parcelRegister("ctR9z", function(module, exports) {

$parcel$export(module.exports, "useTriggerIssueCreateModal", () => $bd445758cecbab8c$export$71e0eb7b8a91a156);
$parcel$export(module.exports, "useOpenIssueCreateModal", () => $bd445758cecbab8c$export$47cf258b1046080b);
$parcel$export(module.exports, "withNewGICProvider", () => $bd445758cecbab8c$export$558a195c5bfe3787);

var $eUqFw = parcelRequire("eUqFw");

var $hompL = parcelRequire("hompL");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $dfh7z = parcelRequire("dfh7z");

var $dEMIg = parcelRequire("dEMIg");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $ellXt = parcelRequire("ellXt");

var $lB25E = parcelRequire("lB25E");

var $WBLbN = parcelRequire("WBLbN");

var $1MRnf = parcelRequire("1MRnf");

var $4SS5k = parcelRequire("4SS5k");

var $dgsxZ = parcelRequire("dgsxZ");
const $bd445758cecbab8c$export$d4c72bab9d6cc13a = {
    inProgressIssueID: undefined,
    isModalOpen: false,
    isSubsequentLoad: false,
    // isSubTaskCreationOpen is used for creating subtasks with new GIC
    isSubTaskCreationOpen: false,
    // isCreateLinkedIssue is used for creating linked issues with new GIC
    isCreateLinkedIssue: false,
    wasStateRestored: false,
    // payload can be used to control the initial values displayed in the GIC Modal
    payload: null,
    // id for the GIC Modal component
    id: 'create-issue-dialog',
    // title for the GIC modal
    title: null,
    // sectionMessage is used to show an info banner at the top of the GIC modal
    sectionMessage: null,
    // submitErrorMessage is used to show an error banner at the top of the GIC modal
    submitErrorMessage: undefined,
    // globalEventNamespaces is the list of event namespaces to which data of created issues will be published
    globalEventNamespaces: [
        (0, $dEMIg.GLOBAL_EVENT_NAMESPACE)
    ],
    // fieldsToAddInPublishedData: list of additioanl fields that should be appended in the data published for
    // created issues. By default we publish summary, status, assignee, duedate, project, issuetype & priority
    fieldsToAddInPublishedData: [],
    // Used on Create Incident from Alerts functionality. Only relevant for Opsgenie alert pages
    alertsToBeLinked: undefined,
    // if onIssueCreate is passed for every issue created in the session onIssueCreate is called with
    // the data of each issue created
    onIssueCreate: null,
    onClose: null,
    // only show required fields
    displayOnlyRequiredFields: false,
    // disables the success flag
    disableCreationSuccessFlag: false,
    // toggle the 'create another issue' checkbox
    displayCreateAnotherIssueToggle: true,
    // toggle display of site picker field.
    displaySitePicker: false,
    // do not allow user to change issue project
    disableProjectDropdown: false,
    // do not allow user to change issue type
    disableIssueTypeDropdown: false,
    // triggerPoinKey can be used to identify specific trigger point of new GIC
    triggerPointKey: (0, $1MRnf.TRIGGER_POINT_KEY_NOT_DEFINED),
    // context can be used to pass data like rank/board data which will be used as payload for issue creation
    context: undefined,
    // the view state for the minimizable modal
    minimizableModalView: 'modal',
    // the modal view maybe persistent depending on conditions, if this value is present, it may override the `minimizableModalView` during `openIssueCreateModal`.
    persistentModalView: undefined,
    // whether we should display mini modal by default for the first time. If this is true, it will override the view state to `mini` during `openIssueCreateModal`.
    shouldPushMiniModalDiscoverability: undefined,
    // whether we should display mini modal spotlight for the first time.
    shouldShowMiniModalSpotlight: undefined,
    // modal was attempted to be opened when already opened
    wasModalRetriggered: false,
    // if there is an existing gic open - we only apply the next state if they discard their current issue
    openIssueCreateModalNextState: {},
    // when an issue is discarded we will reinitialise the gic modal
    shouldInitFetchConfig: false,
    interactedWithModalChangerButtons: false,
    // open modal for the jql board trigger point
    isModalLoadInContext: false,
    // opt-out of the minimizable GIC modal
    disableMinimizableModal: false,
    // switch to control the hide and display of minimizable buttons
    displayMinimizableButtons: true,
    // switch to control the hide and display of header action container
    displayHeaderActionContainer: true,
    // do not override "use request type fields" toggle state
    overrideUseRequestTypeFieldsToggleState: undefined,
    /**
	 * this is for applying the container styles on the GIC containers except modal view
	 */ containerStyle: {},
    // this flag is for enable the minidesign for a trigger point without being in mini view
    isMiniDesignEnabled: false,
    // this flag is for the GIC multiple layout experiment by Makkuro
    isEnrolledAndTargetedForGicMultipleLayouts: false,
    // optional sessionId used for the current issue creation session
    sessionId: undefined,
    // optional component - when supplied, this wraps every field as children within the GIC modal
    FieldWrapperComponent: undefined,
    // optional component - Renders external component above form fields
    ExternalControls: undefined,
    // Analytics property for board with custom filter and icc enabled
    isCustomBoardWithIcc: false,
    // optional ID of the jql swimlane we are creating issues in
    jqlSwimlaneId: undefined,
    // Analytics property for board with swimlane enabled
    swimlaneMode: undefined,
    // prefilled custom Fields if any
    prefilledCustomFields: {}
};
const $bd445758cecbab8c$export$e324594224ef24da = {
    restoreState: (stateToRestore)=>({ setState: setState, getState: getState })=>{
            const { isSubsequentLoad: isSubsequentLoad, isModalOpen: isModalOpen } = getState();
            if (!isModalOpen && stateToRestore.isModalOpen) (0, $dgsxZ.startGlobalIssueCreateMetrics)(isSubsequentLoad);
            setState(stateToRestore);
        },
    openIssueCreateModal: (nextState)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (currentState.isModalOpen) /* If there is an existing gic open then we will defer the state change to prevent
                       clashing with the issue in creation. */ setState({
                wasModalRetriggered: true,
                openIssueCreateModalNextState: nextState
            });
            else {
                (0, $dgsxZ.startGlobalIssueCreateMetrics)(currentState.isSubsequentLoad);
                const isDiscoverabilityPushEnabled = !currentState.isEnrolledAndTargetedForGicMultipleLayouts;
                const isDiscoPushTriggerPoint = isDiscoverabilityPushEnabled && (0, $dgsxZ.isPartOfDiscoverabilityTriggers)(nextState?.triggerPointKey);
                const nextModalView = isDiscoverabilityPushEnabled ? (0, $dgsxZ.getNextModalView)(isDiscoPushTriggerPoint, currentState.persistentModalView, $bd445758cecbab8c$export$d4c72bab9d6cc13a.minimizableModalView) : 'modal';
                setState({
                    ...$bd445758cecbab8c$export$d4c72bab9d6cc13a,
                    ...isDiscoverabilityPushEnabled && {
                        minimizableModalView: nextModalView,
                        persistentModalView: currentState.persistentModalView,
                        ...(0, $dgsxZ.discoverabilityPushModalViewOverride)(currentState.shouldPushMiniModalDiscoverability, isDiscoPushTriggerPoint, nextModalView)
                    },
                    inProgressIssueID: (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4(),
                    isSubsequentLoad: currentState.isSubsequentLoad,
                    isModalOpen: true,
                    wasModalRetriggered: currentState.isModalOpen,
                    ...nextState
                });
            }
        },
    closeIssueCreateModal: (hasIssueCreated)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const isDiscoverabilityPushEnabled = !currentState.isEnrolledAndTargetedForGicMultipleLayouts;
            const isValidDiscoPushTriggerPoint = isDiscoverabilityPushEnabled && (0, $dgsxZ.isPartOfDiscoverabilityTriggers)(currentState.triggerPointKey);
            const shouldUpdatePersistentModalView = isDiscoverabilityPushEnabled && hasIssueCreated && isValidDiscoPushTriggerPoint;
            const shouldPersistDiscoverabilityState = isDiscoverabilityPushEnabled && currentState.shouldPushMiniModalDiscoverability && !isValidDiscoPushTriggerPoint;
            setState({
                ...$bd445758cecbab8c$export$d4c72bab9d6cc13a,
                callbackPayload: undefined,
                ...shouldPersistDiscoverabilityState && {
                    shouldPushMiniModalDiscoverability: true
                },
                ...isDiscoverabilityPushEnabled && {
                    persistentModalView: currentState.persistentModalView
                },
                ...shouldUpdatePersistentModalView && {
                    persistentModalView: currentState.minimizableModalView === 'mini' ? 'mini' : 'modal'
                },
                isModalOpen: false,
                isSubsequentLoad: true
            });
            (0, $dfh7z.CreateIssueUFOExperience).abort({
                metadata: {
                    wasStateRestored: getState().wasStateRestored
                }
            });
        },
    clearSectionMessage: ()=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                ...currentState,
                sectionMessage: null
            });
        },
    setDisplayOnlyRequiredFields: (nextState)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                ...currentState,
                displayOnlyRequiredFields: nextState
            });
        },
    setMinimizableModalView: (minimizableModalView)=>({ setState: setState })=>{
            setState({
                minimizableModalView: minimizableModalView,
                interactedWithModalChangerButtons: true
            });
        },
    resetWasModalRetriggered: (applyNextState = false)=>({ setState: setState, getState: getState })=>{
            if (applyNextState) {
                const currentState = getState();
                (0, $dgsxZ.startGlobalIssueCreateMetrics)(currentState.isSubsequentLoad);
                setState({
                    ...$bd445758cecbab8c$export$d4c72bab9d6cc13a,
                    ...!currentState.isEnrolledAndTargetedForGicMultipleLayouts && {
                        persistentModalView: currentState.persistentModalView
                    },
                    inProgressIssueID: currentState.inProgressIssueID,
                    isSubsequentLoad: currentState.isSubsequentLoad,
                    isModalOpen: true,
                    wasModalRetriggered: false,
                    minimizableModalView: 'modal',
                    openIssueCreateModalNextState: {},
                    shouldInitFetchConfig: true,
                    ...currentState.openIssueCreateModalNextState
                });
            } else setState({
                minimizableModalView: 'modal',
                wasModalRetriggered: false,
                openIssueCreateModalNextState: {}
            });
        },
    resetShouldInitFetchConfig: ()=>({ setState: setState })=>{
            setState({
                shouldInitFetchConfig: false
            });
        },
    setCallbackPayload: (callbackPayload)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                callbackPayload: {
                    id: currentState.callbackPayload?.id ?? '',
                    data: callbackPayload
                }
            });
        },
    setShouldPushMiniModalDiscoverability: (shouldPushMiniModalDiscoverability)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (currentState.isEnrolledAndTargetedForGicMultipleLayouts) return;
            setState({
                shouldPushMiniModalDiscoverability: shouldPushMiniModalDiscoverability
            });
        },
    dismissModalSpotlight: ()=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (currentState.isEnrolledAndTargetedForGicMultipleLayouts) return;
            setState({
                shouldShowMiniModalSpotlight: false
            });
        },
    setPersistentModalView: (persistentModalView)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (currentState.isEnrolledAndTargetedForGicMultipleLayouts) return;
            setState({
                persistentModalView: persistentModalView
            });
        },
    removeAlertFromAlertsToBeLinked: (alertId)=>({ setState: setState, getState: getState })=>{
            if (!(0, $1ybV0.ff)('linked-alerts-in-gic_onvr6')) return;
            const currentState = getState();
            const alertsToBeLinked = currentState.alertsToBeLinked?.filter((entry)=>entry !== alertId);
            setState({
                alertsToBeLinked: alertsToBeLinked
            });
        },
    setSessionId: (sessionId)=>({ setState: setState })=>{
            setState({
                sessionId: sessionId
            });
        }
};
const $bd445758cecbab8c$var$store = (0, $WBLbN.createStore)({
    name: 'issue-create.issue-create-form.use-trigger-issue-create-modal',
    initialState: $bd445758cecbab8c$export$d4c72bab9d6cc13a,
    actions: $bd445758cecbab8c$export$e324594224ef24da
});
const $bd445758cecbab8c$var$useTriggerIssueCreateModalState = (0, $WBLbN.createStateHook)($bd445758cecbab8c$var$store);
const $bd445758cecbab8c$var$useTriggerIssueCreateModalActions = (0, $WBLbN.createActionsHook)($bd445758cecbab8c$var$store);
const $bd445758cecbab8c$export$71e0eb7b8a91a156 = ()=>{
    const createState = $bd445758cecbab8c$var$useTriggerIssueCreateModalState();
    const createActions = $bd445758cecbab8c$var$useTriggerIssueCreateModalActions();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { openIssueCreateModal: openIssueCreateModal, ...otherActions } = createActions;
    const openIssueCreateModalWithAnalytics = (0, $eUqFw.useCallback)((nextState)=>{
        const analyticsEvent = createAnalyticsEvent({});
        const attributes = {
            gicViewState: nextState?.minimizableModalView,
            isSubtask: nextState?.isSubTaskCreationOpen,
            triggerPointKey: nextState?.triggerPointKey
        };
        (0, $jMP2a.fireTrackAnalyticsDeferred)(analyticsEvent, 'issueCreateModal triggered', attributes);
        openIssueCreateModal(nextState);
    }, [
        createAnalyticsEvent,
        openIssueCreateModal
    ]);
    return [
        createState,
        {
            ...otherActions,
            openIssueCreateModal: openIssueCreateModalWithAnalytics
        }
    ];
};
const $bd445758cecbab8c$export$47cf258b1046080b = ()=>{
    const { openIssueCreateModal: openIssueCreateModal } = $bd445758cecbab8c$var$useTriggerIssueCreateModalActions();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [, { setSitePickerState: setSitePickerState }] = (0, $4SS5k.useSitePickerContext)();
    return (0, $eUqFw.useCallback)((nextState)=>{
        const analyticsEvent = createAnalyticsEvent({});
        const attributes = {
            gicViewState: nextState?.minimizableModalView,
            isSubtask: nextState?.isSubTaskCreationOpen,
            triggerPointKey: nextState?.triggerPointKey
        };
        (0, $jMP2a.fireTrackAnalyticsDeferred)(analyticsEvent, 'issueCreateModal triggered', attributes);
        // overrideCloudId only used for embedded GIC
        if (nextState?.payload?.overrideCloudId && (0, $eI5EY.fg)('jira_ai_issue_create_site_user_preference')) // set cloudId inside the state if there's an override
        setSitePickerState({
            selectedCloudId: nextState?.payload?.overrideCloudId
        });
        openIssueCreateModal(nextState);
    }, [
        createAnalyticsEvent,
        openIssueCreateModal,
        setSitePickerState
    ]);
};
const $bd445758cecbab8c$export$4c674fe824b8f278 = (0, $WBLbN.createSubscriber)($bd445758cecbab8c$var$store);
function $bd445758cecbab8c$export$558a195c5bfe3787(WrappedComponent) {
    return (props)=>{
        const [, { openIssueCreateModal: openIssueCreateModal, closeIssueCreateModal: closeIssueCreateModal }] = $bd445758cecbab8c$export$71e0eb7b8a91a156();
        const { data: data } = (0, $lB25E.useResource)((0, $ellXt.gicOptInStatusResources));
        const currentIssueCreateVisibility = data && data?.gicOptInStatus;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
            openIssueCreateModal: openIssueCreateModal,
            closeIssueCreateModal: closeIssueCreateModal,
            currentIssueCreateVisibility: currentIssueCreateVisibility?.isEnabled || false,
            ...props
        });
    };
}

});
parcelRegister("dfh7z", function(module, exports) {

$parcel$export(module.exports, "CreateIssueUFOExperience", () => $5fd686e53a19cbe0$export$cd75c112ac11a83b);
$parcel$export(module.exports, "StatusFieldLoad", () => $5fd686e53a19cbe0$export$e890e797a25e655c);
$parcel$export(module.exports, "GlobalIssueCreateModalSubmitUFOExperience", () => $5fd686e53a19cbe0$export$70208657c8d471a7);
$parcel$export(module.exports, "EcosystemAPIPrefillingUFOExperience", () => $5fd686e53a19cbe0$export$b2d8f8edec75f571);

var $12kyE = parcelRequire("12kyE");
var $kDfSL = parcelRequire("kDfSL");
const $5fd686e53a19cbe0$export$cd75c112ac11a83b = new (0, $kDfSL.UFOExperience)('global-issue-create.create-issue', {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).Custom,
    category: 'global-issue-create.create-issue'
});
const $5fd686e53a19cbe0$export$e890e797a25e655c = new (0, $kDfSL.UFOExperience)('global-issue-create.create-issue.status-field', {
    type: (0, $12kyE.ExperienceTypes).Load,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).PageSegmentLoad
});
const $5fd686e53a19cbe0$export$70208657c8d471a7 = new (0, $kDfSL.UFOExperience)('modern-global-issue-create.modal.issue-submit', {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).Custom,
    category: 'modern-global-issue-create.modal.issue-submit'
});
const $5fd686e53a19cbe0$export$b2d8f8edec75f571 = new (0, $kDfSL.UFOExperience)('ecosystem-api-new-gic-prefilling', {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).Custom,
    category: 'ecosystem-api-new-gic-prefilling'
});

});

parcelRegister("dEMIg", function(module, exports) {

$parcel$export(module.exports, "REQUIRED", () => $dd9f36fe091541c8$export$b1c05b34d317c074);
$parcel$export(module.exports, "FORM_DROPZONE_CONTAINER_ID", () => $dd9f36fe091541c8$export$1a020bd73f33e5a);
$parcel$export(module.exports, "MINIMISED_DROPZONE_CONTAINER_ID", () => $dd9f36fe091541c8$export$9eadc594a5383580);
$parcel$export(module.exports, "LOG_WORK_TIME_SPENT_ERROR_KEY", () => $dd9f36fe091541c8$export$a1a7caa1e4a73c9f);
$parcel$export(module.exports, "LOG_WORK_TIME_REMAINING_ERROR_KEY", () => $dd9f36fe091541c8$export$cf70f9220e6a2f50);
$parcel$export(module.exports, "LOG_WORK_DATE_ERROR_KEY", () => $dd9f36fe091541c8$export$aac4661200ba4104);
$parcel$export(module.exports, "LOG_WORK_DESCRIPTION_ERROR_KEY", () => $dd9f36fe091541c8$export$a23c32d5cf54cba0);
$parcel$export(module.exports, "COMMON_LOG_WORK_ERROR_KEYS", () => $dd9f36fe091541c8$export$74ab3898ae683660);
$parcel$export(module.exports, "MULTI_INPUT_FIELDS_ERROR_KEYS", () => $dd9f36fe091541c8$export$983715bb9b0f9b2c);
$parcel$export(module.exports, "DEFAULT_SCROLL_OPTIONS", () => $dd9f36fe091541c8$export$40f6793dd75f4e52);
$parcel$export(module.exports, "UNSUPPORTED_FIELD_TYPES_IN_GIC", () => $dd9f36fe091541c8$export$3bf5bce483cc2c30);
$parcel$export(module.exports, "ISSUE_CREATE_TYPE", () => $dd9f36fe091541c8$export$30cc1fd33e7c7258);
$parcel$export(module.exports, "GLOBAL_EVENT_NAMESPACE", () => $dd9f36fe091541c8$export$8170252f0ea43511);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

const $dd9f36fe091541c8$export$17bcab948893a9ba = 'worklog';
const $dd9f36fe091541c8$export$b1c05b34d317c074 = 'REQUIRED';
const $dd9f36fe091541c8$export$f10b32dfda12e96e = 'unknown';
const $dd9f36fe091541c8$export$e5e4b8c32e68dd0b = 'networkError';
const $dd9f36fe091541c8$export$2d06efb8146cd043 = 'graphQLError';
const $dd9f36fe091541c8$export$1a020bd73f33e5a = 'issue-create-modal-dropzone-container';
const $dd9f36fe091541c8$export$9eadc594a5383580 = 'minimised-issue-create-dropzone-container';
const $dd9f36fe091541c8$export$a1a7caa1e4a73c9f = 'worklog_timeLogged';
const $dd9f36fe091541c8$export$cf70f9220e6a2f50 = 'worklog_newEstimate';
const $dd9f36fe091541c8$export$aac4661200ba4104 = 'worklog_startDate';
const $dd9f36fe091541c8$export$a23c32d5cf54cba0 = 'worklog_description';
const $dd9f36fe091541c8$export$74ab3898ae683660 = [
    'worklog_adjustmentAmount',
    'worklog_adjustEstimate',
    'worklog_activate'
];
const $dd9f36fe091541c8$export$63fd567c1d0aca19 = [
    ...$dd9f36fe091541c8$export$74ab3898ae683660,
    $dd9f36fe091541c8$export$a1a7caa1e4a73c9f,
    $dd9f36fe091541c8$export$cf70f9220e6a2f50,
    $dd9f36fe091541c8$export$aac4661200ba4104,
    $dd9f36fe091541c8$export$a23c32d5cf54cba0
];
const $dd9f36fe091541c8$export$983715bb9b0f9b2c = {
    [$dd9f36fe091541c8$export$17bcab948893a9ba]: $dd9f36fe091541c8$export$63fd567c1d0aca19
};
const $dd9f36fe091541c8$export$40f6793dd75f4e52 = {
    behavior: 'auto',
    scrollMode: 'if-needed',
    block: 'start'
};
const $dd9f36fe091541c8$export$3bf5bce483cc2c30 = [
    'com.atlassian.servicedesk:sd-request-participants'
];
const $dd9f36fe091541c8$export$30cc1fd33e7c7258 = {
    linkedIssue: 'LINKED_ISSUE_CREATE',
    standard: 'STANDARD'
};
const $dd9f36fe091541c8$export$8170252f0ea43511 = 'QuickCreateIssue';

});

parcelRegister("1MRnf", function(module, exports) {

$parcel$export(module.exports, "GENERIC_FORGE_USE_PRODUCT_MODALS", () => $33ffe55cb7bcdadc$export$a05673a22505d5ee);
$parcel$export(module.exports, "GENERIC_GLOBAL_CREATE_BUTTON", () => $33ffe55cb7bcdadc$export$c78d329777576aa0);
$parcel$export(module.exports, "GENERIC_KEYBOARD_SHORTCUT", () => $33ffe55cb7bcdadc$export$affdc3af7a9a4677);
$parcel$export(module.exports, "JSW_ISSUE_VIEW_CREATE_ISSUE_IN_EPIC", () => $33ffe55cb7bcdadc$export$7e9cfd1f59e60910);
$parcel$export(module.exports, "JSW_ISSUE_VIEW_CREATE_SUBTASK", () => $33ffe55cb7bcdadc$export$708499dcd016e5e9);
$parcel$export(module.exports, "JSW_ISSUE_VIEW_AI_BREAKDOWN_CHILD_ISSUE", () => $33ffe55cb7bcdadc$export$e1c8789144c4c810);
$parcel$export(module.exports, "JSW_ISSUE_VIEW_AI_BREAKDOWN_SUBTASK", () => $33ffe55cb7bcdadc$export$c5afabb7a17e802);
$parcel$export(module.exports, "JSW_RELEASES_CREATE_ISSUE", () => $33ffe55cb7bcdadc$export$2086a63173b79b56);
$parcel$export(module.exports, "JSW_ROADMAP_CREATE_ISSUE", () => $33ffe55cb7bcdadc$export$fe1e5e4597147709);
$parcel$export(module.exports, "JSW_SECURITY_CREATE_ISSUE", () => $33ffe55cb7bcdadc$export$9bc326812a93707);
$parcel$export(module.exports, "JSM_CALENDAR_CREATE_CHANGE_REQUEST", () => $33ffe55cb7bcdadc$export$f352934e06f44599);
$parcel$export(module.exports, "JSM_CREATE_INCIDENT_FROM_ALERT_DETAIL", () => $33ffe55cb7bcdadc$export$6ae07c77acc64360);
$parcel$export(module.exports, "JSM_CREATE_INCIDENT_FROM_ALERT_LIST", () => $33ffe55cb7bcdadc$export$b41d0684e4b6ab1);
$parcel$export(module.exports, "JSM_EMPTY_QUEUE_CREATE_REQUEST", () => $33ffe55cb7bcdadc$export$be9b2b1329ff7ec9);
$parcel$export(module.exports, "JSW_CREATE_ISSUE_DIALOG", () => $33ffe55cb7bcdadc$export$aa348159181703a0);
$parcel$export(module.exports, "ISSUE_VIEW_CREATE_LINKED_ISSUE", () => $33ffe55cb7bcdadc$export$f90eec3841adf619);
$parcel$export(module.exports, "COMMAND_PALETTE_CREATE_LINKED_ISSUE", () => $33ffe55cb7bcdadc$export$718822a309bffada);
$parcel$export(module.exports, "SERVICE_DESK_LINKED_ISSUE_TRIGEER", () => $33ffe55cb7bcdadc$export$2753dafac81e805c);
$parcel$export(module.exports, "JSW_INCIDENTS_CREATE_JSM_PIR_TRIGGER", () => $33ffe55cb7bcdadc$export$7c4d5cc5711d9294);
$parcel$export(module.exports, "JPO_DIALOGS_CREATE_ISSUE_TRIGGER", () => $33ffe55cb7bcdadc$export$998dfc72404b9e14);
$parcel$export(module.exports, "JSW_ADAPTED_GLOBAL_ISSUE_CREATE", () => $33ffe55cb7bcdadc$export$fc180a4b5785d2f4);
$parcel$export(module.exports, "JSW_CREATE_EPIC_ISSUE", () => $33ffe55cb7bcdadc$export$946ec0b21cb84fd0);
$parcel$export(module.exports, "CREATE_ISSUE_ACTIVE_SPRINT_EMPTY_VIEW", () => $33ffe55cb7bcdadc$export$5b97e2844e620e54);
$parcel$export(module.exports, "CREATE_SUBTASK_NIN_TRIGGER", () => $33ffe55cb7bcdadc$export$b99842c2cf46f6be);
$parcel$export(module.exports, "TRIGGER_POINT_KEY_NOT_DEFINED", () => $33ffe55cb7bcdadc$export$8d987f6e80b74000);
$parcel$export(module.exports, "ISSUE_PARENT_SWITCHER_FIELD_CREATE_ISSUE", () => $33ffe55cb7bcdadc$export$8de9fa43731c4b5b);
$parcel$export(module.exports, "POLARIS_CREATE_DELIVERY_ISSUE", () => $33ffe55cb7bcdadc$export$87249ccbfd10fb78);
$parcel$export(module.exports, "HOME_PAGE_DEFAULT_OPEN_GIC", () => $33ffe55cb7bcdadc$export$c0eeeb31d264de76);
$parcel$export(module.exports, "ISSUE_CREATE_EMBEDDABLE_TRIGGER", () => $33ffe55cb7bcdadc$export$f546e18e46478c84);
$parcel$export(module.exports, "DEVELOPER_ESCALATIONS_ISSUE_CREATE_TRIGGER", () => $33ffe55cb7bcdadc$export$1784e634ba79f1f9);
$parcel$export(module.exports, "JWM_INLINE_CREATE", () => $33ffe55cb7bcdadc$export$145eb8935a34e85e);
$parcel$export(module.exports, "POLARIS_GLOBAL_SUBMIT_IDEA_SWITCH_PROJECTS_TRIGGER", () => $33ffe55cb7bcdadc$export$32648b574a536c8b);
$parcel$export(module.exports, "ALLOWED_EXTERNAL_CONTROLS", () => $33ffe55cb7bcdadc$export$c0e2ab74dfaa67cc);
const $33ffe55cb7bcdadc$export$a05673a22505d5ee = 'forge-open-issue-create';
const $33ffe55cb7bcdadc$export$c78d329777576aa0 = 'global-create-button';
const $33ffe55cb7bcdadc$export$affdc3af7a9a4677 = 'keyboard-shortcut';
const $33ffe55cb7bcdadc$export$7e9cfd1f59e60910 = 'jsw-issue-view-create-issue-in-epic';
const $33ffe55cb7bcdadc$export$708499dcd016e5e9 = 'jsw-issue-view-create-subtask';
const $33ffe55cb7bcdadc$export$e1c8789144c4c810 = 'jsw-issue-view-ai-breakdown-child-issue';
const $33ffe55cb7bcdadc$export$c5afabb7a17e802 = 'jsw-issue-view-ai-breakdown-subtask';
const $33ffe55cb7bcdadc$export$2086a63173b79b56 = 'jsw-releases-create-issue';
const $33ffe55cb7bcdadc$export$fe1e5e4597147709 = 'jsw-roadmap-create-issue';
const $33ffe55cb7bcdadc$export$9bc326812a93707 = 'jsw-security-create-issue';
const $33ffe55cb7bcdadc$export$f352934e06f44599 = 'jsm-calendar-create-change-request';
const $33ffe55cb7bcdadc$export$6ae07c77acc64360 = 'jsm-create-incident-from-alert-detail';
const $33ffe55cb7bcdadc$export$b41d0684e4b6ab1 = 'jsm-create-incident-from-alert-list';
const $33ffe55cb7bcdadc$export$be9b2b1329ff7ec9 = 'jsm-empty-queue-create-request';
const $33ffe55cb7bcdadc$export$235b856f54db8916 = 'jwm-board-create-issue';
const $33ffe55cb7bcdadc$export$ebbb81a0a3406bcb = 'jwm-calendar-create-issue';
const $33ffe55cb7bcdadc$export$8e135b62470e5f9a = 'jwm-list-create-issue';
const $33ffe55cb7bcdadc$export$21ea58e7361c33ba = 'jwm-list-create-subtask';
const $33ffe55cb7bcdadc$export$d2cf44b8c67cca33 = 'jwm-timeline-create-issue';
const $33ffe55cb7bcdadc$export$894285d6d13375fd = 'jwm-timeline-create-subtask';
const $33ffe55cb7bcdadc$export$aa348159181703a0 = 'software-create-issue-dialog';
const $33ffe55cb7bcdadc$export$f90eec3841adf619 = 'create-linked-issue-issue-view';
const $33ffe55cb7bcdadc$export$718822a309bffada = 'create-linked-issue-command-palette';
const $33ffe55cb7bcdadc$export$2753dafac81e805c = 'service-desk-linked-issue-trigger';
const $33ffe55cb7bcdadc$export$7c4d5cc5711d9294 = 'jsw-incidents-create-jsm-pir-trigger';
const $33ffe55cb7bcdadc$export$6eb7318fea2f8ce0 = 'jsw-incidents-create-issue-trigger';
const $33ffe55cb7bcdadc$export$998dfc72404b9e14 = 'jpo-dialogs-jira-create-issue';
const $33ffe55cb7bcdadc$export$fc180a4b5785d2f4 = 'jsw-adapted-global-issue-create-trigger';
const $33ffe55cb7bcdadc$export$946ec0b21cb84fd0 = 'jsw-create-epic-issue';
const $33ffe55cb7bcdadc$export$dba86c91ec4fdbf0 = 'create-issue-backlog-trigger';
const $33ffe55cb7bcdadc$export$b5cdfd7f3bb79a7 = 'create-epic-issue-backlog-trigger';
const $33ffe55cb7bcdadc$export$a8199da3cfab0e8 = 'create-issue-in-epic-backlog-trigger';
const $33ffe55cb7bcdadc$export$5b97e2844e620e54 = 'create-issue-active-sprint-empty-view-trigger';
const $33ffe55cb7bcdadc$export$569f5ff8afa08896 = 'create-linked-issue-issue-navigator-trigger';
const $33ffe55cb7bcdadc$export$bafd52474e9ff4e = 'jwm-summary-create-first-issue-trigger';
const $33ffe55cb7bcdadc$export$87f86192eaf0fdf = 'create-subtask-issue-navigator-trigger';
const $33ffe55cb7bcdadc$export$b99842c2cf46f6be = 'create-subtask-new-issue-navigator-trigger';
const $33ffe55cb7bcdadc$export$1e467d0a3f53a410 = 'jwm-board-embed-issue-create';
const $33ffe55cb7bcdadc$export$8d987f6e80b74000 = 'trigger-point-key-not-defined';
const $33ffe55cb7bcdadc$export$867e9a641a3c1457 = 'jwm-list-embed-issue-create';
const $33ffe55cb7bcdadc$export$8de9fa43731c4b5b = 'issue-parent-switcher-field-create-issue';
const $33ffe55cb7bcdadc$export$87249ccbfd10fb78 = 'polaris-create-delivery-issue';
const $33ffe55cb7bcdadc$export$c0eeeb31d264de76 = 'home-page-default-open-gic';
const $33ffe55cb7bcdadc$export$f546e18e46478c84 = 'issue-create-embed-trigger';
const $33ffe55cb7bcdadc$export$1784e634ba79f1f9 = 'developer-escalations-issue-create-trigger';
const $33ffe55cb7bcdadc$export$145eb8935a34e85e = 'jwm-inline-create';
const $33ffe55cb7bcdadc$export$32648b574a536c8b = 'polaris-global-submit-idea-switch-project-trigger';
const $33ffe55cb7bcdadc$export$818f24c6c32e18a = 'jira-calendar-create-issue';
const $33ffe55cb7bcdadc$export$f352408886aa304b = 'connect-app-ecosystem';
const $33ffe55cb7bcdadc$export$c0e2ab74dfaa67cc = {
    FIELD_IDS: [
        'description'
    ],
    TRIGGER_POINTS: [
        'service-desk-gen-ai-pir'
    ]
};

});

parcelRegister("4SS5k", function(module, exports) {

$parcel$export(module.exports, "useSitePickerContext", () => $fda55b41d7d37cf0$export$f8b5aae013e4cf77);

var $WBLbN = parcelRequire("WBLbN");
const $fda55b41d7d37cf0$export$d4c72bab9d6cc13a = {
    selectedCloudId: '',
    siteDomain: ''
};
const $fda55b41d7d37cf0$export$e324594224ef24da = {
    setSitePickerState: ({ selectedCloudId: selectedCloudId, siteDomain: siteDomain })=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                ...currentState,
                selectedCloudId: selectedCloudId || '',
                siteDomain: siteDomain || ''
            });
        }
};
const $fda55b41d7d37cf0$export$6f57813fe9f31bf9 = (0, $WBLbN.createStore)({
    name: 'issue.fields.site-picker',
    initialState: $fda55b41d7d37cf0$export$d4c72bab9d6cc13a,
    actions: $fda55b41d7d37cf0$export$e324594224ef24da
});
const $fda55b41d7d37cf0$export$f8b5aae013e4cf77 = (0, $WBLbN.createHook)($fda55b41d7d37cf0$export$6f57813fe9f31bf9);

});

parcelRegister("dgsxZ", function(module, exports) {

$parcel$export(module.exports, "startGlobalIssueCreateMetrics", () => $b8d8e5356c7976a6$export$550b19803bc962ec);
$parcel$export(module.exports, "isPartOfDiscoverabilityTriggers", () => $b8d8e5356c7976a6$export$f6bc17a4d9120156);
$parcel$export(module.exports, "discoverabilityPushModalViewOverride", () => $b8d8e5356c7976a6$export$8d246e5e04f0b424);
$parcel$export(module.exports, "getNextModalView", () => $b8d8e5356c7976a6$export$720579602bb055a2);

var $dfh7z = parcelRequire("dfh7z");

var $fqKjL = parcelRequire("fqKjL");

var $hBkQt = parcelRequire("hBkQt");

var $75e8i = parcelRequire("75e8i");
const $b8d8e5356c7976a6$export$550b19803bc962ec = (isSubsequentLoad)=>{
    (0, $dfh7z.CreateIssueUFOExperience).start();
    const globalIssueCreateModalLoadMetric = isSubsequentLoad ? (0, $fqKjL.globalIssueCreateModalLoadSubsequent) : (0, $fqKjL.globalIssueCreateModalLoad);
    if (isSubsequentLoad) (0, $75e8i.default)('global-issue.create-modal-subsequent');
    else (0, $75e8i.default)('global-issue.create-modal');
    globalIssueCreateModalLoadMetric.start();
    (0, $hBkQt.startGlobalIssueCreateTTIWithAdjustments)();
};
const $b8d8e5356c7976a6$export$f6bc17a4d9120156 = (triggerPoint)=>{
    if (!triggerPoint) return false;
    const acceptedTriggerPoints = [
        'global-create-button',
        'keyboard-shortcut'
    ];
    return acceptedTriggerPoints.includes(triggerPoint);
};
const $b8d8e5356c7976a6$export$8d246e5e04f0b424 = (shouldPushDiscoverability, isTriggerAccepted, defaultView = 'modal')=>{
    if (!shouldPushDiscoverability) return undefined;
    return {
        minimizableModalView: isTriggerAccepted ? 'mini' : defaultView,
        shouldPushMiniModalDiscoverability: true,
        shouldShowMiniModalSpotlight: isTriggerAccepted
    };
};
const $b8d8e5356c7976a6$export$720579602bb055a2 = (isTriggerAccepted, persistentView, defaultView = 'modal')=>{
    if (isTriggerAccepted) return persistentView || defaultView;
    return defaultView;
};

});
parcelRegister("fqKjL", function(module, exports) {

$parcel$export(module.exports, "globalIssueCreateModalLoad", () => $de2993c8c3fea479$export$5a01a7fa84b239c8);
$parcel$export(module.exports, "globalIssueCreateModalLoadSubsequent", () => $de2993c8c3fea479$export$c50ad3c31b6fcfc6);
$parcel$export(module.exports, "successFlagDisplay", () => $de2993c8c3fea479$export$4b2382574525bb0f);
$parcel$export(module.exports, "successFlagAddToSprintAction", () => $de2993c8c3fea479$export$7839bdaa2f6a2385);
$parcel$export(module.exports, "successFlagClearFiltersAction", () => $de2993c8c3fea479$export$c1592e4d8d98963e);

var $lNfG4 = parcelRequire("lNfG4");
const $de2993c8c3fea479$export$5a01a7fa84b239c8 = (0, $lNfG4.metrics).interaction({
    key: 'global-issue-create-modal'
});
const $de2993c8c3fea479$export$c50ad3c31b6fcfc6 = (0, $lNfG4.metrics).interaction({
    key: 'global-issue-create-modal-subsequent'
});
const $de2993c8c3fea479$export$4b2382574525bb0f = (0, $lNfG4.metrics).interaction({
    key: 'global-issue-create-dynamic-success-flag-display'
});
const $de2993c8c3fea479$export$7839bdaa2f6a2385 = (0, $lNfG4.metrics).interaction({
    key: 'global-issue-create-dynamic-success-flag-add-to-sprint-action'
});
const $de2993c8c3fea479$export$c1592e4d8d98963e = (0, $lNfG4.metrics).interaction({
    key: 'global-issue-create-dynamic-success-flag-clear-filters-action'
});

});

parcelRegister("hBkQt", function(module, exports) {

$parcel$export(module.exports, "globalIssueCreateTTIWithAdjustments", () => $362542d6dd943f24$export$9f3d6f17e1da7874);
$parcel$export(module.exports, "startGlobalIssueCreateTTIWithAdjustments", () => $362542d6dd943f24$export$457c9fb71ad5b3a9);
$parcel$export(module.exports, "markGicTti", () => $362542d6dd943f24$export$ef664dac649a716c);
$parcel$export(module.exports, "stopTTI", () => $362542d6dd943f24$export$30ca4c461fab486c);
$parcel$export(module.exports, "cancelTTI", () => $362542d6dd943f24$export$27f2445288b528c);
$parcel$export(module.exports, "markIframeLoad", () => $362542d6dd943f24$export$7a2709fc1e33401a);
$parcel$export(module.exports, "markFieldsRegistered", () => $362542d6dd943f24$export$cf3893335c93e33b);
$parcel$export(module.exports, "markOnInitResolved", () => $362542d6dd943f24$export$d86f4868694f2aa7);

var $lNfG4 = parcelRequire("lNfG4");

var $gGRYc = parcelRequire("gGRYc");
const $362542d6dd943f24$export$9f3d6f17e1da7874 = (0, $lNfG4.metrics).interaction({
    key: 'global-issue-create-tti-with-adjustments',
    timings: [
        {
            key: 'gic-tti-delta',
            startMark: 'gic-tti'
        },
        {
            key: 'script-execution',
            startMark: 'iframe-load'
        },
        {
            key: 'loading-indicators-visibility',
            startMark: 'fields-registered'
        },
        {
            key: 'time-until-oninit-resolved',
            endMark: 'oninit-resolved'
        },
        {
            key: 'gic-all-fields-tti',
            endMark: 'gic-all-fields-loaded'
        }
    ],
    featureFlags: (0, $gGRYc.TTIFFs)
});
const $362542d6dd943f24$export$457c9fb71ad5b3a9 = ()=>{
    $362542d6dd943f24$export$9f3d6f17e1da7874.start();
};
const $362542d6dd943f24$export$ef664dac649a716c = ()=>$362542d6dd943f24$export$9f3d6f17e1da7874.mark('gic-tti');
const $362542d6dd943f24$export$30ca4c461fab486c = (customData)=>{
    $362542d6dd943f24$export$9f3d6f17e1da7874.stop({
        customData: customData
    });
};
const $362542d6dd943f24$export$27f2445288b528c = ()=>{
    $362542d6dd943f24$export$9f3d6f17e1da7874.cancel();
};
const $362542d6dd943f24$export$7a2709fc1e33401a = ()=>{
    $362542d6dd943f24$export$9f3d6f17e1da7874.mark('iframe-load');
};
const $362542d6dd943f24$export$cf3893335c93e33b = ()=>{
    $362542d6dd943f24$export$9f3d6f17e1da7874.mark('fields-registered');
};
const $362542d6dd943f24$export$d86f4868694f2aa7 = ()=>{
    $362542d6dd943f24$export$9f3d6f17e1da7874.mark('oninit-resolved');
};

});
parcelRegister("gGRYc", function(module, exports) {

$parcel$export(module.exports, "TTIFFs", () => $05ae9ccc47102fc0$export$c396ba1504d97f3f);
const $05ae9ccc47102fc0$export$c396ba1504d97f3f = [];

});





parcelRegister("lMr0e", function(module, exports) {

$parcel$export(module.exports, "BreadcrumbsWrapper", () => $c139de4544e87cb7$export$85f84040e645a2c9);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

const $c139de4544e87cb7$export$85f84040e645a2c9 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _1pbycs5v _18s8as9j _4t3i1tcg _pvkq8isj",
            __cmplp.className
        ])
    });
});

});

parcelRegister("2X0lQ", function(module, exports) {

$parcel$export(module.exports, "Breadcrumbs", () => $32f8bda8f16cb2cc$export$2dc68d50d56fbbd);

var $eUqFw = parcelRequire("eUqFw");

var $SEaoU = parcelRequire("SEaoU");

var $lB25E = parcelRequire("lB25E");

var $g3DZb = parcelRequire("g3DZb");

var $148M7 = parcelRequire("148M7");

var $1bryV = parcelRequire("1bryV");
const $32f8bda8f16cb2cc$export$2dc68d50d56fbbd = ()=>{
    const [{ query: query, match: match }] = (0, $lB25E.useRouter)();
    const baseUrl = '';
    const [{ data: data, error: error }] = (0, $SEaoU.useContainerContext)();
    const { chartView: chartView } = (0, $g3DZb.useUrlState)();
    if (!data || error) return null;
    let boardId;
    if (match && match.params && match.params.boardId !== undefined) boardId = Number(match.params.boardId);
    else boardId = Number(query.rapidView);
    const boardName = data.scope && data.scope.name || '';
    const isReportsView = query && query.view === 'reporting';
    // @ts-expect-error - TS2339 - Property 'user' does not exist on type 'ContainerContext'.
    if (data.user) {
        const accountId = match.params.accountId || '';
        const isLocationlessBoard = !!query.locationless;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1bryV.UserBreadcrumbs), {
            accountId: accountId,
            boardId: boardId,
            boardName: boardName,
            isReportsView: isReportsView,
            // @ts-expect-error - TS2339 - Property 'user' does not exist on type 'ContainerContext'.
            profileUrl: data.user.profileUrl,
            // @ts-expect-error - TS2339 - Property 'user' does not exist on type 'ContainerContext'.
            userName: data.user.name,
            chart: chartView,
            isLocationlessBoard: isLocationlessBoard
        });
    }
    // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
    const { project: project } = data;
    const projectKey = project.key;
    const projectName = project.name;
    const projectId = project.id;
    const isSimplifiedProject = project.isSimplified;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $148M7.ProjectBreadcrumbs), {
        baseUrl: baseUrl,
        boardId: boardId,
        boardName: boardName,
        chart: chartView,
        projectKey: projectKey,
        projectName: projectName,
        projectId: projectId,
        isSimplifiedProject: isSimplifiedProject
    });
};

});
parcelRegister("148M7", function(module, exports) {

$parcel$export(module.exports, "ProjectBreadcrumbs", () => $696ec6d0a23e8684$export$38f8c59e2af08a87);

var $eUqFw = parcelRequire("eUqFw");

var $aTgXo = parcelRequire("aTgXo");

var $dpXKE = parcelRequire("dpXKE");

var $5JgJ2 = parcelRequire("5JgJ2");

var $2S9jt = parcelRequire("2S9jt");
const $696ec6d0a23e8684$export$38f8c59e2af08a87 = /*#__PURE__*/ (0, $eUqFw.memo)(({ baseUrl: baseUrl, boardId: boardId, boardName: boardName, projectKey: projectKey, projectName: projectName, projectId: projectId, isSimplifiedProject: isSimplifiedProject, chart: chart })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dpXKE.default), {
        baseUrl: baseUrl,
        projectKey: projectKey,
        projectName: projectName,
        projectId: projectId,
        isSimplifiedProject: isSimplifiedProject
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aTgXo.default), {
        breadcrumb: {
            text: boardName,
            href: `/jira/software/c/projects/${projectKey}/boards/${boardId}`,
            type: 'boardName',
            analyticsAttributes: {
                nextGenProject: isSimplifiedProject,
                projectConfig: isSimplifiedProject ? 'next-gen' : 'classic'
            },
            analyticsFields: {
                name: 'navigateToSubProject',
                containerId: projectId,
                containerType: 'project'
            }
        }
    }, chart && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aTgXo.default), {
        breadcrumb: {
            text: formatMessage((0, $2S9jt.messages).projectReportBreadcrumb),
            href: `/projects/${projectKey}?selectedItem=com.atlassian.jira.jira-projects-plugin:report-page`
        }
    })));
});

});
parcelRegister("2S9jt", function(module, exports) {

$parcel$export(module.exports, "messages", () => $c2f55229d0512841$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $c2f55229d0512841$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    projectReportBreadcrumb: {
        "id": "classic-software.rapidboard-content.breadcrumbs.project.project-report-breadcrumb",
        "defaultMessage": "Reports"
    }
});

});


parcelRegister("1bryV", function(module, exports) {

$parcel$export(module.exports, "UserBreadcrumbs", () => $aeb2383f38d6f5fd$export$74fdd5a0187b08ef);

var $eUqFw = parcelRequire("eUqFw");

var $aTgXo = parcelRequire("aTgXo");

var $5c2C3 = parcelRequire("5c2C3");

var $5JgJ2 = parcelRequire("5JgJ2");

var $1Shhg = parcelRequire("1Shhg");
const $aeb2383f38d6f5fd$export$74fdd5a0187b08ef = /*#__PURE__*/ (0, $eUqFw.memo)(({ accountId: accountId, boardId: boardId, boardName: boardName, profileUrl: profileUrl, userName: userName, chart: chart, isLocationlessBoard: isLocationlessBoard })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    if (isLocationlessBoard) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5c2C3.default), {
        profileUrl: profileUrl,
        name: userName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aTgXo.default), {
        breadcrumb: {
            text: boardName,
            href: `/secure/RapidBoard.jspa?rapidView=${boardId}&locationless=true`,
            type: 'boardName'
        }
    }, chart && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aTgXo.default), {
        breadcrumb: {
            text: formatMessage((0, $1Shhg.messages).userReportBreadcrumb),
            href: `/secure/RapidBoard.jspa?rapidView=${boardId}&view=reporting&chart=${chart}&locationless=true`
        }
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5c2C3.default), {
        profileUrl: profileUrl,
        name: userName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aTgXo.default), {
        breadcrumb: {
            text: boardName,
            href: `/jira/people/${accountId}/boards/${boardId}`,
            type: 'boardName'
        }
    }, chart && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aTgXo.default), {
        breadcrumb: {
            text: formatMessage((0, $1Shhg.messages).userReportBreadcrumb),
            href: `/jira/people/${accountId}/boards/${boardId}/reports/${chart}`
        }
    })));
});

});
parcelRegister("1Shhg", function(module, exports) {

$parcel$export(module.exports, "messages", () => $326726380d6cf3f4$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $326726380d6cf3f4$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    userReportBreadcrumb: {
        "id": "classic-software.rapidboard-content.breadcrumbs.user.user-report-breadcrumb",
        "defaultMessage": "Reports"
    }
});

});



parcelRegister("2m6fd", function(module, exports) {

$parcel$export(module.exports, "LicenseCheckGeneric", () => $8ba8f5c21ac0694b$export$b2d39e859fdd5656);

var $eUqFw = parcelRequire("eUqFw");

var $bEZRh = parcelRequire("bEZRh");

var $7HKaW = parcelRequire("7HKaW");

var $4nlEU = parcelRequire("4nlEU");
const $8ba8f5c21ac0694b$export$b2d39e859fdd5656 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4nlEU.LicenseStateCheck), {
        type: "servicedesk"
    }, ({ licenseState: licenseState })=>{
        if (licenseState === (0, $7HKaW.LICENSE_STATE_ACTIVE)) return children;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bEZRh.GenericPermissionErrorPageAsync), null);
    });

});
parcelRegister("4nlEU", function(module, exports) {

$parcel$export(module.exports, "LicenseStateCheck", () => $22d137a5c552acc6$export$ce623a03a46f6b64);

var $eUqFw = parcelRequire("eUqFw");

var $7HKaW = parcelRequire("7HKaW");

var $gd0Sp = parcelRequire("gd0Sp");
const $22d137a5c552acc6$var$appLicenseMapper = {
    software: 'software',
    servicedesk: 'serviceDesk'
};
const $22d137a5c552acc6$export$17fd9ec24bb0187f = (tenantContext, type)=>{
    if (tenantContext.licenseStates) return tenantContext.licenseStates[$22d137a5c552acc6$var$appLicenseMapper[type]];
    return 0, $7HKaW.LICENSE_STATE_UNLICENSED;
};
const $22d137a5c552acc6$export$ce623a03a46f6b64 = ({ children: children, type: type })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gd0Sp.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>{
        const licenseState = $22d137a5c552acc6$export$17fd9ec24bb0187f(tenantContext, type);
        return children({
            licenseState: licenseState
        });
    });

});


parcelRegister("84DNy", function(module, exports) {

$parcel$export(module.exports, "LicenseCheck", () => $c6714474ce1d831c$export$944be0b3bf2a6feb);

var $eUqFw = parcelRequire("eUqFw");

var $7HKaW = parcelRequire("7HKaW");

var $5p2pw = parcelRequire("5p2pw");

var $a0J8R = parcelRequire("a0J8R");

var $4nlEU = parcelRequire("4nlEU");
const $c6714474ce1d831c$export$944be0b3bf2a6feb = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4nlEU.LicenseStateCheck), {
        type: "software"
    }, ({ licenseState: licenseState })=>{
        if (licenseState === (0, $7HKaW.LICENSE_STATE_ACTIVE)) return children;
        if (licenseState === (0, $7HKaW.LICENSE_STATE_SUSPENDED)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a0J8R.AsyncSuspendedSoftwareLicense), null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5p2pw.AsyncNoSoftwareLicense), null);
    });

});
parcelRegister("5p2pw", function(module, exports) {

$parcel$export(module.exports, "AsyncNoSoftwareLicense", () => $de0deb0ce0efa641$export$52d8964299339cae);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $foc4i = parcelRequire("foc4i");

var $gGtKh = parcelRequire("gGtKh");

const $de0deb0ce0efa641$var$LazyNoSoftwareLicense = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("4qojl")), {
    moduleId: "./src/packages/spa-apps/common/src/error-screens/no-software-license/index.tsx"
});
const $de0deb0ce0efa641$export$52d8964299339cae = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "no-software-license",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $foc4i.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($de0deb0ce0efa641$var$LazyNoSoftwareLicense, null));

});
parcelRegister("4qojl", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("gd5QC").then(()=>parcelRequire('4kT9n'));

});


parcelRegister("a0J8R", function(module, exports) {

$parcel$export(module.exports, "AsyncSuspendedSoftwareLicense", () => $18059a552e79d4f3$export$a2b6823ff422b6ba);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $foc4i = parcelRequire("foc4i");

var $gGtKh = parcelRequire("gGtKh");

const $18059a552e79d4f3$var$LazySuspendedSoftwareLicense = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("akiOt")), {
    moduleId: "./src/packages/spa-apps/common/src/error-screens/suspended-software-license/index.tsx"
});
const $18059a552e79d4f3$export$a2b6823ff422b6ba = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "suspended-software-license",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $foc4i.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($18059a552e79d4f3$var$LazySuspendedSoftwareLicense, null));

});
parcelRegister("akiOt", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("cEByh").then(()=>parcelRequire('90aaJ'));

});



parcelRegister("6Is19", function(module, exports) {

$parcel$export(module.exports, "LocationlessDialog", () => $056cd00d9562b164$export$35c86e8920989ff4);

var $eUqFw = parcelRequire("eUqFw");

var $SEaoU = parcelRequire("SEaoU");

var $lB25E = parcelRequire("lB25E");

var $eIIdI = parcelRequire("eIIdI");
const $056cd00d9562b164$export$35c86e8920989ff4 = ()=>{
    const baseUrl = '';
    const [rapidView] = (0, $lB25E.useQueryParam)('rapidView');
    const [{ loading: loading, data: data }] = (0, $SEaoU.useContainerContext)();
    if (!loading && !data) {
        const rapidViewId = Number(rapidView);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eIIdI.default), {
            baseUrl: baseUrl,
            rapidViewId: rapidViewId
        });
    }
    return null;
};

});
parcelRegister("eIIdI", function(module, exports) {

$parcel$export(module.exports, "default", () => $cdb43db6d89e52fb$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $h97Af = parcelRequire("h97Af");

var $5GxEP = parcelRequire("5GxEP");

var $gGtKh = parcelRequire("gGtKh");
const $cdb43db6d89e52fb$var$LOAD_START_LOCATION_LESS_DIALOG_MARK_KEY = 'LOAD_START_LOCATION_LESS_DIALOG_MARK_KEY';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $cdb43db6d89e52fb$var$LazyLocationlessDialogApp = (0, $7rh0R.lazy)(()=>(parcelRequire("gWe8K")), {
    moduleId: "./src/packages/board-location-dialogs/locationless/src/app.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$cdb43db6d89e52fb$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5GxEP.default), {
        id: "async.jira-board-location-dialogs-locationless.defer",
        packageName: "jiraClassicBoardAndBacklog"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "locationless-dialog-app",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h97Af.default), {
            metricKey: $cdb43db6d89e52fb$var$LOAD_START_LOCATION_LESS_DIALOG_MARK_KEY
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cdb43db6d89e52fb$var$LazyLocationlessDialogApp, props)));

});
parcelRegister("gWe8K", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("3xPH3")
]).then(()=>parcelRequire('9DSYx'));

});



parcelRegister("6viyJ", function(module, exports) {

$parcel$export(module.exports, "RapidBoardRoot", () => $3ef3d9dafc550cca$export$434e4e9fbd0546b9);

var $eUqFw = parcelRequire("eUqFw");

var $fvRmf = parcelRequire("fvRmf");
const $3ef3d9dafc550cca$export$434e4e9fbd0546b9 = ()=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        id: "content",
        className: "z-index-content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        id: "gh",
        className: "ghx-gh aui-page-panel"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        id: "ghx-header"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        id: "ghx-content-main",
        className: "ghx-content-main"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fvRmf.IssueActions), null));

});
parcelRegister("fvRmf", function(module, exports) {

$parcel$export(module.exports, "IssueActions", () => $ed64e729b74aae3b$export$8f0a14bb9a7ce353);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $10v3r = parcelRequire("10v3r");

var $lB25E = parcelRequire("lB25E");

var $3umxD = parcelRequire("3umxD");
const $ed64e729b74aae3b$export$8f0a14bb9a7ce353 = ()=>{
    const { data: data } = (0, $lB25E.useResource)((0, $10v3r.rapidboardResource));
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    // @ts-expect-error - TS7019 - Rest parameter 'params' implicitly has an 'any[]' type. | TS2556 - A spread argument must either have a tuple type or be passed to a rest parameter.
    const wrappedFormatMessage = (...params)=>formatMessage(...params, {
            '0': '{0}'
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: "hidden js-issueaction-container-dot"
    }, data?.issueOperations?.map((action)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
            key: action.id + action.style,
            id: action.id,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `js-issueaction ${action.style}`,
            href: action.url
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
            className: "hidden"
        }, "Link for ", action.id)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("fieldset", {
        className: "hidden parameters"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("input", {
        type: "hidden",
        id: "thanks_issue_updated",
        value: wrappedFormatMessage((0, $3umxD.messages).issueUpdated)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("input", {
        type: "hidden",
        id: "thanks_issue_transitioned",
        value: wrappedFormatMessage((0, $3umxD.messages).issueUpdated)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("input", {
        type: "hidden",
        id: "thanks_issue_assigned",
        value: wrappedFormatMessage((0, $3umxD.messages).issueAssigned)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("input", {
        type: "hidden",
        id: "thanks_issue_commented",
        value: wrappedFormatMessage((0, $3umxD.messages).issueCommented)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("input", {
        type: "hidden",
        id: "thanks_issue_worklogged",
        value: wrappedFormatMessage((0, $3umxD.messages).issueWorklogged)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("input", {
        type: "hidden",
        id: "thanks_issue_voted",
        value: wrappedFormatMessage((0, $3umxD.messages).issueVoted)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("input", {
        type: "hidden",
        id: "thanks_issue_watched",
        value: wrappedFormatMessage((0, $3umxD.messages).issueWatched)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("input", {
        type: "hidden",
        id: "thanks_issue_moved",
        value: wrappedFormatMessage((0, $3umxD.messages).issueMoved)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("input", {
        type: "hidden",
        id: "thanks_issue_linked",
        value: wrappedFormatMessage((0, $3umxD.messages).issueLinked)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("input", {
        type: "hidden",
        id: "thanks_issue_cloned",
        value: wrappedFormatMessage((0, $3umxD.messages).issueCloned)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("input", {
        type: "hidden",
        id: "thanks_issue_labelled",
        value: wrappedFormatMessage((0, $3umxD.messages).issueLabelled)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("input", {
        type: "hidden",
        id: "thanks_issue_deleted",
        value: wrappedFormatMessage((0, $3umxD.messages).issueDeleted)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("input", {
        type: "hidden",
        id: "thanks_issue_attached",
        value: wrappedFormatMessage((0, $3umxD.messages).issueAttached)
    })));
};

});
parcelRegister("3umxD", function(module, exports) {

$parcel$export(module.exports, "messages", () => $a6ac61a0ede23d5a$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $a6ac61a0ede23d5a$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    issueUpdated: {
        "id": "classic-software.rapidboard-content.rapidboard-root.issue-actions.issue-updated",
        "defaultMessage": "{0} has been updated."
    },
    issueTransitioned: {
        "id": "classic-software.rapidboard-content.rapidboard-root.issue-actions.issue-transitioned",
        "defaultMessage": "{0} has been updated."
    },
    issueAssigned: {
        "id": "classic-software.rapidboard-content.rapidboard-root.issue-actions.issue-assigned",
        "defaultMessage": "{0} has been assigned."
    },
    issueCommented: {
        "id": "classic-software.rapidboard-content.rapidboard-root.issue-actions.issue-commented",
        "defaultMessage": "{0} has been updated with your comment."
    },
    issueWorklogged: {
        "id": "classic-software.rapidboard-content.rapidboard-root.issue-actions.issue-worklogged",
        "defaultMessage": "Work has been logged on {0}."
    },
    issueVoted: {
        "id": "classic-software.rapidboard-content.rapidboard-root.issue-actions.issue-voted",
        "defaultMessage": "Your vote on {0} has been updated."
    },
    issueWatched: {
        "id": "classic-software.rapidboard-content.rapidboard-root.issue-actions.issue-watched",
        "defaultMessage": "Your watcher status on {0} has been updated."
    },
    issueMoved: {
        "id": "classic-software.rapidboard-content.rapidboard-root.issue-actions.issue-moved",
        "defaultMessage": "{0} has been moved."
    },
    issueLinked: {
        "id": "classic-software.rapidboard-content.rapidboard-root.issue-actions.issue-linked",
        "defaultMessage": "The links on {0} have been updated."
    },
    issueCloned: {
        "id": "classic-software.rapidboard-content.rapidboard-root.issue-actions.issue-cloned",
        "defaultMessage": "{0} has been cloned."
    },
    issueLabelled: {
        "id": "classic-software.rapidboard-content.rapidboard-root.issue-actions.issue-labelled",
        "defaultMessage": "The labels on {0} have been updated."
    },
    issueDeleted: {
        "id": "classic-software.rapidboard-content.rapidboard-root.issue-actions.issue-deleted",
        "defaultMessage": "{0} has been deleted."
    },
    issueAttached: {
        "id": "classic-software.rapidboard-content.rapidboard-root.issue-actions.issue-attached",
        "defaultMessage": "The file(s) have been attached to {0}."
    }
});

});



parcelRegister("lr4tk", function(module, exports) {

$parcel$export(module.exports, "StyleReset", () => $37fcef3535f5010e$export$f56c26255765fd48);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- To migrate as part of go/ui-styling-standard

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $37fcef3535f5010e$export$f56c26255765fd48 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_wmvt1wug",
            __cmplp.className
        ])
    });
});

});


parcelRegister("1CHhy", function(module, exports) {

$parcel$export(module.exports, "RoadmapSettingRedirect", () => $a4b4ca6036191734$export$c59f8e851148ddf9);

var $eUqFw = parcelRequire("eUqFw");

var $53ciZ = parcelRequire("53ciZ");

var $SEaoU = parcelRequire("SEaoU");

var $atRHQ = parcelRequire("atRHQ");

var $lB25E = parcelRequire("lB25E");
const $a4b4ca6036191734$var$SOFTWARE_TIMELINE_CLASSIC_REGEX = /\/jira\/software\/c\/projects\/(\w+)\/boards\/(\d+)/;
const $a4b4ca6036191734$export$c59f8e851148ddf9 = ()=>{
    const [{ data: data, error: error }] = (0, $SEaoU.useContainerContext)();
    const [{ query: { config: config, ...params }, location: location }] = (0, $lB25E.useRouter)();
    const match = $a4b4ca6036191734$var$SOFTWARE_TIMELINE_CLASSIC_REGEX.exec(location.pathname);
    if (!data || error) return null;
    if (match && config === 'roadmapConfig') {
        let url = `${location.pathname}?config=timelineConfig`;
        const queryParams = (0, $53ciZ.stringify)(params);
        url += queryParams ? `&${queryParams}` : '';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $atRHQ.ScreenRedirect), {
            to: url,
            persistSearchParams: false
        });
    }
    return null;
};

});

parcelRegister("iK63v", function(module, exports) {

$parcel$export(module.exports, "SLATracker", () => $615a88ff3875328f$export$ccc9bce94d001ecf);

var $eUqFw = parcelRequire("eUqFw");

var $kwMhr = parcelRequire("kwMhr");

var $3T07y = parcelRequire("3T07y");

var $1SPOJ = parcelRequire("1SPOJ");

var $cjsFv = parcelRequire("cjsFv");

var $g3DZb = parcelRequire("g3DZb");

var $crSCO = parcelRequire("crSCO");

var $eUGPU = parcelRequire("eUGPU");
const $615a88ff3875328f$export$ccc9bce94d001ecf = ()=>{
    const { slaFailure: slaFailure, hasFinishedRetrying: hasFinishedRetrying } = (0, $1SPOJ.useSLAHandler)();
    const { mode: mode, config: config } = (0, $g3DZb.useUrlState)();
    if (hasFinishedRetrying && slaFailure !== null && slaFailure !== undefined && !(0, $eUGPU.isBoardSettings)(config)) {
        const { name: name = '' } = slaFailure;
        if ((0, $eUGPU.isUserNetworkError)(name)) return null;
        const failedReason = (0, $eUGPU.getFailedReason)(slaFailure);
        const status = (0, $eUGPU.getStatusCode)(slaFailure);
        const slaResult = (0, $cjsFv.getSLAResult)(status, mode);
        const isSLAFailureDetected = slaResult.state === (0, $3T07y.FAILURE);
        if (isSLAFailureDetected) {
            /* The task and boardType wont be available in case wrm fails
            The only solution to solve above is to copy paste those code here and retrieve from route resource board config which is kind of hacky
            */ const dataAttributes = (0, $eUGPU.getDataAttributes)();
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kwMhr.ExperienceFailureTracker), {
                location: failedReason,
                failureEventAttributes: {
                    statusCode: status === null ? (0, $crSCO.UNKNOWN_STATUSCODE) : status,
                    errorMessage: (0, $eUGPU.getErrorMessage)(failedReason, status),
                    debugAttribute: (0, $eUGPU.getDebugAttributes)(mode, status, slaFailure),
                    ...dataAttributes
                }
            });
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kwMhr.ExperienceSuccessTracker), {
            location: failedReason
        });
    }
    return null;
};

});
parcelRegister("1SPOJ", function(module, exports) {

$parcel$export(module.exports, "useSLAHandler", () => $4d636412075fa8fc$export$a66926222dff2756);

var $a5edq = parcelRequire("a5edq");

var $jT7aq = parcelRequire("jT7aq");

var $kQ5lq = parcelRequire("kQ5lq");

var $3syrf = parcelRequire("3syrf");
const $4d636412075fa8fc$export$a66926222dff2756 = ()=>{
    const { loading: dataLoading, error: dataError, hasFinishedRetrying: hasFinishedRetrying } = (0, $kQ5lq.useRapidBoardResource)({
        resource: (0, $a5edq.getRapidBoardDataResource)(),
        shouldShowFlag: false,
        retryPredicate: (0, $jT7aq.isAllDataErrorValid)
    });
    const { errorGHContext: errorGHContext } = (0, $3syrf.useWrmBundleLoader)();
    const isResourceOrApiLoading = dataLoading;
    // @ts-expect-error - TS2345 - Argument of type 'Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error) | null' is not assignable to parameter of type 'RouteResourceError'.
    const slaError = (0, $jT7aq.isAllDataErrorValid)(dataError) ? dataError : null;
    return {
        slaFailure: !isResourceOrApiLoading ? slaError : null,
        dataError: dataError,
        wrmError: errorGHContext,
        hasFinishedRetrying: hasFinishedRetrying
    };
};

});


parcelRegister("gVPP8", function(module, exports) {

$parcel$export(module.exports, "DevDetailsDialogLoaderAsync", () => $d943de865dd0122f$export$f5ffc0f323543e16);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $d943de865dd0122f$var$DevDetailDialogLoaderWithContainer = (0, $7rh0R.lazy)(()=>(parcelRequire("g6LDU")), {
    ssr: false,
    moduleId: "./src/packages/development/details-loader/src/ui/index.tsx"
});
const $d943de865dd0122f$export$f5ffc0f323543e16 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "dev-detail-dialog-loader-with-container",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d943de865dd0122f$var$DevDetailDialogLoaderWithContainer, props));
$d943de865dd0122f$export$f5ffc0f323543e16.defaultProps = {
    onCloseDevDetailDialog: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
};

});
parcelRegister("g6LDU", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("90cOZ")
]).then(()=>parcelRequire('g5FQE'));

});


parcelRegister("8UjU2", function(module, exports) {

$parcel$export(module.exports, "asyncRunInitBridge", () => $a9abc759d6822b43$export$da4dfe182afd32b5);

var $l9jp9 = parcelRequire("l9jp9");
const $a9abc759d6822b43$export$da4dfe182afd32b5 = ()=>{
    (0, $l9jp9.initBridge)();
};

});
parcelRegister("l9jp9", function(module, exports) {

$parcel$export(module.exports, "initBridge", () => $62132c3bc3a16245$export$7c01844c99427400);

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $2BvS3 = parcelRequire("2BvS3");

var $jOOKa = parcelRequire("jOOKa");
const $62132c3bc3a16245$export$7c01844c99427400 = ()=>{
    const editSprintButtonBridge = {
        render: (domObj, props)=>{
            if (document.body && document.body.contains(domObj)) (0, $lEfVV.render)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jOOKa.EditSprintButtonApp), props), domObj);
        },
        unmount: (container)=>{
            if (document.body && document.body.contains(container)) (0, $lEfVV.unmountComponentAtNode)(container);
        }
    };
    // eslint-disable-next-line jira/wrm/no-load-bridge
    (0, $2BvS3.loadBridge)({
        name: 'jira-agile/rapid/ui/sprint-edit-modal-bridge'
    }).then((bridge)=>bridge.resolve(editSprintButtonBridge));
};

});
parcelRegister("jOOKa", function(module, exports) {

$parcel$export(module.exports, "EditSprintButtonApp", () => $228d79e27b520bcd$export$355ec03fbecca550);

var $eUqFw = parcelRequire("eUqFw");

var $jYVKV = parcelRequire("jYVKV");

var $6lKbz = parcelRequire("6lKbz");

var $0cdA8 = parcelRequire("0cdA8");

var $5JgJ2 = parcelRequire("5JgJ2");

var $7LFzI = parcelRequire("7LFzI");

var $8WuJm = parcelRequire("8WuJm");
var $jMP2a = parcelRequire("jMP2a");
var $iKlrz = parcelRequire("iKlrz");
var $bFzGY = parcelRequire("bFzGY");

var $3FyZ4 = parcelRequire("3FyZ4");

var $ln3W8 = parcelRequire("ln3W8");

var $2byXr = parcelRequire("2byXr");

var $cilgq = parcelRequire("cilgq");

var $2c0Qi = parcelRequire("2c0Qi");

var $7KGHt = parcelRequire("7KGHt");
const $228d79e27b520bcd$export$355ec03fbecca550 = (props)=>{
    const onEvent = (0, $eUqFw.useCallback)((event)=>{
        (0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>{
            if (client) client.sendEvent((0, $iKlrz.getEvent)(event));
        });
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "editSprintModalLegacyBridgeEditButtonApp",
        packageName: "jiraEditSprintModalLegacyBridge",
        teamName: "a4t-pandora"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        sourceName: "cmpReports"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jYVKV.default), {
        channel: "*",
        onEvent: onEvent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ln3W8.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7LFzI.IntlProvider), {
        messages: $7KGHt,
        locale: (0, $6lKbz.default)(props.locale)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($228d79e27b520bcd$export$4c5785b6a33764d0, props))))));
};
const $228d79e27b520bcd$export$4c5785b6a33764d0 = ({ boardId: boardId, sprintId: sprintId, onSubmit: onSubmit })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject, stopMetric: stopMetric, editSprintModalTriggerRef: editSprintModalTriggerRef } = (0, $cilgq.useEditSprintModalEntryPoint)(boardId, sprintId, true);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const handleOpenEditSprint = (0, $eUqFw.useCallback)((e)=>{
        e.preventDefault();
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'dropdownItem'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'openEditSprint');
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
        id: "ghx-edit-sprint",
        role: "button",
        href: "#",
        ref: editSprintModalTriggerRef,
        onClick: handleOpenEditSprint
    }, formatMessage((0, $2c0Qi.default).editSprint)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2byXr.EditSprintModalEntryPointContainer), {
        boardId: boardId,
        isCompanyManaged: true,
        entryPointReferenceSubject: entryPointReferenceSubject,
        entryPointActions: entryPointActions,
        onReady: stopMetric,
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        onClose: ()=>{},
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        onSubmit: onSubmit || (()=>{})
    }));
};

});
parcelRegister("6lKbz", function(module, exports) {

$parcel$export(module.exports, "default", () => $4df0223a452ae697$export$2e2bcd8739ae039);
// en_US => en
// DO NOT USE IT ANYMORE!!
// DO NOT USE IT ANYMORE!!
//
// After the feature flag(https://app.launchdarkly.com/jira/staging/features/use.bcp47.locale.format/targeting) is cleaned-up, this will be removed.
// The reason why it is deprecated is that we are providing locale to ReactIntlProvider as a locale prop after applying
// this function. This is wrong because we are passing only language part ignoring the region variance.
// The consequence is react-intl's format functions such as formatDate will format date into MM-DD-YYYY, instead of DD-MM-YYYY
// in case of en-gb. The similar things could happen in any other language variances.
// On 2. Feb. 2021, it is confirmed that this function is only used to provide locale for IntlProvider component
// Under the feature flag, it is replaced with getBCPLocale function that replaces _ to - to be BCP47 web standard locale format
//
// DO NOT USE IT ANYMORE!!
// DO NOT USE IT ANYMORE!!
// eslint-disable-next-line jira/import/no-anonymous-default-export
var $4df0223a452ae697$export$2e2bcd8739ae039 = (locale)=>locale ? locale.substring(0, locale.indexOf('_')) : '';

});

// SCREENS
const $41ea3621645e2acc$export$f636b5b56f1d624a = 'Screen';
const $41ea3621645e2acc$export$9d2de6eebf7462b5 = 'Drawer';
const $41ea3621645e2acc$export$1171103ea9083ffa = 'Modal';
const $41ea3621645e2acc$export$cae2783c9279926 = 'InlineDialog';
const $41ea3621645e2acc$export$d1123261ca8831d2 = 'Dropdown';
const $41ea3621645e2acc$export$238d30785c4bca84 = 'Banner';
const $41ea3621645e2acc$export$a1562d08625f5d7e = 'UI';
const $41ea3621645e2acc$export$947dac6c72b26f81 = 'TRACK';
const $41ea3621645e2acc$export$f1d537d508d2945a = 'SCREEN';
const $41ea3621645e2acc$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("2byXr", function(module, exports) {

$parcel$export(module.exports, "EditSprintModalEntryPointContainer", () => $d99df3b5470985a5$export$385f16077f730dc3);

var $eUqFw = parcelRequire("eUqFw");

var $3q7Yq = parcelRequire("3q7Yq");

var $3tfzg = parcelRequire("3tfzg");
var $k8Qyf = parcelRequire("k8Qyf");

var $huI7r = parcelRequire("huI7r");

var $dWLk9 = parcelRequire("dWLk9");
const $d99df3b5470985a5$export$385f16077f730dc3 = ({ boardId: boardId, isCompanyManaged: isCompanyManaged, entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject, triggerRef: triggerRef, onSubmit: onSubmit, onReady: onReady, onClose: onClose })=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const boardAri = (0, $huI7r.createAri)({
        resourceId: String(boardId),
        resourceType: 'board',
        resourceOwner: 'jira-software',
        cloudId: cloudId
    });
    const handleSubmit = (0, $eUqFw.useCallback)((data, requestPromise)=>{
        // Show a generic error flag on request failure
        requestPromise.catch(()=>{
            showFlag((0, $3tfzg.default).genericError());
            return {
                editSprint: null
            };
        });
        onSubmit(data, requestPromise);
    }, [
        onSubmit,
        showFlag
    ]);
    const props = (0, $eUqFw.useMemo)(()=>({
            boardAri: boardAri,
            isCompanyManaged: isCompanyManaged,
            triggerRef: triggerRef,
            fetchSprints: true,
            onSubmit: handleSubmit,
            ...onReady && {
                onReady: onReady
            },
            ...onClose && {
                onClose: onClose
            }
        }), [
        boardAri,
        isCompanyManaged,
        handleSubmit,
        onReady,
        onClose,
        triggerRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3q7Yq.ModalEntryPointContainer), {
        id: "edit-sprint-modal",
        teamName: "a4t-pandora",
        packageName: "jiraSoftwareEditSprintModalRelay",
        entryPointActions: entryPointActions,
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: props
    });
};

});
parcelRegister("3q7Yq", function(module, exports) {

$parcel$export(module.exports, "ModalEntryPointContainer", () => $79aee538140aeba6$export$4d67c6ee49f3d14d);

var $eUqFw = parcelRequire("eUqFw");

var $dxopF = parcelRequire("dxopF");

var $P6D7Q = parcelRequire("P6D7Q");

var $ioLN0 = parcelRequire("ioLN0");
const $79aee538140aeba6$export$4d67c6ee49f3d14d = ({ entryPointActions: { unload: unload }, entryPointReferenceSubject: entryPointReferenceSubject, errorFallback: errorFallback, runtimeProps: runtimeProps, ...containerProps })=>{
    const entryPointReference = (0, $P6D7Q.useEntryPointSubscription)(entryPointReferenceSubject);
    const props = (0, $eUqFw.useMemo)(()=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        ({
            ...runtimeProps,
            onClose () {
                runtimeProps.onClose?.();
                unload();
            }
        }), [
        runtimeProps,
        unload
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, entryPointReference && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ioLN0.InternalEntryPointContainer), {
        ...containerProps,
        entryPointReference: entryPointReference,
        errorFallback: errorFallback || 'flag',
        placeholderName: "modal-entry-point-container",
        runtimeProps: props
    }));
};

});

parcelRegister("3tfzg", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2f5282da7c4a398$export$2e2bcd8739ae039);

var $7ZFHa = parcelRequire("7ZFHa");

var $1yPyd = parcelRequire("1yPyd");

var $kZOWw = parcelRequire("kZOWw");

var $aiNUT = parcelRequire("aiNUT");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c2f5282da7c4a398$export$2e2bcd8739ae039 = {
    forbidden: $7ZFHa.default,
    genericError: $1yPyd.default,
    serverError: $kZOWw.default,
    unauthorized: $aiNUT.default
};

});
parcelRegister("7ZFHa", function(module, exports) {

$parcel$export(module.exports, "default", () => $38183d80ce97928d$export$2e2bcd8739ae039);
/* eslint-disable jira/i18n/id-named-by-package
    --------
    Temporary disable while refactoring the flags package
    so that we don't trigger retranslation of strings */ 
var $90IgZ = parcelRequire("90IgZ");
const $38183d80ce97928d$var$messages = (0, $90IgZ.defineMessages)({
    title: {
        "id": "platform.ui.flags.flags.errors.forbidden.title",
        "defaultMessage": "You don't have permission to do that"
    },
    description: {
        "id": "platform.ui.flags.flags.errors.forbidden.description",
        "defaultMessage": "Ask your Jira admin for help."
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$38183d80ce97928d$export$2e2bcd8739ae039 = ()=>({
        type: 'error',
        title: $38183d80ce97928d$var$messages.title,
        description: $38183d80ce97928d$var$messages.description
    });

});

parcelRegister("1yPyd", function(module, exports) {

$parcel$export(module.exports, "default", () => $2073c932b2866c1b$export$2e2bcd8739ae039);
/* eslint-disable jira/i18n/id-named-by-package
    --------
    Temporary disable while refactoring the flags package
    so that we don't trigger retranslation of strings */ 
var $90IgZ = parcelRequire("90IgZ");
const $2073c932b2866c1b$var$messages = (0, $90IgZ.defineMessages)({
    title: {
        "id": "platform.ui.flags.flags.errors.generic-error.title",
        "defaultMessage": "Something's gone wrong"
    },
    description: {
        "id": "platform.ui.flags.flags.errors.generic-error.description",
        "defaultMessage": "Refresh the page and try again."
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2073c932b2866c1b$export$2e2bcd8739ae039 = ()=>({
        type: 'error',
        title: $2073c932b2866c1b$var$messages.title,
        description: $2073c932b2866c1b$var$messages.description
    });

});

parcelRegister("kZOWw", function(module, exports) {

$parcel$export(module.exports, "default", () => $e55ad6379920dc9f$export$2e2bcd8739ae039);
/* eslint-disable jira/i18n/id-named-by-package
    --------
    Temporary disable while refactoring the flags package
    so that we don't trigger retranslation of strings */ 
var $90IgZ = parcelRequire("90IgZ");
const $e55ad6379920dc9f$var$messages = (0, $90IgZ.defineMessages)({
    title: {
        "id": "platform.ui.flags.flags.errors.server-error.title",
        "defaultMessage": "We're having some trouble"
    },
    description: {
        "id": "platform.ui.flags.flags.errors.server-error.description",
        "defaultMessage": "Something went wrong on our end. Refresh the page and try again."
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e55ad6379920dc9f$export$2e2bcd8739ae039 = ()=>({
        type: 'error',
        title: $e55ad6379920dc9f$var$messages.title,
        description: $e55ad6379920dc9f$var$messages.description
    });

});

parcelRegister("aiNUT", function(module, exports) {

$parcel$export(module.exports, "default", () => $df39dc77bca926f0$export$2e2bcd8739ae039);
/* eslint-disable jira/i18n/id-named-by-package
    --------
    Temporary disable while refactoring the flags package
    so that we don't trigger retranslation of strings */ 
var $90IgZ = parcelRequire("90IgZ");
const $df39dc77bca926f0$var$messages = (0, $90IgZ.defineMessages)({
    title: {
        "id": "platform.ui.flags.flags.errors.unauthorized.title",
        "defaultMessage": "You're logged out"
    },
    description: {
        "id": "platform.ui.flags.flags.errors.unauthorized.description",
        "defaultMessage": "Log back in and try again."
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$df39dc77bca926f0$export$2e2bcd8739ae039 = ()=>({
        type: 'error',
        title: $df39dc77bca926f0$var$messages.title,
        description: $df39dc77bca926f0$var$messages.description
    });

});



parcelRegister("cilgq", function(module, exports) {

$parcel$export(module.exports, "useEditSprintModalEntryPoint", () => $7edf04cea7541d07$export$6009493f90785e59);

var $eUqFw = parcelRequire("eUqFw");

var $l3Qg0 = parcelRequire("l3Qg0");

var $6j4bv = parcelRequire("6j4bv");

var $huI7r = parcelRequire("huI7r");

var $dWLk9 = parcelRequire("dWLk9");

var $bU6dn = parcelRequire("bU6dn");

var $8Y2Gm = parcelRequire("8Y2Gm");
const $7edf04cea7541d07$export$6009493f90785e59 = (boardId, sprintId, isCompanyManaged)=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const boardAri = (0, $eUqFw.useMemo)(()=>(0, $huI7r.createAri)({
            resourceOwner: 'jira-software',
            cloudId: cloudId,
            resourceType: 'board',
            resourceId: String(boardId)
        }), [
        boardId,
        cloudId
    ]);
    const sprintAri = (0, $eUqFw.useMemo)(()=>(0, $huI7r.createAri)({
            resourceOwner: 'jira-software',
            cloudId: cloudId,
            resourceType: 'sprint',
            resourceId: sprintId
        }), [
        cloudId,
        sprintId
    ]);
    const entryPointParams = (0, $eUqFw.useMemo)(()=>({
            boardId: boardAri,
            sprintId: sprintAri,
            fetchSprints: false,
            isCompanyManaged: isCompanyManaged
        }), [
        boardAri,
        sprintAri,
        isCompanyManaged
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject, stopMetric: stopMetric } = (0, $6j4bv.useEntryPoint)((0, $bU6dn.editSprintModalEntryPoint), entryPointParams, (0, $8Y2Gm.editSprintModalLoad));
    const editSprintModalTriggerRef = (0, $l3Qg0.useEntryPointButtonTrigger)(entryPointActions);
    return {
        entryPointActions: entryPointActions,
        entryPointReferenceSubject: entryPointReferenceSubject,
        stopMetric: stopMetric,
        editSprintModalTriggerRef: editSprintModalTriggerRef
    };
};

});
parcelRegister("l3Qg0", function(module, exports) {

$parcel$export(module.exports, "useEntryPointButtonTrigger", () => $c6e813dbc513f02a$export$25d2524a63315ed);
$parcel$export(module.exports, "getDefaultEntrypointActionEventMap", () => $c6e813dbc513f02a$export$5f13515bd3a35325);

var $eUqFw = parcelRequire("eUqFw");

var $a9frS = parcelRequire("a9frS");
const $c6e813dbc513f02a$export$25d2524a63315ed = (actions, isActive = true, eventMap = $c6e813dbc513f02a$export$5f13515bd3a35325(actions))=>{
    const removePreviousListeners = (0, $eUqFw.useRef)(null);
    const isMounted = (0, $eUqFw.useRef)(true);
    (0, $eUqFw.useEffect)(()=>()=>{
            removePreviousListeners.current?.();
            removePreviousListeners.current = null;
            isMounted.current = false;
        }, []);
    return (0, $eUqFw.useCallback)((element)=>{
        if (!isMounted.current) return;
        removePreviousListeners.current?.();
        if (element && isActive) {
            (0, $a9frS.modifyListeners)({
                element: element,
                operationName: 'add',
                eventMap: eventMap
            });
            removePreviousListeners.current = ()=>{
                (0, $a9frS.modifyListeners)({
                    element: element,
                    operationName: 'remove',
                    eventMap: eventMap
                });
            };
        } else removePreviousListeners.current = null;
    }, [
        eventMap,
        isActive
    ]);
};
const $c6e813dbc513f02a$export$5f13515bd3a35325 = (actions)=>({
        click: actions.load,
        mouseenter: actions.preload,
        mouseleave: actions.cancelPreload,
        focusin: actions.preload,
        focusout: actions.cancelPreload
    });

});
parcelRegister("a9frS", function(module, exports) {

$parcel$export(module.exports, "modifyListeners", () => $592b51d0c18fde03$export$15257a36a7e3f9d6);
function $592b51d0c18fde03$export$15257a36a7e3f9d6(params) {
    const { element: element, operationName: operationName, eventMap: eventMap } = params;
    const functionName = operationName === 'add' ? 'addEventListener' : 'removeEventListener';
    if (element) Object.keys(eventMap).forEach((eventName)=>element[functionName](eventName, eventMap[eventName]));
}

});


parcelRegister("bU6dn", function(module, exports) {

$parcel$export(module.exports, "editSprintModalEntryPoint", () => $a575ddbc99f0c007$export$62497640baecc927);

var $9e6N7 = parcelRequire("9e6N7");

var $53Hxw = parcelRequire("53Hxw");

var $artI2 = parcelRequire("artI2");

const $a575ddbc99f0c007$export$62497640baecc927 = (0, $artI2.createEntryPoint)({
    root: (0, $53Hxw.JSResourceForInteraction)(()=>(parcelRequire("cC66o")), {
        moduleId: "c7ce165f"
    }),
    getPreloadProps: ({ boardId: boardId, sprintId: sprintId, fetchSprints: fetchSprints })=>({
            queries: {
                editSprintModal: {
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: $9e6N7.default,
                    variables: {
                        boardId: boardId,
                        sprintId: sprintId,
                        fetchSprints: fetchSprints
                    }
                }
            }
        })
});

});
parcelRegister("9e6N7", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed53291ef2849f32$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a6471efb4cf0d88bef3ca4f275ac9826>>
 * @relayHash a7c5c4d6570548dfbbb896009ae5fc47
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 90bffcc09f8865bee8f7861946866baaa79e714bb9afc19568bc71a86050977b
const $ed53291ef2849f32$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "90bffcc09f8865bee8f7861946866baaa79e714bb9afc19568bc71a86050977b",
        "metadata": {},
        "name": "uiJiraSoftwareEditSprintModalQuery",
        "operationKind": "query",
        "text": null
    }
};
var $ed53291ef2849f32$export$2e2bcd8739ae039 = $ed53291ef2849f32$var$node;

});

parcelRegister("cC66o", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("hPzOn"),
    $d1Cng("cM9em"),
    $d1Cng("fr9NE"),
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("35Awq")
]).then(()=>parcelRequire('6uWGk'));

});


parcelRegister("8Y2Gm", function(module, exports) {

$parcel$export(module.exports, "clickEditSprintInteraction", () => $e9488ae64fed68a8$export$9c57106ef5795d9a);
$parcel$export(module.exports, "editSprintModalLoad", () => $e9488ae64fed68a8$export$c39d6b5415c8a491);

var $lNfG4 = parcelRequire("lNfG4");
const $e9488ae64fed68a8$export$9c57106ef5795d9a = (0, $lNfG4.metrics).interaction({
    key: 'sprint-edit-click'
});
const $e9488ae64fed68a8$export$c39d6b5415c8a491 = (0, $lNfG4.metrics).interaction({
    key: 'edit-sprint-modal-load'
});

});


parcelRegister("2c0Qi", function(module, exports) {

$parcel$export(module.exports, "default", () => $9026e576795e7d09$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $9026e576795e7d09$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    editSprint: {
        "id": "edit-sprint-modal-legacy-bridge.edit-sprint-button.edit-sprint",
        "defaultMessage": "Edit sprint"
    }
});

});




parcelRegister("3rugj", function(module, exports) {

$parcel$export(module.exports, "getActiveQuickFilters", () => $7baafd71b159444e$export$40e8efdeac3c81db);

var $exb0h = parcelRequire("exb0h");
const $7baafd71b159444e$var$ACTIVE_QUICK_FILTERS = 'activeQuickFilters';
const $7baafd71b159444e$var$PLAN_QUICK_FILTERS = 'planQuickFilters';
const $7baafd71b159444e$export$40e8efdeac3c81db = (name)=>{
    const { GH: GH } = window;
    if (GH?.RapidBoard?.State) {
        if (name === (0, $exb0h.ROUTE_NAMES_RAPIDBOARD_BOARD)) return GH.RapidBoard.State.getBoardSettings()[$7baafd71b159444e$var$ACTIVE_QUICK_FILTERS];
        if (name === (0, $exb0h.ROUTE_NAMES_RAPIDBOARD_BACKLOG)) return GH.RapidBoard.State.getBoardSettings()[$7baafd71b159444e$var$PLAN_QUICK_FILTERS];
    }
    return '';
};

});

parcelRegister("cfJys", function(module, exports) {

$parcel$export(module.exports, "useRapidBoardLongTasks", () => $680eebb76eb329c0$export$3ff0c45230113a8c);

var $eUqFw = parcelRequire("eUqFw");

var $511uv = parcelRequire("511uv");

var $6RZSH = parcelRequire("6RZSH");
const $680eebb76eb329c0$export$3ff0c45230113a8c = (mode)=>{
    (0, $eUqFw.useEffect)(()=>{
        if (mode !== 'rapidboard-board' && mode !== 'rapidboard-backlog') return undefined;
        // This is intentionally verbose to show in searches.
        const startEvent = mode === 'rapidboard-board' ? 'jira:gh:work:drag-and-drop:start' : 'jira:gh:plan:drag-and-drop:start';
        const endEvent = mode === 'rapidboard-board' ? 'jira:gh:work:drag-and-drop:stop' : 'jira:gh:plan:drag-and-drop:stop';
        const onDragStart = ()=>{
            (0, $511uv.getLongTasksMetrics)('dnd').start(mode);
        };
        const onDragStop = ()=>{
            (0, $511uv.getLongTasksMetrics)('dnd').stop((0, $6RZSH.softwareGenericLongTasksReporter)('dnd'));
        };
        window.addEventListener(startEvent, onDragStart);
        window.addEventListener(endEvent, onDragStop);
        return ()=>{
            window.removeEventListener(startEvent, onDragStart);
            window.removeEventListener(endEvent, onDragStop);
            (0, $511uv.getLongTasksMetrics)('dnd').stop((0, $6RZSH.softwareGenericLongTasksReporter)('dnd'));
        };
    }, [
        mode
    ]);
};

});
parcelRegister("511uv", function(module, exports) {

$parcel$export(module.exports, "getLongTasksMetrics", () => $6e4a680496b7cbbf$export$b092a8653a66aa5e);

var $jqvCZ = parcelRequire("jqvCZ");

var $6iz4v = parcelRequire("6iz4v");

var $hgcvd = parcelRequire("hgcvd");

var $7tZw9 = parcelRequire("7tZw9");
let $6e4a680496b7cbbf$var$observer = null;
const $6e4a680496b7cbbf$var$stopObserver = ()=>{
    if ($6e4a680496b7cbbf$var$observer) {
        $6e4a680496b7cbbf$var$observer.disconnect();
        $6e4a680496b7cbbf$var$observer = null;
    }
};
const $6e4a680496b7cbbf$export$b092a8653a66aa5e = (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))((type)=>{
    const clearData = {
        type: type
    };
    let isStarted = false;
    let observationData = {
        ...clearData
    };
    const isDnd = /dnd$/.test(type.toLowerCase());
    return {
        start: (appName, startPerformanceMark, // eslint-disable-next-line @typescript-eslint/no-explicit-any
        extra = {})=>{
            if (window.PerformanceObserver && !isStarted) try {
                const startTimestamp = (0, $hgcvd.default).now();
                observationData = {
                    type: observationData.type,
                    startTimestamp: startTimestamp,
                    dragStartEndTimestamp: startTimestamp,
                    eventStartPerformanceMark: startPerformanceMark,
                    events: [],
                    appName: appName,
                    extra: extra
                };
                isStarted = true;
                $6e4a680496b7cbbf$var$stopObserver();
                $6e4a680496b7cbbf$var$observer = new window.PerformanceObserver((list)=>{
                    list.getEntries().forEach((entry)=>{
                        if (entry.entryType === 'longtask') {
                            if (!(0, $7tZw9.isExpandedObservationData)(observationData) || observationData.events.find((item)=>item.timestamp === entry.startTime && item.duration === entry.duration)) return;
                            observationData.events.push({
                                timestamp: entry.startTime,
                                duration: entry.duration
                            });
                        } else if (entry.entryType === 'event' && entry.name === 'dragstart') /**
								 * Use the observed event to compute the "end" timestamp of the dragstart event,
								 * which will be used for splitting the long tasks for dragstart and dragmove.
								 */ observationData.dragStartEndTimestamp = entry.startTime + entry.duration;
                    });
                });
                $6e4a680496b7cbbf$var$observer.observe({
                    type: 'longtask'
                });
                if (isDnd) /**
						 * Observe events with >48ms duration.
						 * https://developer.mozilla.org/en-US/docs/Web/API/PerformanceObserver/observe
						 */ // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                $6e4a680496b7cbbf$var$observer.observe({
                    type: 'event',
                    durationThreshold: 48
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, no-empty
            } catch (e) {}
        },
        stop: (callback, // eslint-disable-next-line @typescript-eslint/no-explicit-any
        extra = {})=>{
            if ((0, $hgcvd.default).now && isStarted) {
                const stopTimestamp = (0, $hgcvd.default).now();
                setTimeout(()=>{
                    $6e4a680496b7cbbf$var$stopObserver();
                    callback({
                        ...observationData
                    }, extra, stopTimestamp);
                    observationData = {
                        ...clearData
                    };
                    isStarted = false;
                });
            }
        },
        stopIfNoMark: (performanceMark)=>{
            if ($6e4a680496b7cbbf$var$observer && performanceMark) {
                const perfMark = (0, $6iz4v.getMark)(performanceMark);
                if (!perfMark) {
                    $6e4a680496b7cbbf$var$stopObserver();
                    observationData = {
                        ...clearData
                    };
                    isStarted = false;
                }
            }
        }
    };
});

});
parcelRegister("7tZw9", function(module, exports) {

$parcel$export(module.exports, "isExpandedObservationData", () => $e45a8242e5c0159d$export$3d38a87309e205a4);
const $e45a8242e5c0159d$export$3d38a87309e205a4 = (observationData)=>observationData !== undefined && 'events' in observationData && observationData.events !== undefined;

});


parcelRegister("6RZSH", function(module, exports) {

$parcel$export(module.exports, "softwareGenericLongTasksReporter", () => $1de416ce1ae9b97d$export$b78c92c0ba709033);

var $x71UL = parcelRequire("x71UL");

var $fPUXl = parcelRequire("fPUXl");

var $7tZw9 = parcelRequire("7tZw9");

var $eI5EY = parcelRequire("eI5EY");


var $3FyZ4 = parcelRequire("3FyZ4");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $1de416ce1ae9b97d$var$aggregatedDataTimeout = {};
const $1de416ce1ae9b97d$export$b78c92c0ba709033 = (observationType, observationEndTime)=>(observationData)=>{
        if ((0, $eI5EY.fg)('jsw_refactor_long-tasks_monitoring')) {
            if (!(0, $7tZw9.isExpandedObservationData)(observationData) || !('appName' in observationData)) return;
            const { appName: appName, startTimestamp: startTimestamp, events: events } = observationData;
            const startTime = startTimestamp;
            const endTime = observationEndTime ?? performance.now();
            const duration = endTime - startTime;
            if (duration < 100) return;
            const rawLongTasks = events ?? [];
            const longTasks = rawLongTasks.filter((event)=>event.timestamp >= startTime && event.timestamp + event.duration <= endTime).map((event)=>({
                    timestamp: event.timestamp - startTime,
                    duration: event.duration
                }));
            const minimumBlockedDuration = longTasks.reduce((sum, longTask)=>sum + longTask.duration, 0);
            const frameRateTarget = 60;
            const budgetPerFrame = 1000 / frameRateTarget;
            const timeOverBudget = longTasks.map((event)=>event.duration - budgetPerFrame).reduce((sum, time)=>sum + time, 0);
            const summary = {
                qualityIndex: 1 - timeOverBudget / duration,
                hasLongTasks: longTasks.length > 0,
                hasExtraLongTasks: longTasks.filter((l)=>l.duration >= 100).length > 0,
                longTasks: longTasks,
                rawLongTaskCount: rawLongTasks.length,
                longTaskCount: longTasks.length,
                minimumBlockedDuration: minimumBlockedDuration,
                timeOverBudget: timeOverBudget,
                duration: duration,
                startTime: startTime,
                endTime: endTime
            };
            (0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>{
                client.sendEvent({
                    type: (0, $41ea3621645e2acc$export$12346a674644c156),
                    payload: {
                        source: appName,
                        action: 'longTask',
                        actionSubject: 'ui',
                        actionSubjectId: `${appName}-${observationType}`,
                        attributes: {
                            key: appName,
                            ...summary
                        }
                    }
                });
            });
        } else {
            if (!(0, $7tZw9.isExpandedObservationData)(observationData)) return;
            const startTime = observationData.events.map((event)=>event.timestamp);
            const analyticsData = {
                ...(0, $fPUXl.generateLongTaskAnalyticsContinuousActionSummary)(observationType, observationData.events),
                measureTimespan: performance.now() - Math.min(observationData.startTimestamp, ...startTime)
            };
            const { appName: appName } = observationData;
            if ($1de416ce1ae9b97d$var$aggregatedDataTimeout[`software.${appName}.${observationType}`]) $1de416ce1ae9b97d$var$aggregatedDataTimeout[`software.${appName}.${observationType}`].data.push(analyticsData);
            else $1de416ce1ae9b97d$var$aggregatedDataTimeout[`software.${appName}.${observationType}`] = {
                data: [
                    analyticsData
                ],
                extra: observationData.extra,
                timeout: setTimeout(()=>{
                    (0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>{
                        const { data: data, extra: extraData } = $1de416ce1ae9b97d$var$aggregatedDataTimeout[`software.${appName}.${observationType}`];
                        client.sendEvent({
                            type: (0, $41ea3621645e2acc$export$12346a674644c156),
                            payload: {
                                source: appName,
                                action: 'longTask',
                                actionSubject: 'ui',
                                actionSubjectId: `${appName}-${observationType}`,
                                attributes: {
                                    key: appName,
                                    ...(0, $fPUXl.getAverageResultsFromContinuousActions)(observationType, data),
                                    ...extraData,
                                    avgScrollTimespan: (0, (/*@__PURE__*/$parcel$interopDefault($x71UL)))(data, 'measureTimespan')
                                }
                            }
                        });
                        delete $1de416ce1ae9b97d$var$aggregatedDataTimeout[`software.${appName}.${observationType}`];
                    });
                }, 7000)
            };
        }
    };

});
parcelRegister("x71UL", function(module, exports) {

var $7qARj = parcelRequire("7qARj");

var $6P7TZ = parcelRequire("6P7TZ");
/**
 * This method is like `_.mean` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the value to be averaged.
 * The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.7.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {number} Returns the mean.
 * @example
 *
 * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
 *
 * _.meanBy(objects, function(o) { return o.n; });
 * // => 5
 *
 * // The `_.property` iteratee shorthand.
 * _.meanBy(objects, 'n');
 * // => 5
 */ function $0638892b8ae22890$var$meanBy(array, iteratee) {
    return $6P7TZ(array, $7qARj(iteratee, 2));
}
module.exports = $0638892b8ae22890$var$meanBy;

});
parcelRegister("6P7TZ", function(module, exports) {

var $835ZM = parcelRequire("835ZM");
/** Used as references for various `Number` constants. */ var $4f7da2b12e23c1f3$var$NAN = 0 / 0;
/**
 * The base implementation of `_.mean` and `_.meanBy` without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {number} Returns the mean.
 */ function $4f7da2b12e23c1f3$var$baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? $835ZM(array, iteratee) / length : $4f7da2b12e23c1f3$var$NAN;
}
module.exports = $4f7da2b12e23c1f3$var$baseMean;

});
parcelRegister("835ZM", function(module, exports) {
/**
 * The base implementation of `_.sum` and `_.sumBy` without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {number} Returns the sum.
 */ function $5dc3411db180ba2c$var$baseSum(array, iteratee) {
    var result, index = -1, length = array.length;
    while(++index < length){
        var current = iteratee(array[index]);
        if (current !== undefined) result = result === undefined ? current : result + current;
    }
    return result;
}
module.exports = $5dc3411db180ba2c$var$baseSum;

});



parcelRegister("fPUXl", function(module, exports) {

$parcel$export(module.exports, "triggerAnalytics", () => $9e8129e894f8b784$export$2c57de8a70f64057);
$parcel$export(module.exports, "generateLongTaskAnalyticsSummary", () => $9e8129e894f8b784$export$2be2635781d23aab);
$parcel$export(module.exports, "generateLongTaskAnalyticsSummaryWithSlo", () => $9e8129e894f8b784$export$c674a20081e82c6a);
$parcel$export(module.exports, "getAverageResultsFromContinuousActions", () => $9e8129e894f8b784$export$c36fdc326d0c207c);
$parcel$export(module.exports, "generateLongTaskAnalyticsContinuousActionSummary", () => $9e8129e894f8b784$export$7e5f2df95eca342a);

var $x71UL = parcelRequire("x71UL");

var $4YjDD = parcelRequire("4YjDD");

var $9HwDQ = parcelRequire("9HwDQ");
const $9e8129e894f8b784$export$2c57de8a70f64057 = (_appName)=>(_eventNameSuffix, _eventData)=>Promise.resolve(undefined);
const $9e8129e894f8b784$export$2be2635781d23aab = (prefix, longTasks)=>{
    const durations = longTasks.map((task)=>task.duration);
    return {
        [`${prefix}LongTaskCount`]: longTasks.length,
        [`${prefix}LongTaskAvg`]: longTasks.length > 0 ? durations.reduce((sumAcc, duration)=>sumAcc + duration, 0) / longTasks.length : 0,
        [`${prefix}LongTaskMax`]: longTasks.length > 0 ? Math.max(...durations) : 0
    };
};
const $9e8129e894f8b784$export$c674a20081e82c6a = (prefix, longTasks, sloSettings)=>{
    const summary = $9e8129e894f8b784$export$2be2635781d23aab(prefix, longTasks);
    if (!sloSettings) return summary;
    const framerate = summary[`${prefix}LongTaskCount`] === 0 ? 20 : 1000 / summary[`${prefix}LongTaskAvg`];
    const blocktime = summary[`${prefix}LongTaskCount`] === 0 ? 0 : summary[`${prefix}LongTaskCount`] * summary[`${prefix}LongTaskAvg`];
    const isSuccess = framerate >= sloSettings.framerateThreshold && blocktime < sloSettings.blocktimeThreshold;
    return {
        [`${prefix}LongTaskSloIsSuccess`]: isSuccess,
        ...summary
    };
};
const $9e8129e894f8b784$export$c36fdc326d0c207c = (prefix, data)=>({
        [`${prefix}ClusterCount`]: (0, (/*@__PURE__*/$parcel$interopDefault($9HwDQ)))(data, `${prefix}ClusterCount`) || 0,
        [`${prefix}ClusterCountAvg`]: (0, (/*@__PURE__*/$parcel$interopDefault($x71UL)))(data, `${prefix}ClusterCount`) || 0,
        [`${prefix}ClusterAvg`]: (0, (/*@__PURE__*/$parcel$interopDefault($x71UL)))(data, `${prefix}ClusterAvg`) || 0,
        [`${prefix}ClusterDistanceAvg`]: (0, (/*@__PURE__*/$parcel$interopDefault($x71UL)))(data, `${prefix}ClusterDistanceAvg`) || 0,
        [`${prefix}ClusterAvgLongTaskCount`]: (0, (/*@__PURE__*/$parcel$interopDefault($x71UL)))(data, `${prefix}ClusterAvgLongTaskCount`) || 0,
        [`${prefix}ClusterAvgLongTaskAvg`]: data.length > 0 ? (0, (/*@__PURE__*/$parcel$interopDefault($4YjDD)))(data.map((entry)=>entry[`${prefix}ClusterAvgLongTaskCount`] * entry[`${prefix}ClusterAvgLongTaskAvg`])) / (0, (/*@__PURE__*/$parcel$interopDefault($9HwDQ)))(data, `${prefix}ClusterAvgLongTaskCount`) : 0,
        [`${prefix}Count`]: data.length
    });
const $9e8129e894f8b784$export$7e5f2df95eca342a = (prefix, longTasks)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const clusters = longTasks.reduce((foundClusters, task)=>{
        if (foundClusters.length === 0) foundClusters.push({
            tasks: [],
            start: 0,
            stop: 0
        });
        const prevCluster = foundClusters[foundClusters.length - 1];
        const taskEnd = task.timestamp + task.duration;
        if (prevCluster.tasks.length === 0) {
            prevCluster.tasks.push(task);
            prevCluster.start = task.timestamp;
            prevCluster.stop = taskEnd;
        } else if (task.timestamp - prevCluster.stop < 100) {
            prevCluster.tasks.push(task);
            prevCluster.stop = taskEnd;
        } else foundClusters.push({
            tasks: [
                task
            ],
            start: task.timestamp,
            stop: taskEnd
        });
        return foundClusters;
    }, []);
    const clusterDurations = clusters.map((cluster)=>cluster.stop - cluster.start);
    const tasksDurations = longTasks.map((task)=>task.duration);
    const gapsBetweenClusters = clusters.length > 1 ? clusters // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .reduce((gaps, cluster, i)=>{
        if (gaps.length === 0) {
            gaps.push({
                start: cluster.stop,
                stop: null
            });
            return gaps;
        }
        // eslint-disable-next-line no-param-reassign
        gaps[gaps.length - 1].stop = cluster.start;
        if (i !== clusters.length - 1) gaps.push({
            start: cluster.stop,
            stop: null
        });
        return gaps;
    }, []).map((gap)=>gap.stop - gap.start) : [];
    return {
        [`${prefix}ClusterCount`]: clusters.length,
        [`${prefix}ClusterAvg`]: clusters.length > 0 ? clusterDurations.reduce((sumAcc, duration)=>sumAcc + duration, 0) / clusters.length : 0,
        [`${prefix}ClusterDistanceAvg`]: gapsBetweenClusters.length > 0 ? gapsBetweenClusters.reduce((sumAcc, duration)=>sumAcc + duration, 0) / gapsBetweenClusters.length : 0,
        [`${prefix}ClusterAvgLongTaskCount`]: clusters.length > 0 ? clusters.map((cluster)=>cluster.tasks.length).reduce((sumAcc, count)=>sumAcc + count, 0) / clusters.length : 0,
        [`${prefix}ClusterAvgLongTaskAvg`]: longTasks.length > 0 ? tasksDurations.reduce((sumAcc, duration)=>sumAcc + duration, 0) / longTasks.length : 0
    };
};

});
parcelRegister("4YjDD", function(module, exports) {

var $835ZM = parcelRequire("835ZM");

var $3QMTK = parcelRequire("3QMTK");
/**
 * Computes the sum of the values in `array`.
 *
 * @static
 * @memberOf _
 * @since 3.4.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {number} Returns the sum.
 * @example
 *
 * _.sum([4, 2, 8, 6]);
 * // => 20
 */ function $39ebffc448745d7b$var$sum(array) {
    return array && array.length ? $835ZM(array, $3QMTK) : 0;
}
module.exports = $39ebffc448745d7b$var$sum;

});

parcelRegister("9HwDQ", function(module, exports) {

var $7qARj = parcelRequire("7qARj");

var $835ZM = parcelRequire("835ZM");
/**
 * This method is like `_.sum` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the value to be summed.
 * The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {number} Returns the sum.
 * @example
 *
 * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
 *
 * _.sumBy(objects, function(o) { return o.n; });
 * // => 20
 *
 * // The `_.property` iteratee shorthand.
 * _.sumBy(objects, 'n');
 * // => 20
 */ function $7101732f00f14013$var$sumBy(array, iteratee) {
    return array && array.length ? $835ZM(array, $7qARj(iteratee, 2)) : 0;
}
module.exports = $7101732f00f14013$var$sumBy;

});




parcelRegister("fO5rB", function(module, exports) {

$parcel$export(module.exports, "SubProductUpdater", () => $0dcc4693f2e4993e$export$eb40d3df56aa5c53);

var $eUqFw = parcelRequire("eUqFw");

var $3viaK = parcelRequire("3viaK");

var $cOnuN = parcelRequire("cOnuN");

var $6QL9v = parcelRequire("6QL9v");

var $kxBN8 = parcelRequire("kxBN8");

var $2SV7r = parcelRequire("2SV7r");
const $0dcc4693f2e4993e$export$eb40d3df56aa5c53 = ({ allowMonolithDeferral: allowMonolithDeferral = false, ...props })=>{
    const subProduct = (0, $2SV7r.isSubProductProps)(props) ? props.subProduct : (0, $6QL9v.getSubProductFromProjectType)(props.projectType);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3viaK.default), {
        op: (0, $kxBN8.default),
        args: [
            subProduct,
            allowMonolithDeferral
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cOnuN.default), {
        subProduct: subProduct
    }));
};

});
parcelRegister("cOnuN", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3e22c81c3ebeab6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lgxha = parcelRequire("lgxha");

var $j5W2t = parcelRequire("j5W2t");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b3e22c81c3ebeab6$export$2e2bcd8739ae039 = ({ subProduct: subProduct })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lgxha.default), {
        op: (0, $j5W2t.default),
        args: [
            subProduct
        ]
    });

});
parcelRegister("j5W2t", function(module, exports) {

$parcel$export(module.exports, "default", () => $8613fa53f568085a$export$2e2bcd8739ae039);

var $gUUjF = parcelRequire("gUUjF");

var $lRmyA = parcelRequire("lRmyA");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8613fa53f568085a$export$2e2bcd8739ae039 = (subProduct)=>{
    (0, $lRmyA.performGetRequest)(`/rest/internal/2/mauTag/${subProduct}`).catch((err)=>{
        (0, $gUUjF.default).safeErrorWithoutCustomerData('common.tag-mau.tag-mau-event', 'Error connecting to monolith mau tag endpoint', err);
    });
};

});


parcelRegister("6QL9v", function(module, exports) {

$parcel$export(module.exports, "getSubProductFromProjectType", () => $c2784746c0813b99$export$b1fe420ed15dff7b);

var $dWlsy = parcelRequire("dWlsy");
const $c2784746c0813b99$export$b1fe420ed15dff7b = (projectType)=>{
    // for Analytics only 'product_discovery' is mapped to 'polaris'. In other cases it is mapped to 'software'
    if (projectType === 'product_discovery') return 'polaris';
    return (0, $dWlsy.subProductFromProjectType)(projectType);
};

});

parcelRegister("kxBN8", function(module, exports) {

$parcel$export(module.exports, "default", () => $95a7ec92a66826ce$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $2BvS3 = parcelRequire("2BvS3");
var $ds5Im = parcelRequire("ds5Im");
var $4DtuZ = parcelRequire("4DtuZ");


var $gUUjF = parcelRequire("gUUjF");

var $3FyZ4 = parcelRequire("3FyZ4");
const $95a7ec92a66826ce$var$maybeDelayAndRace = (// @ts-expect-error - TS2304 - Cannot find name 'Deferred'.
maybeWaitPromise, getDefaultPromise, getRacePromise)=>maybeWaitPromise ? Promise.race([
        maybeWaitPromise.then(getDefaultPromise),
        getRacePromise()
    ]) : getDefaultPromise();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$95a7ec92a66826ce$export$2e2bcd8739ae039 = async (subProduct, allowMonolithDeferral)=>{
    (0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>{
        client.setSubProduct(subProduct);
        if (subProduct === 'serviceDesk') client.setUIViewedAttributes({
            solutions: [
                (0, $96da08ab2c7a3243$export$c8b406ad8ee0dab9)
            ]
        });
        else client.removeUIViewedAttribute('solutions');
    });
    // IMPORTANT -
    // Until such time as all pre-TTI WRM loads are removed we find that waitForHeritage() then
    // loadBridgeStrict() is too slow, resulting in `subproduct:unknown` for analytics events.
    // In that same case however, profiling shows us that polling in loadBridgeWeak() somehow
    // resolves the same AMD code faster.
    // This is not well understood, but it does allow us to work around the issue by racing these
    // two techniques.
    // Once there is no pre-TTI WRM loads we the waitForHeritage() then loadBridgeStrict() does seem
    // to be faster such that we can remove the `Promise.race()`.
    /* eslint-disable jira/wrm/no-load-bridge */ $95a7ec92a66826ce$var$maybeDelayAndRace(allowMonolithDeferral ? (0, $4DtuZ.waitForHeritage)() : null, ()=>(0, $2BvS3.loadBridgeStrict)({
            name: 'jira/analytics/sub-product-resolver',
            wrmKeys: [
                'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
            ]
        }), ()=>(0, $ds5Im.loadBridgeWeak)({
            name: 'jira/analytics/sub-product-resolver'
        })).then((subProductResolver)=>{
        subProductResolver.setSubProduct(subProduct);
    }).catch((e)=>(0, $gUUjF.default).safeErrorWithoutCustomerData('common.analytics-sub-product.sub-product-updater', 'Error connecting to monolith sub product resolver', e));
/* eslint-enable jira/wrm/no-load-bridge */ };

});
const $96da08ab2c7a3243$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';


parcelRegister("2SV7r", function(module, exports) {

$parcel$export(module.exports, "isSubProductProps", () => $5e5ef73a1d4e492a$export$c3063d6d7a8c075f);
const $5e5ef73a1d4e492a$export$c3063d6d7a8c075f = (props)=>'subProduct' in props && typeof props.subProduct === 'string';
const $5e5ef73a1d4e492a$export$81da4a7e1ba1dcee = (props)=>'projectType' in props && typeof props.projectType === 'string';

});


parcelRegister("bhy8H", function(module, exports) {

$parcel$export(module.exports, "useIsReportsPage", () => $bd184472910bdcb5$export$7f768b3cf3a7f9a4);

var $exb0h = parcelRequire("exb0h");

var $10fdS = parcelRequire("10fdS");
const $bd184472910bdcb5$export$391661b031b686a4 = (name, callback)=>{
    window.addEventListener(name, callback);
    return ()=>window.removeEventListener(name, callback);
};
const $bd184472910bdcb5$export$7f768b3cf3a7f9a4 = ()=>{
    const route = (0, $10fdS.useCurrentRoute)();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $exb0h.ROUTE_NAMES_RAPIDBOARD_REPORT) === route.name;
};

});



// error types
const $8b8bfa076f313cc4$export$6c8cb487d6ffc522 = 'QueryError';
const $8b8bfa076f313cc4$export$b171488d52070cb3 = 'JiraIssueFieldUnsupportedErrorExtension';
const $8b8bfa076f313cc4$export$14b50ab9fbf2d370 = 'JiraIssueFieldValueValidationErrorExtension';
const $8b8bfa076f313cc4$export$3d1cda9bd50505e8 = 'SERVICE_REQUEST';
const $8b8bfa076f313cc4$export$48c144830383423 = 'INCIDENT_MANAGEMENT';
const $8b8bfa076f313cc4$export$1ea6ead7bcee4494 = 'PROBLEM_MANAGEMENT';
const $8b8bfa076f313cc4$export$b92ccb6dc3cdb548 = 'CHANGE_MANAGEMENT';
const $8b8bfa076f313cc4$export$a4a741b969f6509c = 'POST_INCIDENT_REVIEW';
const $8b8bfa076f313cc4$export$81e62964cc725098 = 'DEVELOPER_ESCALATION';
const $8b8bfa076f313cc4$export$92ab80c1dc9baf44 = 'REQUEST_TYPE';
const $8b8bfa076f313cc4$export$ebb48b08205007c5 = 'ISSUE_TYPE';
const $8b8bfa076f313cc4$export$c835df30ebbd529d = 'UNASSIGNED_REQUEST_TYPE';


//# sourceMappingURL=async-rapid-board.c01d5aab.js.map
